//import library
import React, {Component} from 'react';
import {
  View,
  Text,
  Image,
  Dimensions,
  ActivityIndicator,
  TouchableOpacity,
  Platform,
  Vibration
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {appendLog} from '../../utils/scanLogQueue';
import * as RootNavigation from '../root_navigation';
// import { Audio } from 'expo-av';
import {connect} from 'react-redux';
// import Swiper from 'react-native-swiper/src';
import NetInfo from '@react-native-community/netinfo';
import axios from 'axios';
import {createOrUpdateOrder} from '../../DexieDbUtils';
import {extractGtin14FromBarcode} from '../../helpers/gs1Barcode';
import { isTTSInProgress } from '../../helpers/textToSpeech';

//import sound from component
import completeSound from '../../../assets/sounds/_order_complete.mp3';
import scanSuccessSound from '../../../assets/sounds/Scann Success_coin_a.mp3';
import scanFailSound from '../../../assets/sounds/scan_fail_shorter.mp3';
import notReady from '../../../assets/sounds/not_ready.mp3';
import setAsideTone from '../../../assets/sounds/beep-03.mp3';
import saveLogReducer from '../../reducers/saveLogReducer';
//import image from assets
import closeButton from '../../../assets/closeicon.png';

//import apis
import { SearchScanpackOrder, FullOrderScan } from '../../actions/scanpackAction';
import { SEARCH_SCANPACK_ORDER_FAIL } from '../../constants';
import {
  GetOrderList,
  SearchOrder,
  UpdateOrderStatus,
  AddOrderItems,
  Getshipment,
  AddBox,
  LoaderShow,
  fetchLabelData,
  PrintSlip,
  emailCustomer
} from '../../actions/orderActions';
import {
  GetProductDetail,
  ClearSearchProduct,
  updateProductList,
  updateProductAlias,
  UpdateProductInfo
} from '../../actions/productAction';
import {GetBothSettings, GetBoxChampSortPreference, SaveBoxChampSortPreference} from '../../actions/userAction';
import {GetOrderDetail, CalculateBoxChampBoxes} from '../../actions/orderActions';
import {SetItem, GetItem} from '../../actions/updateAsyncAction';
import {
  SubmitLog,
  MultiBoxSaveLog,
  fetchUser
} from '../../actions/saveLogAction';
import {CheckIsListMode, ShowNotification} from '../../actions/menuActions';
import {
  ShuffleTheItem,
  InstructionCheck,
  GetPackingInstructionConf,
  QtyCheck,
  RestartLog,
  CheckItemExists,
  SerialRecordLog,
  HandleKitUpdateData,
  handleByPassLog,
  submitTrackingLog,
  AddNoteLog,
  scanAllItemLog,
  typeScanLog,
  HandleUpdateScannedQty,
  setAllScanCount,
  serialLogUpdate,
  updateTheItem,
  getSerialScanAccess,
  submitTypeScan,
  scanAllItem,
  checkTypeCount,
  skipBarcodeFunction,
  handleNotFulfilledBarcode,
  restoreNotFulfilledItemsToUnscanned,
  addNotFulfilledFlagToLog,
  getFirstItemProductId,
  processBarCode,
  processClickAndPassScan,
  handleScanning,
  handleScanningForUnscan,
  scanForNoBarocode,
  removeStringFromBarcode,
  barcodeEntryMatches
} from './scanBarcodeFunctions';
import {matchScannedBox} from './boxChampVerify';
import BoxChampRecalculatingNotice, {shouldShowRecalculatingNotice} from './BoxChampRecalculatingNotice';
import BoxChampPlanErrorNotice from './BoxChampPlanErrorNotice';
import BoxChampOversizeWarning from './BoxChampOversizeWarning';
import BoxChampDimsForm, {getItemsNeedingDims} from './BoxChampDimsForm';
import BoxChampHandoffCard from './BoxChampHandoffCard';
import BoxChampSetAsideNotice, {
  isSetAsideRejection,
  setAsideMessage
} from './BoxChampSetAsideNotice';
import {createGuidedViewMemo, createLiveTreeMemo} from './boxChampGuided';
import {
  handoffState,
  classifyPausedInput,
  HANDOFF_IDLE,
  HANDOFF_PAUSED,
  HANDOFF_AWAITING_FIRST_VERIFY
} from './boxChampHandoff';
import {
  modalSuppressesHandoffCard,
  focusBlockingModalOpen
} from './boxChampModalFlags';
import {handoffEvent, firstVerifyEvent, newGestureUid} from './boxChampEvents';
import BoxChampEscalatedNotice from './BoxChampEscalatedNotice';
import BoxChampOptionsSheet from './BoxChampOptionsSheet';
import {boxOptions, planOpEvent} from './boxChampOptions';
import {
  substitutionStep,
  SUBSTITUTION_PENDING
} from './boxChampSubstitution';

//import components to view
import styles from '../../style/scanpack';
import UnscannedItems from './unscanned_items';
import ScannedItems from './scanned_items';
import NextItems from './next_items';
import Notes from './internal_notes';
import Alert from './alert';
import AddBarcode from './addBarcode';
import PopUpModel from './pop_up_model';
import ShipmentRecord from './shipmentsRecord';
import TypeScanAlert from './type_scan_alert';
import ResponseView from './response_view';
import LogView from './log';
import SerialRecord from './serial_record';
import SerialRecordingNoteModal from '../../commons/serialRecordingNoteModal';
import ClickScanConfirmationPopUp from './click_scan_confirmation_pop_up';
import ProductConfirmationCheck from './productConfirmationCheck';
import ConfirmTrackingNumber from './confirmTrackingNumber';
import OrderConfirmationPopUp from './orderConfirmationPopUp';
import globalStyles from '../../style/global';
import SwipeGesture from '../../helpers/swipe-gesture';
import Hotkeys from 'react-hot-keys';
import ProductAlias from '../Alias/productAlias';
import {LinearGradient} from 'expo-linear-gradient';
import {fontFamily} from '../../helpers/fontFamily';
import {
  ScanPackItemtrackingMsg,
  ScanpackQtyExceedMsgPart1,
  ScanPackRequiredSerialMsg,
  ScanpackQtyExceedMsgPart2,
  ScanPackSuccessMsg,
  ScanPackTypeCountMsg,
  ScanPackMultiPackMsg,
  ScanPackPassFunMsg
} from '../notification';
import i18n from 'i18n-js';
import AlertBoxTrackingNumber from './alertBoxTrackingNumber';
import AlertBoxShippingLabel from './alertBoxShippingLable';
import InterNetChecks from '../internateConnectionCheck';
import InerternetConnectionAlert from '../internetConnectionAlert';
// import {debug} from 'react-native-reanimated';
import Prompt from '../../commons/prompt';
import CommonPrompt from '../../commons/modal/commonPrompt';
import TTSEnablementPrompt from '../../commons/modal/ttsEnablementPrompt';
import MultiBoxAlert from './multiBoxAlert';
import moment from 'moment';
import {fetchData, handlePrinterSelection, handleQzError} from '../../../qzservice';
import PrinterShow from '../directPrinting/printerShow';
import {trackingSubmit} from './tracking_submit';
import {getLiveStatsData} from '../../helpers/scanPackFunctions';
import {preloadCameraIfEnabled} from '../../helpers/preloadCamera';
import CustomScrollBar from '../../commons/customScrollBar';
import { getScanBarCode, saveOrders, saveProducts, saveSettings } from './apiStorage';
import { updateBarcodeName } from './db';
import AssignmentToast from '../scanToCart/CartAssignmentDetailToast';
import scanpackReducer from '../../reducers/scanpackReducer';
import { OFFLINE_DATA } from '../../constants';
import { updateOfflineOrder } from '../../actions/scanpackAction';
import { handleItemOutOfStock } from '../../actions/scanToCartActions';
import { storeLastPrintJob } from '../reprint/reprintUtils';
// import Sound from 'react-native-sound';
let searchOrderCheck = false;
let updateProductInfoSuccess = false;
let ScanPackSettingsAccess = false;
let GeneralSettingAccess = false;
let orderSaveSuccess = false;
let updateLogSuccess = true;
let callOrderSuccess = true;
let formOrderDetailPage = true;
let updateSerialLog = {};
let enableSerial = false;
let ordersListSuccess = true;
let blockScan = false;
let confirmProductConfirmation = false;
let updateFromOrderDetailPage = true;
let searchOrderSuccess = false;
let updateFromProductSuccess = false;
let updateProductApi = false;
let by_passed = false;
let sku = '';
let kitItem = false;
let updateAliasSuccess = false;
let isModalCleared = false;
let clickBarcodeVal = '';
let typeValue = '';
let allowed = false;
let addItemFlag = false;
let addLog = true;
let isClickScan = false;
let barCodeInput = '';
let typeInCountModal = false;
let serviceIssueModal = true;
let barcode_copy = '';
let isPrintOrderBarcode = false;
//For multibox
let multiBoxFlag = false;
// let scanSuccessAction = false
// let scanFailAction = false
// let orderCompleteAction = false
// let responseShowAction = false
// const sound = new Audio.Sound();
// successSound.autoplay = true
// const successSound = new Audio("data:audio/mpeg;base64,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")
var successSound = new Audio(scanSuccessSound); // correct order when order is done...
var failSound = new Audio(scanFailSound); // Error scan
var notReadySound = new Audio(notReady); //
var setAsideSound = new Audio(setAsideTone);
var completeSoun = new Audio(completeSound); // order done
let Scanpack_qty_exceed_msg_part1 = i18n.t(
  'scanpackItem.Scanpack_qty_exceed_msg_part1'
);
let Scanpack_qty_exceed_msg_part2 = i18n.t(
  'scanpackItem.Scanpack_qty_exceed_msg_part2'
);
let product_confirm = '';
let trackState = '';
let isBulkScan = '';
let isOrderComplete = false;
let currentItemForSerialScan;
let isSerialScan = false;
let counter = 0;

class ScanPackItem extends Component {
  constructor(props) {
    // debugger
    // debugger
    super(props);

    this.state = {
      isConnected:null,
      shipmentOrder: {
        input: '',
        state: 'scanpack.rfo',
        id: null,
        box_id: null,
        store_order_id: null,
        app: 'app'
      },
      data: {
        input: '',
        state: 'scanpack.rfo',
        id: null,
        box_id: null,
        store_order_id: null
      },
      orderList: {
        filter: 'awaiting',
        order: 'DESC',
        limit: '1',
        offset: '0',
        app: 'app',
        count: 0
      },
      orderDetail: {
        filter: 'awaiting',
        order: 'DESC',
        limit: '1',
        offset: '0',
        type: 'app'
      },
      isClicked: false,
      type: '',
      log: [],
      localLogs: [],
      boxChampVerifiedBoxIds: [],
      boxChampJustConfirmedBoxId: null,
      boxChampSealConfirmedBoxIds: [],
      boxChampHandoffMessage: '',
      boxChampHandoffDismissedKey: null,
      boxChampSetAsideMessage: '',
      boxChampSetAsideConfirmation: false,
      boxChampCatalog: [],
      boxChampOptionsBoxId: null,
      boxChampPendingSubstitution: null,
      boxChampAddBoxError: '',
      boxChampCatalogError: '',
      boxChampPlanError: '',
      firstScreen: true,
      secondScreen: false,
      thirdScreen: false,
      logScreen: false,
      bar_code: '',
      alert: false,
      functionalityPerformed: false,
      addItemToOrder: false,
      addItemToOrderInput: '',
      addNextItemLoading: false,
      notes_fromPacker: '',
      typeScanAlert: false,
      typeScanCount: '',
      kitConfirmation: false,
      kitInstructions: '',
      notes_toPacker_enable: true,
      showshipments: true,
      errorMessage: i18n.t('scanPack.checkInternet'),
      errorMessageShow: false,
      matchOrderShow: true,
      typeScanState: '',
      message: '',
      unscannedItemShow: false,
      nextItemShow: true,
      scannedItemShow: false,
      typeScanDeductCountState: '',
      issueFlag: false,
      noteFlag: false,
      trackingOrderInput: '',
      trackingNumberView: false,
      postScanningFieldLabel: '',
      postScanningOrderNumber: '',
      postScanningMessageDetail: '',
      alertBoxTracking: false,
      alertBoxShipping: false,
      alertTextTracking: '',
      alertTextShipping: '',
      timeSecond: false,
      postScan: false,
      serialRecordPopUpShow: false,
      serialRecordText: '',
      serialRecordInput: '',
      serialRecordTwo: '',
      clickScanConfirmInput: '',
      serialRecordOne: '',
      notes_toPackerFlag: true,
      notes_internalFlag: true,
      customer_commentsFlag: true,
      tags_toPackerFlag: true,
      scanSuccessAction: false,
      scanFailAction: false,
      orderCompleteAction: false,
      responseShowAction: false,
      errorMessageClickScanConfirmation: false,
      loadOrderSpinner: false,
      loader: false,
      unscannedItemPerPage: 1,
      serviceIssuePrompt: false,
      serviceIssueInput: '',
      orderSearchLoading: false,
      scannedItemPerPage: 1,
      productConfirmationCheck: false,
      productConfirmationCheckInput: '',
      errorMessageProductConfirmationCheck: false,
      blockScan: false,
      orderConfirmPopUp: false,
      OrderConfirmationCheckInput: '',
      errorMessageOrderConfirmationCheck: false,
      popUpModelShow: false,
      messageTypeSuccess: false,
      reRenderFocus: false,
      clickScanConfirmation: false,
      focusBarcode: false,
      scannedList: true,
      unscannedList: false,
      logList: false,
      addBarcodeWindow: false,
      alias: false,
      Product: [],
      windowWidth: Dimensions.get('window').width,
      userData: {},
      packing_cam_options: false,
      shipping_easy: true,
      order_cup: true,
      shopify_shipping: true,
      prodConfCheck: true,
      forSerialRecord: '',
      popInternet: true,
      verifylabel: false,
      orderConfirmationPer: false,
      orderId: '',
      newState: false,
      // activeBoxIndex: 0,
      openRestartPrompt: false,
      isPageRedirectedAfterScanningComplete: false,
      activeBoxIndex: 0,
      verifiedBoxIds: [],
      boxid: null,
      boxChampRecalculating: false,
      boxChampDimsModalOpen: false,
      multiBoxAlertState: false,
      emptyBoxPrint: false,
      focusTarget: null,
      modalVisible: false,
      printingLabel: false,
      printers: [],
      selectedPrinter: '',
      isBarcodeEnter: false,
      directPrintLabelState : false,
      isCameraReady: false,
      notFullFilledItems: [],
      isFetchLabelData : false
    };
    this.cameraRef = React.createRef();
    this.barcode = React.createRef();
    this.serialRecord = React.createRef();
    this.multipleTime = this.multipleTime.bind(this);
    this.responseAction = this.responseAction?.bind(this);
    this.redirectFun = this.redirectFun.bind(this);
    this.InputField = React.createRef();
    this.myInput = React.createRef();
    this.offlineMessageRef = React.createRef();
  }
  // After refresh log
  // prevlog= async ()=>{
  //   if(this.props.route.params.data.order.scanned_items.length>0){
  //     let logging = await AsyncStorage.getItem("Logging")
  //     let logg = JSON.parse(logging)
  //     let arr = []
  //     logg.reverse().filter((l)=>{
  //       if(l.increment_id == this.props.route.params.data.order.increment_id){
  //         console.log("====",l)
  //         arr.push(l)
  //         this.setState({
  //           localLogs: [...this.state.localLogs, l]
  //         })
  //       }
  //     })
  //     console.log("arr00",arr)
  //       console.log("****",)
  //     }
  // }
  getdata = () => {
    // console.log("get data")
    this.setState({orderConfirmPopUp: false});
  };
  async componentDidMount() {
    this._isMounted = true;
    this.fetchSounds();
    if (this.boxChampVerificationOn() || this.props?.bothSettings?.data?.data?.general_setting?.is_box_champ) {
      this.loadBoxChampCatalog();
    }
    let SSLabelDataNew = this.props?.callOrder?.data?.order?.[0]
    let sslabelID = SSLabelDataNew?.id

    this.unsubscribe = NetInfo.addEventListener((state) => {
      console.log('stammering eeeeee', state.isConnected);
      this.setState({ isConnected: state.isConnected });
    });
    if(SSLabelDataNew?.print_ss_label ){
      this.setState({isFetchLabelData : false})
    this.props.fetchLabelData({ id: sslabelID, app: true }).then((res)=>{
      if(res.status === 200){
        this.setState({isFetchLabelData : true})
      }
    })
  }
    this.props.GetOrderDetail(this.props?.route?.params?.data?.order).then(async(res)=> {
      await saveOrders(res)
    })
    this.setState({userData: this.props.route.params.userdata});
    window.addEventListener('resize', this.updateDimensions);
    this.setState({loader: true});
    this.setState({orderId: this.props?.ordersList?.orders[0]?.id});
    this.getUserInfo();
    serviceIssueModal = true;
    this.apiCall();
    // this.prevlog()

    successSound.load();
    failSound.load();
    notReadySound.load();
    completeSoun.load();
    // if (Platform.OS === "ios") {
    //   await Audio.setAudioModeAsync({
    //     playsInSilentModeIOS: true,
    //   });
    // }
    this.beforePackingCam();
    const sI = setInterval(() => {
      this.test();
    }, 2000);
    //Logic for OrderConfirmationPopup shows one time only!
    this.setShowConfirmationPopUp();

    // Only preload camera if packing cam is enabled in both settings and locally
    const scanpackSetting = this.props?.bothSettings?.data?.data?.scanpack_setting;
    const storeDisablePackingCam = this.props?.Order?.storeinfo?.disable_packing_cam;
    const adminToolsPackingCam = this.props?.bothSettings?.data?.data?.packing_cam;
    const psv2Modules = this.props?.bothSettings?.data?.data?.post_scanning_config?.modules_config;
    await preloadCameraIfEnabled(this.cameraRef, this.onCameraReady, scanpackSetting, storeDisablePackingCam, adminToolsPackingCam, psv2Modules);
  }

  fetchSounds = async () => {
  
    const correctScanSound = await AsyncStorage.getItem('correctScanType');
    const errorScanSound = await AsyncStorage.getItem('errorScanType');
    const orderScanSound = await AsyncStorage.getItem('orderScanType');
    console.log('correctScanSound',correctScanSound)
    console.log('errorScanSound',errorScanSound)
    console.log('orderScanSound',orderScanSound)
    completeSoun = new Audio(orderScanSound); // correct order when order is done...
    successSound = new Audio(correctScanSound); // order done...
    failSound = new Audio(errorScanSound); // Error scan...
    // notReadySound = new Audio(notReady); //
  };

  onCameraReady = () => {
    this.setState({isCameraReady: true});
  };

  setShowConfirmationPopUp = () => {
    let notesConfirmation =
      this.props?.ordersList?.orders[0]?.scan_hash?.data?.order
        ?.note_confirmation;
    if (
      this.props?.ordersList?.general_settings?.conf_req_on_notes_to_packer ===
      'always'
    ) {
      this.setState({orderConfirmPopUp: true});
    }
    if (
      this.props?.ordersList?.general_settings?.conf_req_on_notes_to_packer ===
      'optional'
    ) {
      if (notesConfirmation) {
        this.setState({orderConfirmPopUp: true});
      }
    }
  };
  beforePackingCam = () => {};
  componentUnmount() {}
  /*RETRIVE THE USER INFO FROM LOCAL*/
  getUserInfo = async () => {
    let info = await AsyncStorage.getItem('userInfo');
    let userInfo = info && JSON.parse(info);
    this.setState({userInfo});
  };
  /*RETRIVE THE USER INFO FROM LOCAL*/

  apiCall = async() => {
    let fetchListData = this.state.shipmentOrder;
    fetchListData.input = this.props.route.params.incrementID;
    let data = this.props?.route?.params?.data;
    const getOfflineData = await getScanBarCode();
    // this.setState({order: data ?? getOfflineData?.data?.data?.order[0]?.scan_hash?.data});
    // this.props.SearchScanpackOrder(fetchListData);
    let orderData = data ?? getOfflineData?.data?.data?.order[0]?.scan_hash?.data;
    const notFullFilledItems = orderData?.order?.not_fulfilled_items || [];
    orderData = restoreNotFulfilledItemsToUnscanned(orderData, notFullFilledItems);

    this.setState({notFullFilledItems: notFullFilledItems, order: orderData});

    this.props.GetBothSettings().then(async(res)=>{
      await saveSettings(res)
    });
    ordersListSuccess = false;

    const id = getFirstItemProductId(
      data?.order?.unscanned_items,
      notFullFilledItems
    );
      this.props?.GetProductDetail(id).then(async(res) => await saveProducts(res));
  };
  duplicateShipStationOrder = data => {
    // GROOV-4994 (QA pass 2, flagged not fixed): this swaps in a whole new order
    // without refreshing this.state.notFullFilledItems (still whatever it was for the
    // PREVIOUS order). getBoxChampTree()/getBoxChampView() — which both this file's and
    // scanned_items.js's active-box resolution depend on — fold notFullFilledItems into
    // the tree they build, so a stale value here could theoretically make the two
    // files' "active box" diverge for a duplicated order. Not reproduced or fixed here;
    // flagging for whoever next touches this path. searchOrder() below (the
    // service-issue order-swap) has the identical gap.
    this.setState({order: data});
    let id =
      data?.order?.unscanned_items[0]?.child_items.length > 0
        ? data?.order?.unscanned_items[0]?.child_items[0]?.product_id
        : data?.order?.unscanned_items[0]?.product_id;
    this.props.GetOrderDetail(data?.order);
    this.props.GetBothSettings();
    this.props?.GetProductDetail(id);
  };

  handleBoxChampDimsSaveAll = payloads => {
    const order = this.state.order?.order;
    const incrementId = order?.increment_id;
    const ids = payloads.map(p => p.product_id);
    const requests = payloads.map(p =>
      this.props.UpdateProductInfo(p.product_id, p.data, incrementId)
    );
    return Promise.all(requests).then(() => {
      if (!this._isMounted) return;
      this.setState(prev => {
        const unscanned = prev.order?.order?.unscanned_items;
        if (!unscanned) return null;
        const clear = list =>
          (list || []).map(it => ({
            ...it,
            needs_dims: ids.includes(it.product_id) ? false : it.needs_dims,
            child_items: it.child_items ? clear(it.child_items) : it.child_items,
          }));
        return {
          order: {
            ...prev.order,
            order: {...prev.order.order, unscanned_items: clear(unscanned)},
          },
        };
      });
      if (order?.id) {
        this.calculateBoxChampPlan(order.id);
      }
    });
  };

  // GROOV-4994 (defect 2): shared by the initial recalculation trigger and by the manual
  // retry so a failed plan fetch has exactly one place that decides what the packer sees.
  //
  // GROOV-4994 (defect cleanup #5): guarded with an in-flight flag, mirroring the
  // _boxChampConfirmInFlight pattern confirmBoxChampHandoff uses above — a double-tap on
  // retry (or the initial trigger racing a manual retry) must not fire two concurrent
  // CalculateBoxChampBoxes requests for the same order. Cleared in both the success and
  // failure branches of the callback so a later call for the same order is never wedged.
  calculateBoxChampPlan = orderId => {
    if (this._boxChampPlanInFlight === orderId) return undefined;
    this._boxChampPlanInFlight = orderId;
    this.setState({boxChampRecalculating: true, boxChampPlanError: ''});
    return this.props.CalculateBoxChampBoxes(orderId, (success, data) => {
      if (success) {
        this._boxChampPlanInFlight = null;
        if (!this._isMounted) return;
        this.refreshBoxChampBoxes();
      } else {
        this._boxChampPlanInFlight = null;
        if (!this._isMounted) return;
        this.setState({
          boxChampRecalculating: false,
          boxChampPlanError: data?.error || 'Could not recalculate the box plan.',
        });
      }
    });
  };

  retryBoxChampPlan = () => {
    const orderId = this.state.order?.order?.id;
    if (orderId) return this.calculateBoxChampPlan(orderId);
    return undefined;
  };

  refreshBoxChampBoxes = () => {
    return this.props.GetOrderDetail(this.state.order?.order).then(res => {
      if (this._isMounted && res && Array.isArray(res.boxes) && res.boxes.length > 0) {
        this.setState({boxChampRecalculating: false});
      }
      return res;
    });
  };

  loadBoxChampCatalog = async () => {
    if (this._boxChampCatalogRequested) return;
    this._boxChampCatalogRequested = true;
    try {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');
      const res = await axios({
        method: 'get',
        url: `${url}/box_types/packing_index.json`,
        headers: {Authorization: `Bearer ${access_token}`}
      });
      if (this._isMounted && Array.isArray(res?.data?.box_types)) {
        this._boxChampCatalogFailures = 0;
        this.setState({boxChampCatalog: res.data.box_types, boxChampCatalogError: ''});
      }
    } catch (e) {
      this._boxChampCatalogFailures = (this._boxChampCatalogFailures || 0) + 1;
      if (this._boxChampCatalogFailures < 3) {
        this._boxChampCatalogRequested = false;
      } else if (this._isMounted) {
        // Give up quietly is the bug: mid-pack substitution and the add-box catalog
        // both silently stop working. Say so, without overstating it — the router
        // still falls back to the expected box's own barcode.
        this.setState({
          boxChampCatalogError:
            'Box catalog unavailable — box substitution and the box list may not work. Tap to retry.',
        });
      }
    }
  };

  retryBoxChampCatalog = () => {
    this._boxChampCatalogFailures = 0;
    this._boxChampCatalogRequested = false;
    this.setState({boxChampCatalogError: ''});
    return this.loadBoxChampCatalog();
  };

  getBoxChampTree = () => {
    if (!this._liveTreeMemo) this._liveTreeMemo = createLiveTreeMemo();
    return this._liveTreeMemo(this.state.order?.order, this.state.notFullFilledItems);
  };

  getBoxChampView = () => {
    if (!this._guidedViewMemo) this._guidedViewMemo = createGuidedViewMemo();
    return this._guidedViewMemo(this.getBoxChampTree(), [
      this.props.Order,
      this.state.order?.order
    ]);
  };

  boxChampVerificationOn = () =>
    Boolean(
      this.props?.bothSettings?.data?.data?.scanpack_setting
        ?.box_scan_verification ||
        this.state?.scan_pack_settings?.box_scan_verification
    );

  // DISPLAY-only predicate: "is a pop-up on screen that the hand-off card should keep
  // out of the way of?" Membership lives in boxChampModalFlags.js so this and the
  // setFocus guard below cannot drift apart (they already had).
  //
  // This is NOT an enforcement question. It feeds handoffState's `modalOpen`, which
  // returns idle purely so the card unmounts — anything that must keep ENFORCING while
  // a pop-up is up reads getBoxChampHandoff({ignoreModal: true}) instead.
  boxChampModalOpen = () => modalSuppressesHandoffCard(this.state, this.props);

  boxChampAutoSealedIds = () => {
    const view = this.getBoxChampView();
    if (!view) return [];
    const boxes = view.projection.boxes;
    const orderId = this.props?.Order?.basicinfo?.id;
    if (this._boxChampSealBaselineOrderId !== orderId) {
      this._boxChampSealBaselineOrderId = orderId;
      this._boxChampSealBaseline = boxes
        .filter(entry => entry.sealed)
        .map(entry => entry.box.id);
    }
    const baseline = this._boxChampSealBaseline || [];
    const confirmed = this.state.boxChampSealConfirmedBoxIds || [];
    return boxes
      .filter(
        entry =>
          entry.sealed &&
          !baseline.includes(entry.box.id) &&
          !confirmed.includes(entry.box.id)
      )
      .map(entry => entry.box.id);
  };

  getBoxChampHandoff = ({ignoreModal = false} = {}) =>
    handoffState({
      view: this.getBoxChampView(),
      verificationOn: this.boxChampVerificationOn(),
      verifiedBoxIds: this.state.boxChampVerifiedBoxIds,
      justConfirmedBoxId: this.state.boxChampJustConfirmedBoxId,
      autoSealedBoxIds: this.boxChampAutoSealedIds(),
      sealConfirmedBoxIds: this.state.boxChampSealConfirmedBoxIds,
      modalOpen: ignoreModal ? false : this.boxChampModalOpen()
    });

  boxChampOrderPacked = () => {
    const view = this.getBoxChampView();
    if (!view) return false;
    return view.projection.allComplete && view.unboxedItems.length === 0;
  };

  // Enforcement, not display: this is what withholds the box-Options affordance
  // (openBoxChampOptions is passed as undefined when it is true, and BoxChampZonedList
  // renders no button without it), so editing the box plan mid-hand-off must not become
  // reachable just because a pop-up is masking the hand-off. ignoreModal for the same
  // reason the scan gate uses it. Unchanged when no hand-off is actually pending.
  boxChampPaused = () =>
    this.getBoxChampHandoff({ignoreModal: true}).kind !== HANDOFF_IDLE;

  boxChampHandoffKey = () => {
    const h = this.getBoxChampHandoff();
    if (!h || h.kind === HANDOFF_IDLE) return null;
    return `${h.kind}:${h.sealBox?.id ?? ''}:${h.expectedBox?.id ?? ''}`;
  };

  boxChampHandoffDismissed = () => {
    const key = this.boxChampHandoffKey();
    return key !== null && key === this.state.boxChampHandoffDismissedKey;
  };

  boxChampHandoffOwnsFocus = () => {
    const h = this.getBoxChampHandoff();
    return Boolean(h && h.kind !== HANDOFF_IDLE && h.requiresBoxScan && !this.boxChampHandoffDismissed());
  };

  dismissBoxChampHandoff = () =>
    this.setState({boxChampHandoffDismissedKey: this.boxChampHandoffKey()});

  showBoxChampHandoff = () => this.setState({boxChampHandoffDismissedKey: null});

  scanFromBoxChampHandoff = value =>
    this.setState({bar_code: value}, () => this.scanBarcode());

  getBoxChampActiveBoxId = () => {
    const view = this.getBoxChampView();
    if (!view) return null;
    return view.projection.activeBoxId;
  };

  // GROOV-4994 (QA pass 3): scanned_items.js needs to know which box is genuinely
  // still awaiting the PACKER's hand-off confirmation — not which box the server
  // currently reports as sealed/complete. QA live-proved (order #1675143, real scans)
  // that the server sets Box.completed_at SYNCHRONOUSLY as part of the same API
  // response that triggers the confirmation modal, so by the time this re-renders the
  // box already reads sealed:true — a server-completion check can never catch this
  // window. getBoxChampHandoff()'s sealBox is the actual field this file already
  // trusts to drive the confirm modal itself (boxChampSealConfirmedBoxIds only gains
  // this box's id once confirmBoxChampHandoff runs, i.e. once the packer acts) — hand
  // that exact value down instead of asking scanned_items.js to reimplement an
  // equivalent (and, as proven, unreliable) heuristic on its own. ignoreModal: true
  // for the same reason confirmBoxChampHandoff/boxChampPaused use it: this is a real
  // enforcement-adjacent state question, not a "should some other pop-up hide the
  // card" display question.
  boxChampPendingConfirmationBoxId = () =>
    this.getBoxChampHandoff({ignoreModal: true}).sealBox?.id ?? null;

  boxChampEarlySetAside = (value, type) => {
    const view = this.getBoxChampView();
    const activeId = view?.projection?.activeBoxId;
    if (!value || activeId == null) return false;
    const sps = this.state?.scan_pack_settings || this.props?.bothSettings?.data?.data?.scanpack_setting || {};
    const gs = this.state?.general_settings || this.props?.bothSettings?.data?.data?.general_setting || {};
    let code = String(value).trim();
    if (sps.escape_string_enabled && type !== 'item_present') code = processBarCode(code, sps).barCodeWithoutSpaces;
    if (sps.string_removal_enabled && sps.string_removal) code = removeStringFromBarcode(code, sps.string_removal);
    const caseInsensitive =
      sps.scanning_sequence === 'any_sequence' ||
      (sps.scanning_sequence === 'kit_packing_mode' && gs.master_switch === false);
    const norm = v => (caseInsensitive ? String(v).toLowerCase() : String(v));
    const target = norm(code);
    if (!target) return false;
    const unscanned = this.state.order?.order?.unscanned_items || [];
    const matches = it => (it?.barcodes || []).some(b => b && norm(b.barcode) === target);
    let item = null;
    let kitId = null;
    unscanned.some(it => {
      if (!it || it.order_item_id == null) return false;
      const children = Array.isArray(it.child_items) ? it.child_items : [];
      if (!children.length) {
        if (matches(it)) { item = it; return true; }
        return false;
      }
      const child = children.find(c => c && c.kit_product_id != null && matches(c));
      if (child) { item = it; kitId = child.kit_product_id; return true; }
      return false;
    });
    if (!item) return false;
    const rowsFor = entry =>
      entry.rows.filter(
        r => r.row.order_item_id === item.order_item_id && (kitId == null ? r.row.kit_id == null : r.row.kit_id === kitId)
      );
    const active = view.projection.boxes.find(e => e.box.id === activeId);
    if (!active || rowsFor(active).some(r => r.filled < r.target)) return false;
    const later = view.projection.boxes.find(
      e => e.box.id !== activeId && !e.sealed && rowsFor(e).some(r => r.filled < r.target)
    );
    if (!later) return false;
    const row = rowsFor(later)[0].row;
    const label = this.boxChampLabelFor(view, row);
    const child = kitId == null ? null : (item.child_items || []).find(c => c && c.kit_product_id === kitId);
    const name = (label && (label.name || label.sku)) || child?.name || item.name || item.sku || 'This item';
    this.playSound('setAside');
    clearTimeout(this._boxChampConfirmationTimer);
    this.setState({
      boxChampSetAsideMessage: `Set that aside — ${name} goes in ${later.box.name}`,
      boxChampSetAsideConfirmation: false,
      boxChampHandoffDismissedKey: null
    });
    return true;
  };

  boxChampUnboxedBarcodes = () => {
    const view = this.getBoxChampView();
    if (!view) return [];
    return view.unboxedItems.flatMap(item =>
      (item.barcodes || []).map(b => b && b.barcode).filter(Boolean)
    );
  };

  getBoxChampSetAsideItems = () => {
    const state = this.getBoxChampHandoff();
    const view = this.getBoxChampView();
    if (!view || !state.nextBox) return [];
    const entry = view.projection.boxes.find(e => e.box.id === state.nextBox.id);
    if (!entry) return [];
    return entry.rows
      .filter(r => r.filled < r.target)
      .map(r => {
        const label = this.boxChampLabelFor(view, r.row);
        return {
          key: `${r.row.id}`,
          order_item_id: r.row.order_item_id,
          name: (label && (label.name || label.sku)) || 'Item',
          qty: r.target - r.filled
        };
      });
  };

  openBoxChampOptions = () => {
    const boxId = this.getBoxChampActiveBoxId();
    if (boxId == null) return;
    if (!this.state.boxChampCatalog.length) this.loadBoxChampCatalog();
    this.setState({boxChampOptionsBoxId: boxId, boxChampAddBoxError: ''});
  };

  closeBoxChampOptions = () =>
    this.setState({boxChampOptionsBoxId: null, boxChampAddBoxError: ''});

  getBoxChampOptions = () =>
    boxOptions({
      view: this.getBoxChampView(),
      boxId: this.state.boxChampOptionsBoxId
    });

  sendBoxChampPlanOp = (event, boxTypeId) => {
    const boxId = this.state.boxChampOptionsBoxId ?? this.getBoxChampActiveBoxId();
    if (boxId == null) return;
    this.updateLog(
      planOpEvent(event, {
        order: this.state.order,
        boxId,
        boxTypeId,
        userName: this.state.userInfo?.username || ''
      }),
      event
    );
    this.closeBoxChampOptions();
    this.refreshBoxChampBoxes();
  };

  handleBoxChampSubstitute = boxTypeId =>
    this.sendBoxChampPlanOp('box_substitute', boxTypeId);

  handleBoxChampCombine = () => this.sendBoxChampPlanOp('box_combine', null);

  handleBoxChampSplit = boxTypeId => this.sendBoxChampPlanOp('box_split', boxTypeId);

  handleBoxChampAddBox = async payload => {
    try {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');
      const res = await axios({
        method: 'post',
        url: `${url}/box_types/packing_create.json`,
        headers: {Authorization: `Bearer ${access_token}`},
        data: payload
      });
      if (res?.data?.status && res.data.box_type) {
        if (this._isMounted) {
          this.setState(prev => ({
            boxChampCatalog: [...prev.boxChampCatalog, res.data.box_type],
            boxChampAddBoxError: ''
          }));
        }
        this.handleBoxChampSubstitute(res.data.box_type.id);
      } else if (this._isMounted) {
        this.setState({
          boxChampAddBoxError:
            (res?.data?.errors || []).join(', ') || 'Could not save that box.'
        });
      }
    } catch (e) {
      // GROOV-4994 (defect cleanup #2/#3): same non-array-errors guard as
      // CalculateBoxChampBoxes (orderActions.js) — a non-array truthy `errors` (string,
      // object) must fall back to the default message instead of throwing on .join.
      const errors = e?.response?.data?.errors;
      if (this._isMounted) {
        this.setState({
          boxChampAddBoxError:
            (Array.isArray(errors) && errors.join(', ')) || 'Could not save that box.'
        });
      }
    }
  };

  handleBoxChampBoxScan = value => {
    const view = this.getBoxChampView();
    if (!view) return false;
    const activeId = this.getBoxChampActiveBoxId();
    const entry = view.projection.boxes.find(e => e.box.id === activeId);
    const step = substitutionStep(value, {
      expectedBox: entry ? entry.box : null,
      catalog: this.state.boxChampCatalog,
      pending: this.state.boxChampPendingSubstitution,
      // Threaded through to classifyBoxScan for the tenant barcode-cleanup step that
      // lands on fix/groov-4994-guided-silent-failures — inert here until that merges.
      settings:
        this.props?.bothSettings?.data?.data?.scanpack_setting ||
        this.state?.scan_pack_settings ||
        {}
    });
    if (!step.handled) return false;

    if (step.commitBoxTypeId != null) {
      this.setState({
        boxChampPendingSubstitution: null,
        boxChampOptionsBoxId: activeId
      });
      this.handleBoxChampSubstitute(step.commitBoxTypeId);
      return true;
    }
    if (step.prompt) {
      clearTimeout(this._boxChampConfirmationTimer);
      this.setState({
        boxChampPendingSubstitution:
          step.state === SUBSTITUTION_PENDING ? step.pending : null,
        boxChampSetAsideMessage: step.prompt,
        boxChampSetAsideConfirmation: false
      });
      return true;
    }
    // confirm_expected: the packer scanned the box they're already packing — a valid,
    // accepted scan. Announce it instead of silently blanking whatever notice was
    // already on screen (the old `boxChampSetAsideMessage: step.prompt || ''` did that).
    // step.cancelled is true when this scan backed out of a pending substitution
    // prompt (boxChampSubstitution.js confirm_expected case) — say so, rather than
    // just "confirmed", which would read as if nothing else had just happened.
    this.boxChampPlaySuccessSound();
    const activeBoxName = entry?.box?.name || 'This box';
    this.boxChampShowConfirmation(
      step.cancelled
        ? `${activeBoxName} confirmed — substitution cancelled.`
        : `${activeBoxName} confirmed.`,
      {boxChampPendingSubstitution: null}
    );
    return true;
  };

  getBoxChampSealPosition = () => {
    const state = this.getBoxChampHandoff();
    const view = this.getBoxChampView();
    const box = state.sealBox || state.expectedBox;
    if (!view || !box) return null;
    const index = view.projection.boxes.findIndex(e => e.box.id === box.id);
    if (index === -1) return null;
    return `Box ${index + 1} of ${view.projection.totalBoxes}`;
  };

  boxChampLabelFor = (view, row) =>
    view.labels[`${row.order_item_id}:${row.kit_id ?? ''}`] ||
    (view.labelsByProduct || {})[row.product_id] ||
    null;

  getBoxChampSealedContents = () => {
    const state = this.getBoxChampHandoff();
    const view = this.getBoxChampView();
    if (!view || !state.sealBox) return [];
    const entry = view.projection.boxes.find(e => e.box.id === state.sealBox.id);
    if (!entry) return [];
    return entry.rows
      .filter(r => r.filled > 0)
      .map(r => {
        const label = this.boxChampLabelFor(view, r.row) || {};
        return {
          key: `${r.row.id}`,
          name: label.name || label.sku || 'Item',
          sku: label.sku,
          image: label.image,
          qty: r.filled
        };
      });
  };

  // Gate for BoxChamp box-scan/hand-off success feedback, mirroring how
  // responseAction('scan_success') gates its own sound on play_success_sound (:2105).
  boxChampPlaySuccessSound = () => {
    if (this.state?.scan_pack_settings?.play_success_sound) {
      this.playSound('BoxChampSuccess');
    }
  };

  boxChampConfirmMessage = state => {
    if (state.kind === HANDOFF_AWAITING_FIRST_VERIFY) {
      return `${state.expectedBox?.name || 'Box'} confirmed — go ahead and start packing.`;
    }
    const sealedName = state.sealBox?.name || 'This box';
    return state.nextBox
      ? `${sealedName} confirmed — now packing ${state.nextBox.name}.`
      : `${sealedName} confirmed.`;
  };

  // Shows a brief BoxChamp success notice whose lifetime is independent of the
  // hand-off log round-trip. boxChampSetAsideMessage is otherwise blanked by
  // componentDidUpdate the instant a non-set-aside SUBMIT_LOG/SUBMIT_LOG_FAIL comes
  // back (see the log-ack handling below) — which, for a hand-off confirm, is the
  // very log this same action just submitted, arriving ~1 tick of the 100ms
  // SubmitLog poll later. boxChampSetAsideConfirmation marks the message as
  // "confirmation-owned" so that clear is skipped; the message instead clears
  // itself via this timer (2.5s), regardless of whether/when the log POST returns.
  boxChampShowConfirmation = (message, extraState = {}) => {
    clearTimeout(this._boxChampConfirmationTimer);
    this.setState({
      ...extraState,
      boxChampSetAsideMessage: message,
      boxChampSetAsideConfirmation: true,
      boxChampHandoffDismissedKey: null
    });
    this._boxChampConfirmationTimer = setTimeout(() => {
      // GROOV-4994 (defect cleanup #6): guard the deferred setState — the component can
      // unmount (navigation away, order redirect) before this 2.5s timer fires.
      if (!this._isMounted) return;
      this.setState(prev =>
        prev.boxChampSetAsideConfirmation && prev.boxChampSetAsideMessage === message
          ? {boxChampSetAsideMessage: '', boxChampSetAsideConfirmation: false}
          : null
      );
    }, 2500);
  };

  confirmBoxChampHandoff = () => {
    // Enforcement, not display: this performs the hand-off. Reading the modal-suppressed
    // state made it return early whenever a pop-up was on screen, so a NEXTBOX scan that
    // the gate had just accepted did nothing at all — the packer's confirm silently
    // vanished. The card's own button is unaffected either way (the card is unmounted
    // while a modal is up), so ignoreModal only ever adds the scan-field path back.
    const state = this.getBoxChampHandoff({ignoreModal: true});
    if (state.kind === HANDOFF_IDLE) return;
    const confirmKey = `${state.kind}:${state.sealBox?.id ?? state.expectedBox?.id ?? ''}`;
    if (this._boxChampConfirmInFlight === confirmKey) return;
    this._boxChampConfirmInFlight = confirmKey;
    const order = this.state.order;
    const userName = this.state.userInfo?.username || '';

    const event =
      state.kind === HANDOFF_AWAITING_FIRST_VERIFY
        ? firstVerifyEvent({
            order,
            verifiedBoxId: state.expectedBox?.id,
            userName
          })
        : handoffEvent({
            order,
            sealedBoxId: state.sealBox?.id,
            verifiedBoxId: state.nextBox?.id ?? null,
            userName
          });

    const verifiedId =
      state.kind === HANDOFF_AWAITING_FIRST_VERIFY
        ? state.expectedBox?.id
        : state.nextBox?.id;

    // The order-completion path (finishBoxChampOrder / responseAction('complete_order'))
    // already plays its own sound and shows its own image — don't double up on this last
    // confirm, just let that path announce itself as it already does.
    const willCompleteOrder = state.isLastBox && this.boxChampOrderPacked();

    this.setState(prev => ({
      boxChampJustConfirmedBoxId:
        state.kind === HANDOFF_PAUSED ? state.sealBox?.id : null,
      boxChampSealConfirmedBoxIds:
        state.kind === HANDOFF_PAUSED && state.sealBox?.id != null
          ? [...prev.boxChampSealConfirmedBoxIds, state.sealBox.id]
          : prev.boxChampSealConfirmedBoxIds,
      boxChampHandoffMessage: '',
      // boxChampHandoffMessage renders only while the hand-off card is visible
      // (BoxChampHandoffCard.js:95), and confirming almost always drops the state
      // straight back to idle (the box we just sealed/verified stops being "pending"
      // the instant boxChampSealConfirmedBoxIds/boxChampVerifiedBoxIds update above).
      // The actual success notice is shown separately via boxChampShowConfirmation
      // below, into boxChampSetAsideMessage (BoxChampSetAsideNotice.js:26 renders
      // regardless of hand-off state) — protected there from the log-ack clear.
      boxChampVerifiedBoxIds:
        verifiedId == null
          ? prev.boxChampVerifiedBoxIds
          : [...prev.boxChampVerifiedBoxIds, verifiedId]
    }), () => {
      this._boxChampConfirmInFlight = null;
    });

    if (!willCompleteOrder) {
      this.boxChampPlaySuccessSound();
      this.boxChampShowConfirmation(this.boxChampConfirmMessage(state));
    }

    this.updateLog(event, 'handoff');

    if (willCompleteOrder) this.finishBoxChampOrder();
  };

  finishBoxChampOrder = () => {
    if (this._boxChampCompletionReleased) return;

    this._boxChampCompletionPending = false;
    this._boxChampCompletionReleased = true;
    const orderVerification =
      this.props?.bothSettings?.data?.data?.scanpack_setting?.order_verification ||
      this.state?.scan_pack_settings?.order_verification;
    if (orderVerification) {
      this.forceUpdate();
      return;
    }
    this.responseAction('order_complete');
    this.scannAllItems(this.props?.Order?.basicinfo?.id);
    setTimeout(() => this.redirectFun(true), 1200);
  };

  boxChampRejectionText = (result, state) => {
    if (result.reason === 'wrong_box') {
      return `That isn't the right box — scan ${result.expectedName}.`;
    }
    if (result.reason === 'scan_the_box') {
      return `Scan ${result.expectedName || 'the box'} to continue.`;
    }
    if (result.reason === 'box_incomplete') {
      return `${result.expectedName || 'This box'} isn't complete yet.`;
    }
    return `Finish the hand-off first — seal ${
      state.sealBox ? state.sealBox.name : 'this box'
    }.`;
  };

  getOrderItemID = () => {
    let id =
      this.state?.order?.order.unscanned_items[0]?.child_items.length > 0
        ? this.state?.order?.order?.unscanned_items[0]?.child_items[0]
            ?.product_id
        : this.state?.order?.order?.unscanned_items[0]?.product_id;
    return id;
  };
  getUpdatededOrder = async id => {
    let fetchListData = this.state.shipmentOrder;
    fetchListData.input = id;
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    axios({
      method: 'post',
      url: `${url}/scan_pack/scan_barcode.json`,
      headers: {Authorization: `Bearer ${access_token}`},
      data: fetchListData
    })
      .then(res => {
        let data = res?.data.data?.order[0].scan_hash?.data;
        let orderData = data;
        if (data && data.order && !data.scanned_items) {
          orderData = data.order;
        }

        if (orderData && orderData.scanned_items && orderData.unscanned_items) {
          this.setState({
            order: {
              order: orderData
            }
          });
        } else {
          console.error('getUpdatededOrder: Invalid order data structure', data);
        }
      })
      .catch(error => {
        if (error?.response?.status) {
          dispatch({
            type: SEARCH_SCANPACK_ORDER_FAIL,
            payload: error?.response?.status
          });
        }
      });
  };
  addBarcode = item => {
    if (
      (item.barcodes && item.barcodes.length === 0) ||
      (item.barcodes &&
        item.barcodes.length === 1 &&
        item.barcodes[0].barcode === ' ')
    ) {
      this.setState({addBarcodeWindow: true, addBarcodeItem: item});
    }
    // if (item.barcodes && item.barcodes.length === 1 && item.barcodes[0].barcode === "") {
    //   this.setState({ addBarcodeWindow: true, addBarcodeItem: item })
    // }
  };

  addBarcodeSubmit = () => {
    if (!this.state.addBarcodeText?.trim()) {
      return;
    }
    const gtin14 = extractGtin14FromBarcode(this.state.addBarcodeText);
    let newHash = {
      value: gtin14 || this.state.addBarcodeText,
      var: 'barcode',
      id: this.state.addBarcodeItem.product_id
    };
    this.props.updateProductList(newHash);
    this.setState({updateProductApiCall: new Date()});
    updateProductApi = true;
  };

  // Check for remaining logs before order completion
  checkAndSendRemainingLogs = async () => {
    try {
      const getItem = await AsyncStorage.getItem('logsArray');
      if (getItem && getItem !== 'undefined') {
        const data = JSON.parse(getItem);
        if (data && data.length > 0) {
          console.log(`Found ${data.length} remaining logs before order completion, sending now...`);
          this.props.SubmitLog('submitLog');
        }
      }
    } catch (error) {
      console.error('Error checking remaining logs:', error);
    }
  };

  addLog = async sku => {
    let logging = await AsyncStorage.getItem('Logging');
    let LoggingArray = JSON.parse(logging);
    if (LoggingArray && LoggingArray.length >= 80) {
      LoggingArray.splice(0, 1);
    }
    let SKU = sku;
    let lastLog = {
      event: 'add_next',
      id: this.state.order.order.id,
      name: this.state.userInfo?.name,
      time: new Date(),
      Log_count: '',
      SKU: SKU
    };
    if (LoggingArray.length > 0) {
      LoggingArray.push(lastLog);
    } else {
      LoggingArray = [lastLog];
    }
    await AsyncStorage.setItem('Logging', JSON.stringify(LoggingArray));
    let localLogs = this.state.localLogs;
    localLogs.splice(0, 0, lastLog);
  };

  componentDidUpdate(prevProps, prevState) {
    // FE-2 (GROOV-4923): clear box-verify state when a different order is loaded, so a
    // reopened/next order never shows a stale "✓ verified" badge. Guarded (only on an
    // order-id change with something to clear) to avoid an update loop.
    if (
      prevState?.order?.order?.id !== this.state?.order?.order?.id &&
      this.state.verifiedBoxIds.length
    ) {
      this.setState({verifiedBoxIds: []});
    }

    if (prevState?.order?.order?.id !== this.state?.order?.order?.id) {
      if (
        this.state.boxChampVerifiedBoxIds.length ||
        this.state.boxChampSealConfirmedBoxIds.length ||
        this.state.boxChampJustConfirmedBoxId !== null ||
        this.state.boxChampOptionsBoxId !== null ||
        this.state.boxChampPendingSubstitution !== null ||
        this.state.boxChampHandoffMessage ||
        this.state.boxChampSetAsideMessage
      ) {
        this.setState({
          boxChampVerifiedBoxIds: [],
          boxChampSealConfirmedBoxIds: [],
          boxChampJustConfirmedBoxId: null,
          boxChampOptionsBoxId: null,
          boxChampPendingSubstitution: null,
          boxChampHandoffMessage: '',
          boxChampHandoffDismissedKey: null,
          boxChampSetAsideMessage: '',
          boxChampSetAsideConfirmation: false
        });
      }
      clearTimeout(this._boxChampConfirmationTimer);
      this._boxChampCompletionReleased = false;
      this._boxChampCompletionPending = false;
      this._boxChampVerificationFired = false;
      this._boxChampConfirmInFlight = null;
    }
    const prevUnscannedCount = prevState?.order?.order?.unscanned_items?.length ?? 0;
    const nowUnscannedCount = this.state?.order?.order?.unscanned_items?.length ?? 0;
    if (prevUnscannedCount === 0 && nowUnscannedCount > 0) this._boxChampVerificationFired = false;
    if (
      !this.state.boxChampCatalog.length &&
      !this._boxChampCatalogRequested &&
      this.getBoxChampView()
    ) {
      this.loadBoxChampCatalog();
    }

    if (
      this.props.updateLog?.time &&
      this.props.updateLog.time !== prevProps.updateLog?.time
    ) {
      const payload = this.props.updateLog.logs;
      if (isSetAsideRejection(payload)) {
        const message = setAsideMessage(payload);
        if (message) {
          this.playSound('setAside');
          clearTimeout(this._boxChampConfirmationTimer);
          this.setState({
            boxChampSetAsideMessage: message,
            boxChampSetAsideConfirmation: false,
            boxChampHandoffDismissedKey: null
          });
          this.refreshBoxChampBoxes();
          this.getUpdatededOrder(this.state.order?.order?.increment_id);
        }
      } else if (this.state.boxChampSetAsideMessage && !this.state.boxChampSetAsideConfirmation) {
        // A hand-off confirm's own success notice must not be a casualty of the very
        // log this SUBMIT_LOG/SUBMIT_LOG_FAIL ack is for (or of any other log ack that
        // happens to land while it's showing) — boxChampSetAsideConfirmation marks it
        // as owned by boxChampShowConfirmation's own timer instead. See that method.
        this.setState({boxChampSetAsideMessage: ''});
      }
    }

    // Hand a mirrored rejection back to the card the moment the card can show it again.
    //
    // scanBarcode's reject branch mirrors the rejection text into the set-aside notice
    // when the card is hidden, so a rejection under a pop-up is more than a buzz. That
    // mirror is decided once, at scan time. When the pop-up closes the card remounts and
    // renders the very same boxChampHandoffMessage itself (BoxChampHandoffCard.js:402),
    // and the notice — which has no timer of its own, unlike boxChampShowConfirmation —
    // would sit there repeating it until an unrelated log ack or an order change happened
    // to clear it. Retiring the echo here is what actually delivers the "never the same
    // sentence in two banners" promise that branch is written against.
    //
    // Deliberately narrow: only an echo (identical text) that is not confirmation-owned,
    // and only once the DISPLAY state is non-idle, which is exactly the condition under
    // which the card renders. A server set-aside message never matches, because it is not
    // the string boxChampRejectionText produced. Clearing makes the guard false, so this
    // cannot re-enter.
    if (
      this.state.boxChampSetAsideMessage &&
      !this.state.boxChampSetAsideConfirmation &&
      this.state.boxChampSetAsideMessage === this.state.boxChampHandoffMessage &&
      this.getBoxChampHandoff().kind !== HANDOFF_IDLE
    ) {
      this.setState({boxChampSetAsideMessage: ''});
    }

    this.releaseBoxChampCompletionIfSettled();

    if (this.state.boxChampJustConfirmedBoxId !== null) {
      const boxes =
        this.props.Order?.boxes || this.state.order?.order?.boxes || [];
      const confirmed = boxes.find(
        b => b && b.id === this.state.boxChampJustConfirmedBoxId
      );
      if (confirmed && confirmed.completed_at) {
        this.setState({boxChampJustConfirmedBoxId: null});
      }
    }
   if( (prevState.isConnected !== this.state.isConnected) && this.state.isConnected && prevState.isConnected !== null){
    console.log(this.props.searchOrder)
    if(  this.props?.bothSettings?.data?.data?.general_setting?.multi_box_shipments){
      setTimeout(()=>{
        this.props.MultiBoxSaveLog(undefined, undefined,this.props.searchOrder.offlineData)
      },3000)
    }else{
        setTimeout(()=>{
        this.props.SubmitLog(undefined , this.props.searchOrder.offlineData)
      },3000)
    }
   }

    if(prevState.isFetchLabelData != this.state.isFetchLabelData){
      if(this.state.isFetchLabelData){
        this.redirectFun()
      }
    }
    let searchOrder = this.props.searchOrder;
    let searchData = searchOrder && searchOrder.data;
    let asyncData = this.props && this.props.bothSettings;
    let updateLog = this.props && this.props.updateLog;
    let settingData;
    let order = {
      order:
        this.props && this.props.route.params && this.props.route.params.data
    };
    let callOrder = this?.props?.callOrder?.data?.order?.[0];
    // console.log("update order data didupdate",order)
    // Membership shared with boxChampModalOpen() via boxChampModalFlags.js. The strict
    // `!== false` / `!== null` comparisons of the original chain are preserved inside
    // focusBlockingModalOpen — an undefined flag blocks focus here even though it does
    // not suppress the card, and that asymmetry is deliberate (see the module header).
    let setFocus =
      !focusBlockingModalOpen(this.state, this.props) &&
      !this.boxChampHandoffOwnsFocus();
    // successSound.load()
    if (setFocus === true || (setFocus === true && this.state.focusBarcode)) {
      try {
        if (!this.props.isListMode && this.state.windowWidth < 900) {
          this.InputField.current.focus();
        } else if (!this.props.isListMode && this.state.windowWidth > 900) {
          !this.state.loader && this.InputField.current.focus();
        } else {
          !this.state.loader && this.InputField.current.focus();
        }
      } catch (error) {}
    }
    if (this.state.errorMessageClickScanConfirmation) {
      try {
        this.myInput.current.focus();
      } catch (error) {}
    }
    if (this.state.clickScanConfirmation) {
      try {
        this.myInput.current.focus();
      } catch (error) {}
    }
    if (
      this.props?.addOrderItems &&
      addItemFlag &&
      this.state.addItemToOrderInput !== ''
    ) {
      this.getUpdatededOrder(this.state.order.order.increment_id);
      this.addLog(this.state.addItemToOrderInput);
      this.props.GetOrderDetail(this.state.order.order)
      this.setState({
        addNextItemLoading: false,
        addItemToOrder: false,
        addItemToOrderInput: '',
        bar_code: ''
      });
      barCodeInput = '';
      addItemFlag = false;
      allowed = false;
    }
    if (
      this.props?.route?.params?.data?.from === 'productDetailPage' &&
      this.props.route.params.data !== this.state.productDetail
    ) {
      console.log('##################');
      let data = {
        input: this.props.route.params.data.increment_id,
        state: 'scanpack.rfo',
        id: null,
        box_id: null,
        store_order_id: null,
        app: 'app'
      };
      updateFromProductSuccess = true;
      this.props.SearchScanpackOrder(data);
      this.setState({
        productDetail: this.props.route.params.data,
        loader: true,
        apiCallTime: new Date(),
        order: this.props.route?.params?.data?.order
      });
      let id = this.getOrderItemID();
      this.props.GetProductDetail(id);
    }

    //Search Order Data
    if (
      updateFromProductSuccess &&
      this.props &&
      this.props.searchOrder &&
      this.props.searchOrder
    ) {
      let searchResult =
        this.props.searchOrder && this.props.searchOrder.searchOrder;
      let order =
        searchResult &&
        searchResult?.data?.order &&
        searchResult?.data?.order[0];
      if (searchResult) {
        if (searchResult.matched) {
          if (
            (searchResult.data.status === 'awaiting' ||
              searchResult.data.status === 'onhold') &&
            this.props.route.params.data.increment_id ===
              this.props.searchOrder.searchOrder.data.order_num
          ) {
            // this.orderDetails(order)
            this.setState({
              oldOne: this.props.searchOrder,
              loader: false,
              order: this.props.route?.params?.data
            });
            updateFromProductSuccess = false;
          }
        }
      }
    }

    /*update order when user click save&close on order detail page start*/
    if (
      this?.props?.route?.params?.data?.from === 'orderDetailPage' &&
      this.props.route.params.data !== this.state.detailData
    ) {
      console.log('called 232')
      this.setState({
        order: this.props.route.params.data,
        detailData: this.props.route.params.data,
        notes_toPackerFlag: true,
        notes_internalFlag: true,
        tags_toPackerFlag: true,
        customer_commentsFlag: true
      });
      updateFromOrderDetailPage = false;
      this.getUpdatededOrder(this.props.route.params.data.order.increment_id);
    }
    /*update order when user click save&close on order detail page end*/

    /*Update the general settings & scanpack settings start*/
    const {bothSettings, product} = this.props;
    if (bothSettings && bothSettings !== this.state.bothSettings && product) {
      settingData = this.props?.bothSettings?.data?.data;
      this.setState({
        scanpackSettings: settingData?.scanpack_setting,
        generalSettings: settingData?.general_setting,
        scan_pack_settings: settingData?.scanpack_setting,
        general_settings: settingData?.general_setting,
        bothSettings: this?.props?.bothSettings,
        loader: false
      });
      //Add this for handle GROOV-2704:
      // if (
      //   this.props?.bothSettings?.data?.data?.general_setting
      //     ?.conf_code_product_instruction === 'always'
      // ) {
      //   this.setState({productConfirmationCheck: true});
      // }
      // if (
      //   this.props?.bothSettings?.data?.data?.general_setting
      //     ?.conf_code_product_instruction === 'optional' &&
      //     this.props?.product?.basicinfo?.packing_instructions_conf
      // ) {

      //     this.setState({productConfirmationCheck: true});

      // }
    }

    /*Update the general settings & scanpack settings end*/

    if (
      updateProductInfoSuccess === true &&
      this.props &&
      this.props.updateProduct &&
      this.props.updateProduct.data
    ) {
      updateProductInfoSuccess = false;
      this.setState({alias: false});
      if (this.props.route.params.data.order) {
        let data = {
          input: this.props.route.params.data.order.increment_id,
          state: 'scanpack.rfo',
          id: null,
          box_id: null,
          store_order_id: null,
          app: 'app'
        };
        this.props.SearchScanpackOrder(data);
        updateFromProductSuccess = true;
      }
    }

    if (asyncData !== '') {
      let convert = asyncData;
      let scData = convert?.data?.data?.scanpack_setting;
      let gsData = convert?.data?.data?.general_setting;
      if (ScanPackSettingsAccess === false && scData) {
        ScanPackSettingsAccess = true;
        if (scData && scData.post_scanning_option !== 'None') {
          let type = scData.post_scanning_option;
          if (type === 'Record') {
            this.setState({
              postScanningFieldLabel: `Tracking Number Recording`,
              postScanningOrderNumber: `${order.order.order.increment_id}`,
              // postScanningMessageDetail: "Please create the shipping label, adhere it to the package, and scan the tracking number to continue."
              postScanningMessageDetail: i18n.t(
                'recordTracingmsg.createShippingLabel'
              )
            });
            // this.setState({ notes_toPackerFlag: false, notes_internalFlag: false, customer_commentsFlag: false, tags_toPackerFlag: false, truepostScanningFieldLabel: `Scan Tracking Number for Order ${order.order.order.increment_id}`, postScanningMessageDetail: "Please create the shipping label, adhere it to the package, and scan the tracking number to continue." })
            // Add If condition for notes when first time render component
            if (
              scData.show_internal_notes ||
              scData.show_tags ||
              scData.show_customer_notes
            ) {
              this.setState({
                notes_toPackerFlag: true,
                notes_internalFlag: true,
                customer_commentsFlag: true,
                tags_toPackerFlag: true
              });
            }
          }
          if (type === 'Verify') {
            let postScanMessage = '';
            if (
              order.order.order.tracking_num !== null &&
              order.order.order.tracking_num !== ''
            ) {
              postScanMessage = i18n.t('shippinglabelmsg.scanShippingLabel');
              // postScanMessage = "Please scan the shipping label."
            } else {
              this.setState({verifylabel: true});
              postScanMessage = i18n.t('shippinglabelmsg.noRecordTracking');
              // postScanMessage = "This order does not have a tracking number associated with it. it may have been imported before shipping label was generated. Please click or press eneter to bypass this check and mark the order scanned."
              // postScanMessage = "Your Scan & Pack settings call for shipping label verification but no tracking information was imported with this order. Please scan your confirmation code or press enter to continue."
            }
            // Resolve internal notes issues here
            if (
              scData.show_internal_notes ||
              scData.show_tags ||
              scData.show_customer_notes
            ) {
              this.setState({
                notes_toPackerFlag: true,
                notes_internalFlag: true,
                customer_commentsFlag: true,
                tags_toPackerFlag: true
              });
            }
            this.setState({
              postScanningFieldLabel: `Shipping Label Verification`,
              postScanningOrderNumber: `${order.order.order.increment_id}`,
              //Just for check
              postScanningMessageDetail: postScanMessage
            });
          }
          if (
            type === 'Barcode' &&
            scData.post_scanning_option_second === 'PackingSlip'
          ) {
            scData['post_scanning_option'] = 'None';
            isPrintOrderBarcode = true;
          }
          if (
            type === 'Barcode' &&
            scData.post_scanning_option_second === 'Barcode'
          ) {
            scData['post_scanning_option'] = 'None';
            isPrintOrderBarcode = true;
          }
          if (
            type === 'Barcode' &&
            scData.post_scanning_option_second === 'None'
          ) {
            scData['post_scanning_option'] = 'None';
            isPrintOrderBarcode = true;
          }
          if (
            type === 'PackingSlip' &&
            scData.post_scanning_option_second === 'None'
          ) {
            scData['post_scanning_option'] = 'None';
          }
          if (
            type === 'PackingSlip' &&
            scData.post_scanning_option_second === 'Barcode'
          ) {
            scData['post_scanning_option'] = 'None';
          }
          if (
            type === 'PackingSlip' &&
            scData.post_scanning_option_second === 'PackingSlip'
          ) {
            scData['post_scanning_option'] = 'None';
          }
        }
        if (
          scData &&
          scData.post_scanning_option == 'Barcode' &&
          scData.post_scanning_option_second !== 'None'
        ) {
          let type = scData.post_scanning_option_second;
          this.postScanFunction(type, true);
        }
        if (
          scData &&
          scData.post_scanning_option == 'PackingSlip' &&
          scData.post_scanning_option_second !== 'None'
        ) {
          let type = scData.post_scanning_option_second;
          this.postScanFunction(type, true);
        }
        this.setState({scan_pack_settings: scData});
        this.props.GetItem('GeneralSetting');
      }
      if (
        ScanPackSettingsAccess === true &&
        settingData?.scanpack_setting.post_scanning_option === 'PackingSlip' &&
        scData.post_scanning_option_second === 'None'
      ) {
        this.setState({
          scan_pack_settings: {
            ...settingData?.scanpack_setting,
            post_scanning_option: 'None'
          }
        });
      }
      if (GeneralSettingAccess === false && gsData !== undefined) {
        GeneralSettingAccess = true;
        this.setState({general_settings: gsData});
      }
    }

    if (this.props.updateLog.time !== this.state.logTime) {
      if (
        this.props?.updateLog?.logs?.status === 'OK' &&
        this.props.updateLog.updateLog &&
        this.props.updateLog.time
      ) {
        this.setState({logTime: this.props.updateLog.time});
      }
    }

    if (this.props.route.params.restart === true) {
      this.props.route.params.restartButton;
    }

    if (
      updateProductApi === true &&
      this.props &&
      this.props.updateProduct &&
      this.props.updateProduct.data !== '' &&
      this.props.updateProduct.time >= this.state.updateProductApiCall
    ) {
      updateProductApi = false;
      let productID =
        this.state.addBarcodeItem && this.state.addBarcodeItem.product_id;
      let order = this.state.order;
      const updateResponse = this.props.updateProduct.data;
      const barcodeSaved =
        updateResponse !== null &&
        typeof updateResponse === 'object' &&
        updateResponse.status !== false;
      if (updateResponse?.show_alias_popup) {
        this.setState({
          alias: true,
          addBarcodeWindow: false,
          Product: this.props.updateProduct.data,
          updateProduct: this.props.updateProduct.data
        });
      } else if (!barcodeSaved) {
        this.setState({
          addBarcodeWindow: false,
          addBarcodeText: undefined,
          addBarcodeItem: '',
          updateProductApiCall: ''
        });
        this.alertBox(
          updateResponse?.error_msg || i18n.t('scanpackItem.add_barcode_failed')
        );
      } else {
        order.order.unscanned_items &&
          order.order.unscanned_items.length > 0 &&
          order.order.unscanned_items.map((item, index) => {
            // debugger
            if (item.child_items.length > 0) {
              item.child_items.map((child, index) => {
                if (child.product_id === productID) {
                  child.barcodes = [
                    {
                      barcode: this.state.addBarcodeText,
                      created_at: '',
                      id: 0,
                      packing_count: '1',
                      product_id: productID,
                      updated_at: new Date()
                    }
                  ];
                }
              });
            } else {
              if (item.product_id === productID) {
                item.barcodes = [
                  {
                    barcode: this.state.addBarcodeText,
                    created_at: '',
                    id: 0,
                    packing_count: '1',
                    product_id: productID,
                    updated_at: new Date()
                  }
                ];
              }
            }
          });
        let unItem =
          order.order.unscanned_items.length > 0 &&
          order.order.unscanned_items[0];
        let item =
          unItem.child_items.length > 0 ? unItem.child_items[0] : unItem;
        this.clickScan(item);
        this.setState({
          addBarcodeWindow: false,
          addBarcodeText: '',
          addBarcodeItem: '',
          order,
          updateProductApiCall: ''
        });
      }
    }

    if (updateAliasSuccess && this.props && this.props.updateAlias) {
      if (this.props.updateAlias.status) {
        let fetchListData = this.state.shipmentOrder;
        fetchListData.input = this.state.order.order.increment_id;
        this.props.SearchScanpackOrder(fetchListData);
        this.setState({updateProductApiCall: new Date()});
        updateAliasSuccess = false;
        updateProductInfoSuccess = true;
        updateFromProductSuccess = true;
      } else {
      }
    }
    // if(this?.state?.order && this?.state?.order?.order && this?.state?.order?.order?.unscanned_items && this?.state?.order?.order?.unscanned_items?.length === 0 && this?.state?.scan_pack_settings?.return_to_orders === false  && callOrder?.popup_shipping_label && callOrder?.store_type === "ShippingEasy"){
    //   if(callOrder?.shipment_id !== ""){

    //     let shippingeasy_url = `http://app.shippingeasy.com/shipments/${parseInt(callOrder?.shipment_id)}/edit`;
    //     window.open(shippingeasy_url,"","width=700,height=500")
    //   }

    // }
    if (this?.props?.getShipment && this.state.shipping_easy) {
      this.setState({shipping_easy: false});
      if (this?.props?.getShipment?.shipment_id !== null) {
        let shippingeasy_url = `http://app.shippingeasy.com/shipments/${parseInt(
          this?.props?.getShipment?.shipment_id
        )}/edit`;
        window.open(
          shippingeasy_url,
          '',
          'width=' + screen.availWidth + ',height=' + screen.availHeight
        );
      } else {
        this.alertBox(i18n.t('scanpackItem.Scanpack_Item_Shipment'));
      }
    }
    if (
      this.state?.order?.order?.status === 'serviceissue' &&
      !this.state?.serviceIssuePrompt &&
      serviceIssueModal
    ) {
      this.setState({serviceIssuePrompt: true, orderConfirmPopUp: false});
      serviceIssueModal = false;
    }
    // this.getProductID();
    if (this.props?.product?.skus) {
      sku = this.props?.product.skus[0]?.sku;
    }
  }

  getProductID = () => {
    let data = this.state?.order?.order.unscanned_items;
    if (data?.length > 0) {
      data.map(data => {
        let barCode = data.barcodes[0]?.barcode.toLowerCase();
        if (barCode === this.state?.bar_code.toLowerCase()) {
          this.props.GetProductDetail(data.barcodes[0].product_id);
        }
      });
    }
  };

  nav = async (order, completeOrder) => {
    completeOrder && this.multipleTime();
  };

  //After the apis call update the status (scanned , order  not present)
  statusFunction = message => {
    let data = this.state.data;
    data['input'] = '';
    this.setState({rfoTitle: message, data});
  };
  printlabel = async (setting, newShippingLabelSetting) => {
    let dimensionShipping =
      this.props?.ssLabelData?.ss_label_data?.dimensions.split('x');
    let messageUrl = this.props?.ssLabelData?.ss_label_data?.direct_printed_url;
    let data = await fetchData();
    this.setState({printers: JSON.parse(JSON.stringify(data?.printersList))});
    let shippingLabel =
      (await AsyncStorage.getItem('print_ss_shipping_labels')) || '';
    if (shippingLabel.length === 0) {
      this.setState({modalVisible: true});
    } else {
      this.setState({modalVisible: false, printingLabel: true});
      const printerState = await handlePrinterSelection(
        JSON.parse(shippingLabel),
        messageUrl,
        setting,
        'shipping_label',
        {width: dimensionShipping[0], height: dimensionShipping[1]},
        null,
        this.alertBox
      );
      if (this._isMounted) this.setState({printingLabel: false});
      if (printerState?.type) this.navigateBack();
    }
  };
  navigateBack(params = {}) {
    const from = this.props?.route?.params?.data?.from;
    const routeParams = this.props?.route?.params || {};
    if (from === 'scanToCart') {
      const navigationParams = {
        ...params,
        resetCartFlag: true,
        ...(routeParams.postScanningContinue && {
          postScanningContinue: routeParams.postScanningContinue,
          postScanOrderId: routeParams.postScanOrderId,
          postScanningModulesRemaining: routeParams.postScanningModulesRemaining,
          postScanningToteInput: routeParams.postScanningToteInput
        })
      };
      this.props.navigation.navigate('ScanToCart', navigationParams);
    } else {
      this.props.navigation.navigate('ScanPack', params);
    }
  };
  redirectFun(force = false) {
    // BoxChamp hand-off can require confirmation after the last item is
    // scanned; until that resolves, the order isn't actually done, so no
    // navigation below (including the Scan-to-Cart early return) may fire.
    if (
      typeof this.boxChampCompletionDeferred === 'function' &&
      this.boxChampCompletionDeferred()
    ) {
      return;
    }
    if (this.props?.route?.params?.data?.from === 'scanToCart') {
      const unscannedRemaining =
        this.state?.order?.order?.unscanned_items?.length ?? 0;
      if (unscannedRemaining === 0 && !this.state.isPageRedirectedAfterScanningComplete) {
        this.setState({isPageRedirectedAfterScanningComplete: true}, () => {
          this.navigateBack({update: true, time: new Date()});
        });
      }
      return;
    }

    const noUnscanned =
      force === true ||
      this?.state?.order?.order?.unscanned_items?.length === 0;
    // Fix: In multibox mode, navigate to ShippingLabel BEFORE going to RFO
    // so the label UI is shown immediately after the last item is scanned.
    const generalSettingsFromProps = this.props?.bothSettings?.data?.data?.general_setting;
    const multiBoxEnabled = generalSettingsFromProps?.multi_box_shipments;
    const perBoxLabelSetting = generalSettingsFromProps?.per_box_shipping_label_creation;
    const boxes = this.props?.Order?.boxes;
    if (
      multiBoxEnabled &&
      perBoxLabelSetting === 'per_box_shipping_label_creation_after_box' &&
      noUnscanned &&
      boxes?.length > 0 &&
      !this.state.isPageRedirectedAfterScanningComplete
    ) {
      this.setState({isPageRedirectedAfterScanningComplete: true}, () => {
        this.props.navigation.navigate('ShippingLabel', {
          time: new Date(),
          setting: this.props?.bothSettings?.data?.data,
          navigation: this.props?.navigation || null,
          userRole: this.props?.route?.params?.userdata || null,
          basicinfo:
            this.props?.Order?.basicinfo ||
            this.props?.callOrder?.data?.order?.[0]?.scan_hash?.data?.order,
          directPrintingSetting:
            this.props?.bothSettings?.data?.data?.general_setting
              ?.print_ss_shipping_labels,
          isolatedComponent: true,
          returnToScanPack: true,
          multiBoxMode: true,
          isFinalBox: true,
          currentOrderId: this.state?.order?.order?.increment_id
        });
      });
      return;
    }

    let shipmentData =
      this.props?.ssLabelData?.ss_label_data?.shipments?.filter(
        z => z.voided === false
      );
    const matchingItem2Array = [];
    let ssLabelData = this.props?.ssLabelData?.ss_label_data?.shipping_labels;
    {
      shipmentData?.map((shipmentinsideData, index) => {
        let matchingItem2 = ssLabelData.find(
          shipmentData =>
            shipmentinsideData.shipmentId === shipmentData.shipment_id
        );
        matchingItem2Array.push(matchingItem2);
      });
    }
    if (matchingItem2Array && matchingItem2Array?.length > 0) {
      this.setState({directPrintLabelState: true});
    }
    let packing =
      this?.state?.scanpackSettings?.camera_option == 'photo' &&
      this.state?.general_settings?.packing_cam == true
        ? true
        : false;
    // console.log("camera optiojn jheree=====>", this?.state?.scanpackSettings?.camera_option)
    /* This code is not being used with cam functionality. Leaving it in here if any edge case comes up */
    // let pack_scanning_option = this?.state?.scanpackSettings?.packing_option
    // this.packingCamFun(pack_scanning_option)
    if (
      this?.state?.scanpackSettings?.camera_option != 'photo' ||
      this.state?.general_settings?.packing_cam === false ||
      this.state?.scanpackSettings?.packing_cam_enabled === false
    ) {
      //Comment down for  GROOV-3339
      // if(this.state.scan_pack_settings?.post_scanning_option === "PackingSlip" ){
      //   this.setState({ scan_pack_settings: { post_scanning_option: 'None' } });
      // }
      if (
        noUnscanned &&
        this?.state?.scan_pack_settings?.post_scanning_option == 'None'
      ) {
        const apiOrder = this?.props?.callOrder?.data?.order?.[0];
        this.props.SearchScanpackOrder('', false);
        if (
          apiOrder?.use_api_create_label &&
          !this?.state?.isPageRedirectedAfterScanningComplete
        ) {
          if (
            apiOrder?.print_ss_label &&
            !this.props?.ssLabelData?.ss_label_data?.direct_printed
          ) {
            this.setState({isPageRedirectedAfterScanningComplete: true}, () => {
              this.props.navigation.navigate('ShippingLabel', {
                time: new Date(),
                setting: this.props?.bothSettings?.data?.data,
                navigation: this.props?.navigation || null,
                userRole: this.props?.route?.params?.userdata || null,
                basicinfo:
                  this.props?.Order?.basicinfo ||
                  apiOrder?.scan_hash?.data?.order,
                directPrintingSetting:
                  this.props?.bothSettings?.data?.data?.general_setting
                    ?.print_ss_shipping_labels,
                isolatedComponent: true,
                directPrintLabelState: this.state.directPrintLabelState
              });
            });
          } else if (
            this.props?.bothSettings?.data?.data?.general_setting
              ?.print_ss_shipping_labels
          ) {  
            this.printlabel(
              this.props?.bothSettings?.data?.data?.general_setting,
              ''
            );
          } else {
            window.open(
              this.props?.ssLabelData?.ss_label_data?.direct_printed_url
            );
            this.setState({isPageRedirectedAfterScanningComplete: true}, () => {
              this.props.navigation.navigate('ScanPack', {
                update: true,
                time: new Date(),
                a: 1
              });
            });
          }
        } else if (
          !apiOrder?.use_api_create_label &&
          !this?.state?.isPageRedirectedAfterScanningComplete &&
          !this?.props?.ssLabelData?.ss_label_data?.direct_printed &&
          !this.state.newState
        ) {
          this.setState({isPageRedirectedAfterScanningComplete: true}, () => {
            this.props.navigation.navigate('ScanPack', {
              update: true,
              time: new Date(),
              a: 2
            });
          });
        }
      }
      // this.props.navigation.navigate("ScanPack", { update: true, time: new Date() })
    }
  }

  searchOrder = async codeFound => {
    let data = {
      input: this.state.serviceIssueInput,
      state: 'scanpack.rfo',
      id: null,
      box_id: null,
      store_order_id: null,
      app: 'app'
    };
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    axios({
      method: 'post',
      url: `${url}/scan_pack/scan_barcode.json`,
      headers: {Authorization: `Bearer ${access_token}`},
      data: data
    }).then(res => {
      if (
        res?.data?.matched &&
        this.state?.serviceIssueInput !== res?.data?.data?.order[0]?.ordernum
      ) {
        this.setState({
          serviceIssueInput: '',
          serviceIssuePrompt: false,
          orderSearchLoading: false
        });
        // GROOV-4994 (QA pass 2, flagged not fixed): same notFullFilledItems-staleness
        // gap as duplicateShipStationOrder() above — this swaps in a new order without
        // refreshing it.
        this.setState({order: res?.data.data?.order[0].scan_hash?.data});
      } else {
        this.props.ShowNotification({value: true, codeFound: codeFound});
        notReadySound.play();
        RootNavigation.reset('ScanPack');
      }
    });
  };

  ChangeOrderStatus = confirmation_code => {
    const data = {
      filter: 'all',
      inverted: false,
      limit: 20,
      offset: 0,
      order: 'DESC',
      orderArray: [{id: this.state.order?.order.id}],
      product_search_toggle: 'true',
      reallocate_inventory: false,
      search: '',
      select_all: false,
      sort: '',
      status: 'awaiting',
      confirmation_code: confirmation_code
    };
    this.props.UpdateOrderStatus(data);
    this.setState({serviceIssueInput: '', serviceIssuePrompt: false});
    this.setShowConfirmationPopUp();
  };

  ServiceIssueFun = () => {
    let userCode = this.state.userData.confirmation_code;
    let userInput = this.state.serviceIssueInput;
    if (this.state.userData.role.add_edit_order_items) {
      if (userInput && userInput === userCode) {
        this.ChangeOrderStatus();
        return;
      }
      if (userInput) {
        this.setState({orderSearchLoading: true});
        this.searchOrder(false);
      }
    } else {
      if (userInput !== '') {
        this.checkConfirmationCode(userInput);
      }
    }
  };
  checkConfirmationCode = async confirmation_code => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    axios({
      method: 'get',
      url: `${url}/users/1/?confirmation_code=${confirmation_code}&format=json`,
      headers: {Authorization: `Bearer ${access_token}`},
      confirmation_code: confirmation_code
    }).then(res => {
      if (
        res.data.user?.confirmation_code === confirmation_code &&
        res.data.user?.role.add_edit_order_items
      ) {
        this.ChangeOrderStatus(confirmation_code);
        return;
      }
      if (res.data.user) {
        this.setState({orderSearchLoading: true});
        this.searchOrder(true);
      }
      this.setState({orderSearchLoading: true});
      this.searchOrder();
    });
  };

  getServiceIssueMsg = () => {
    if (this.state.userData.role.add_edit_order_items) {
      return i18n.t('scanpackItem.service_Issue_msg_one');
    } else {
      return i18n.t('scanpackItem.service_Issue_msg_two');
    }
  };

  /*RESPONSE SOUND AND IMAGE START*/
  responseAction = async (response, from) => {
    if (
      (response === 'order_complete' || response === 'complete_order') &&
      this.boxChampCompletionDeferred()
    ) {
      return this.responseAction('scan_success', from);
    }
    // let logdata = AsyncStorage.getItem("logsArray")
    // console.log("---logdata",logdata)
    // await sound.unloadAsync();
    // this.InputField.current.focus()
    // if(Platform.OS == 'ios'){
    //   successSound.load()
    // }

    let {
      play_success_sound,
      show_success_image,
      success_image_time,
      play_fail_sound,
      show_fail_image,
      fail_image_time,
      play_order_complete_sound,
      show_order_complete_image,
      order_complete_image_time
    } = this.state?.scan_pack_settings;
    let popup_show_time = 0.3; // default time
    if (response === 'not_ready') {
      popup_show_time = fail_image_time;
      show_fail_image
        ? this.setState({scanFailAction: true, responseShowAction: true})
        : null;
      play_fail_sound ? this.playSound('notReady') : null;
      this.setState({bar_code: ''});
      barCodeInput = '';
    }
    if (response === 'scan_fail') {
      popup_show_time = fail_image_time;
      show_fail_image
        ? this.setState({scanFailAction: true, responseShowAction: true})
        : null;
      play_fail_sound ? this.playSound('Fail') : null;
    }
    if (response === 'scan_success') {
      popup_show_time = success_image_time;
      show_success_image
        ? this.setState({scanSuccessAction: true, responseShowAction: true})
        : null;
      play_success_sound ? this.playSound('Success') : null;
      this.setState({forSerialRecord: ''});
      if (
        this.props?.bothSettings?.data?.data?.general_setting
          ?.multi_box_shipments
      ) {
        this.state.serialRecordPopUpShow === false && this.multipleTime();
      }
    }
    if (response === 'order_complete') {
      if (
        this.props?.route?.params?.data?.from === 'scanToCart' ||
        (this.state.scan_pack_settings.post_scanning_option === 'None' &&
          (this.state?.general_settings?.packing_cam === true ||
            this.state?.scanpackSettings?.packing_cam_enabled === false))
      ) {
        response = 'complete_order';
      } else {
        let scanType = this.state.scan_pack_settings.post_scanning_option;
        this.postScanFunction(scanType);
      }
    }

    // when all order items scanned
    if (response === 'complete_order') {
      // Check for remaining logs before completing order
      this.checkAndSendRemainingLogs();

      let bothSettingNew =
        this.props?.bothSettings?.data?.data?.scanpack_setting;
      popup_show_time = order_complete_image_time;
      show_order_complete_image
        ? this.setState({orderCompleteAction: true, responseShowAction: true})
        : null;
      play_order_complete_sound ? this.playSound('Complete') : null;
      if(bothSettingNew?.email_customer_option && !this.props?.Order?.storeinfo?.disable_packing_cam && (bothSettingNew?.post_scanning_option === "Barcode" && bothSettingNew?.post_scanning_option === "PackingSlip")){
        this.props.emailCustomer(this.props?.Order?.basicinfo?.id)
      }
      from !== 'packing_cam' && this.nav(this.state.order, true);
      this.setState({scan_pack_settings: {post_scanning_option: 'None'}});
      isOrderComplete = true;
      this.setState({general_settings: {packing_cam: false}});
      this.triggerReprintIfEnabled();

      // Updating the Index DB to handle the discrepancies for this order
      if (this.props.Order?.basicinfo) {
        let {id} = this.props.Order.basicinfo;
        let {userInfo} = this.state;

        if (userInfo) {
          await createOrUpdateOrder({
            tenant: userInfo.current_tenant,
            user_id: userInfo.id,
            order_id: id,
            flag: 0,
            order_data: this.props.Order.basicinfo
          });
        }
      }
      // if(this.state.newPacking === true && this.state?.bothSettings?.data?.data?.scanpack_setting?.post_scanning_option==='None' ){
      //   setTimeout(()=>{
      //     this.props.navigation.navigate('ScanPack')
      //   },1000)
      // }
      // this.setState({ packing_cam_options: true })
    }
    if (response === 'restart_action_complete') {
      this.nav(this.state.order);
    }
    let showTime = popup_show_time * 400;

    //Logic order-complete-image wait
    if (response === 'complete_order') {
      typeof showTime === 'Number' &&
        setTimeout(() => {
          this.setState({
            scanFailAction: false,
            scanSuccessAction: false,
            orderCompleteAction: false,
            responseShowAction: false
          });
        }, showTime);
    } else {
      setTimeout(() => {
        this.setState({
          scanFailAction: false,
          scanSuccessAction: false,
          orderCompleteAction: false,
          responseShowAction: false
        });
      }, showTime);
    }
    //End Logic for order_complete_image
    this.updateAction.bind(this);
    try {
      if (from === 'serialRecord') {
        this.serialRecord.current.focus();
      } else {
        // this.barcode.current.focus()
      }
    } catch (error) {}
    // this.multipleTime()
  };
  updateKitScannedQty = (
    unScannedItem,
    scannedItems,
    oneChildItem,
    eachKitConsistOn
  ) => {
    if (unScannedItem.confirmation && unScannedItem?.instruction?.length > 0) {
      this.setState({
        productConfirmationCheck: true,
        kitConfirmation: true,
        kitInstructions: unScannedItem?.instruction
      });
    }
    HandleUpdateScannedQty(
      unScannedItem,
      scannedItems,
      oneChildItem,
      eachKitConsistOn
    );
  };

  handleKitUpdate = (unScannedItem, scannedItems, numberOfKits) => {
    let updateKit = HandleKitUpdateData(unScannedItem, numberOfKits);
    if (updateKit) {
      this.updateKitScannedQty(unScannedItem, scannedItems);
    }
  };

  handleKitConfirmation = () => {
    let unScannedItems = this.state?.order.order.unscanned_items;
    let scannedItems = this.state?.order.order.scanned_items;
    let numberOfKits =
      unScannedItems[0]?.child_items.length > 0
        ? unScannedItems[0].total_qty
        : 0;
    if (numberOfKits > 1) {
      let childItem = unScannedItems[0].child_items[0];
      let eachKitConsistOn =
        (childItem.qty_remaining + childItem.scanned_qty) / numberOfKits;
      let isOpenPopUp =
        unScannedItems[0].child_items[0].scanned_qty % eachKitConsistOn;
      if (isOpenPopUp == 0) {
        let childItemsScanned = false;
        scannedItems.map(item => {
          if (item.order_item_id === unScannedItems[0].order_item_id) {
            if (item.child_items?.length > 1) {
              childItemsScanned = true;
            }
          }
        });
        if (unScannedItems[0].child_items.length === 1 && !childItemsScanned) {
          this.updateKitScannedQty(
            unScannedItems[0],
            scannedItems,
            true,
            eachKitConsistOn
          );
        } else {
          this.handleKitUpdate(unScannedItems[0], scannedItems, numberOfKits);
        }
      }
    }
  };

  handleUnScannedList = () => {
    let updatedList = this.state.order.order.unscanned_items.filter(
      item => item.qty_remaining !== 0
    );
    updateBarcodeName(this.state.order.order)
  .then(result => {
    console.log('Updated barcode data:', result);
  })
  .catch(error => {
    console.error('Failed to update barcode:', error);
  });
    this.setState({
      order: {
        ...this.state.order,
        order: {
          ...this.state.order.order,
          unscanned_items: updatedList
        }
      }
    });
  };

  playSound = async response => {
    if (response === 'notReady') {
      notReadySound.play();
    }

    if (response === 'setAside') {
      setAsideSound.pause();
      setAsideSound.currentTime = 0;
      setAsideSound.play();
    }
    if (response === 'Success') {
      // successSound.autoplay = true

      successSound.pause();
      successSound.currentTime = 0;
      successSound.play();
      this.props.fetchUser(true);
      this.handleKitConfirmation();
      this.handleUnScannedList();
    }
    if (response === 'Fail') {
      failSound.play();
    }
    if (response === 'Complete') {
      completeSoun.play();
      this.props.fetchUser(true);
    }
    if (response === 'BoxChampSuccess') {
      // Same "success" tone as a regular item scan (successSound), reused here for a
      // BoxChamp box scan / hand-off confirm — deliberately skips the item-scan side
      // effects (fetchUser, handleKitConfirmation, handleUnScannedList) that 'Success'
      // carries, since those apply to product scans, not box confirmations.
      successSound.pause();
      successSound.currentTime = 0;
      successSound.play();
    }
  };

  /*RESPONSE SOUND AND IMAGE END*/

  currentFocus = () => {
    // try {
    //   this.barcode.current.focus()
    // } catch (error) {
    // }
  };

  sleep = async ms => {
    return new Promise(resolve => {
      setTimeout(resolve, ms);
    });
  };
  alertBoxOpenTracking = (msg, state) => {
    this.setState({alertTextTracking: msg, alertBoxTracking: state});
  };
  alertBoxOpenShipping = (msg, state) => {
    this.setState({alertTextShipping: msg, alertBoxShipping: state});
  };
  /* SUBMIT TRACKING START */
  trackingSubmit(trackingNumber) {
    trackState = trackingSubmit(
      this,
      this.state,
      this.state.scan_pack_settings,
      trackingNumber,
      this.state.order,
      this.state.localLogs,
      this.props?.route?.params?.userdata?.role?.add_edit_order_items,
      this.state.general_settings,
      this.setStateCallback
    );
  }
  /* SUBMIT TRACKING END */

  postScanFunction = (type, timeSecond) => {
    let scanPack = this.state.scan_pack_settings;
    let Order = this.state.order && this.state.order.order || this.props?.route?.params?.data?.order
    if (timeSecond) {
      if (type === 'Record') {
        this.setState({
          trackingNumberView: true,
          timeSecond: true,
          postScanningFieldLabel: `Tracking Number Recording`,
          postScanningOrderNumber: `${Order.increment_id}`,
          postScanningMessageDetail: i18n.t(
            'recordTracingmsg.createShippingLabel'
          )
          // postScanningMessageDetail: "Please create the shipping label, adhere it to the package, and scan the tracking number to continue."
        });
      }
      if (type === 'Verify') {
        Order.tracking_num !== null
          ? this.setState({
              trackingNumberView: true,
              timeSecond: true,
              postScanningFieldLabel: `Shipping Label Verification`,
              postScanningOrderNumber: `${Order.increment_id}`,
              postScanningMessageDetail: i18n.t(
                'shippinglabelmsg.scanShippingLabel'
              )
              // postScanningMessageDetail: "Please scan the shipping label."
            })
          : this.setState({
              trackingNumberView: true,
              timeSecond: true,
              postScanningFieldLabel: `Shipping Label Verification`,
              postScanningOrderNumber: `${Order.increment_id}`,
              postScanSecond: true,
              verifylabel: true,
              postScanningMessageDetail: i18n.t(
                'shippinglabelmsg.noRecordTracking'
              )
              // postScanningMessageDetail: "This order does not have a tracking number associated with it. it may have been imported before shipping label was generated. Please click or press eneter to bypass this check and mark the order scanned.",
              // postScanningMessageDetail: "Your Scan & Pack settings call for shipping label verification but no tracking information was imported with this order. Please scan your confirmation code or press enter to continue."
            });
      }
      if (type === 'Barcode' || type === 'PackingSlip') {
        this.responseAction('complete_order');
        this.scannAllItems(this.props?.Order?.basicinfo?.id);
        if (!this.isBoxChampCompletionPending()) this.props?.navigation?.navigate('ScanPack');
      }
    } else {
      if (type === 'Record') {
        this.setState({
          trackingNumberView: true,
          postScanningFieldLabel: `Tracking Number Recording`,
          postScanningOrderNumber: `${Order.increment_id}`,
          postScanningMessageDetail: i18n.t(
            'recordTracingmsg.createShippingLabel'
          )
          // postScanningMessageDetail: "Please create the shipping label, adhere it to the package, and scan the tracking number to continue."
        });
      }
      if (type === 'Verify') {
        Order.tracking_num !== null
          ? this.setState({
              trackingNumberView: true,
              postScanningFieldLabel: `Shipping Label Verification`,
              postScanningOrderNumber: `${Order.increment_id}`,
              postScanningMessageDetail: i18n.t(
                'shippinglabelmsg.scanShippingLabel'
              )
              // postScanningMessageDetail: "Please scan the shipping label."
            })
          : this.setState({
              verifylabel: true,
              trackingNumberView: true,
              postScanningFieldLabel: `Shipping Label Verification`,
              postScanningOrderNumber: `${Order.increment_id}`,
              postScan: true,
              postScanningMessageDetail: i18n.t(
                'shippinglabelmsg.noRecordTracking'
              )
              // postScanningMessageDetail: "This order does not have a tracking number associated with it. it may have been imported before shipping label was generated. Please click or press eneter to bypass this check and mark the order scanned.",
              // postScanningMessageDetail: "Your Scan & Pack settings call for shipping label verification but no tracking information was imported with this order. Please scan your confirmation code or press enter to continue."
            });
      }
    }
  };

  updateAction = async time => {
    const soundObject = new Audio.Sound();
    await soundObject.unloadAsync();
    this.setState({bar_code: ''});
    barCodeInput = '';
  };

  /*Send log at the back end method start*/
  multipleTime = async submitLog => {
    // let getItem = await AsyncStorage.getItem("logsArray")
    // let convert = getItem && JSON.parse(getItem)
    //changes for multibox.
    const {order} = this?.state ?? {};
    const {unscanned_items} = order?.order ?? {};
    if (unscanned_items?.length === 0) {
      setTimeout(() => {
        getLiveStatsData();
      }, 5000);
    }
    if (this.multipleTimeRunning) {
      return;
    }
    this.multipleTimeRunning = true;
    let getItem = await AsyncStorage.getItem('logsArray');
    let data = getItem && JSON.parse(getItem);
    if (
      this.props?.bothSettings?.data?.data?.general_setting?.multi_box_shipments
    ) {
      let id = this.props?.route?.params?.data?.order;
      if(!this.state.isConnected){
        this.props.updateOfflineOrder(data)
      }else{
        await this.props.MultiBoxSaveLog(submitLog, id);
      }
      setTimeout(() => this.redirectFun(), 1000);
      multiBoxFlag = true;
    }
    else{
      let getItem = await AsyncStorage.getItem('logsArray');
      let data = getItem && JSON.parse(getItem);
      // debugger
      console.log(this.props.searchOrder.offlineData);
   if(!this.state.isConnected) {
    this.props.updateOfflineOrder(data)
   }else{
     this.props.SubmitLog(submitLog);
   }
    setTimeout(() => this.redirectFun(), 3000);
    }
    setTimeout(() => {
      this.multipleTimeRunning = false;
    }, 1000);
  };
  /*Send log at the back end method end*/

  resetIsPrintOrderBarcode = () => {
    isPrintOrderBarcode = false;
  };

  /* FOR SUBMIT THE NOTE AND ISSUE ACTION BARCODE START */
  submitAlert = () => {
    let order = this.state.order;
    let notes_fromPacker = this.state.notes_fromPacker;
    order.order.notes_fromPacker = notes_fromPacker;
    let temp_order = AddNoteLog(
      order,
      notes_fromPacker,
      '',
      this.state.userInfo?.name,
      'note'
    );
    if (this.state.issueFlag) {
      this.updateLog(temp_order, 'issue');
      RootNavigation.navigate('ScanPack');
    }
    if (this.state.noteFlag) {
      this.updateLog(temp_order, 'note');
    }
    // localLogs.push(temp_order)
    console.log('called fff')
    this.setState({
      issueFlag: false,
      noteFlag: false,
      alert: false,
      notes_fromPacker: '',
      order
    });
  };
  /* FOR SUBMIT THE NOTE AND ISSUE ACTION BARCODE END*/

  checkCount = () => {
    let count = setAllScanCount(this.state.order.order);

    return count < 3;
  };

  setType = newType => {
    isBulkScan = newType;
  };

  isScanAllDisable = (item, isBulkScan) => {
    if (item.click_scan_enabled === 'off' && isBulkScan === 'scan_all_items') {
      this.alertBox(i18n.t('scanpackItem.Scanpack_pass_fun_msg'));
      return false;
    }
    return true;
  };

  /* BULK SCAN START */
  scanAllItem = () => {
    scanAllItem(
      this.setStateCallback,
      this.state.order,
      this.state.typeScanCount,
      this.state.scan_pack_settings,
      this.state.log,
      this.state.general_settings,
      this.state.localLogs,
      this.state.type,
      this.state.userInfo,
      this.isScanAllDisable,
      this.updateLog,
      this.responseAction,
      blockScan,
      confirmProductConfirmation,
      isBulkScan,
      enableSerial,
      this.setEnableSerial,
      this.setConfirmProductConfirmation,
      this.setIsBulk
    );

    //Comment this code for handle GROOV-2704 (Kit activity Issue)
    // if (general_settings.conf_code_product_instruction === 'always') {
    //   this.setState({
    //     productConfirmationCheck: true,
    //     blockItemType: 'bulk_scan'
    //   });
    //   blockScan = true;
    // } else if (general_settings.conf_code_product_instruction === 'optional') {
    //   if (items.child_items && items.child_items.length >= 1) {
    //     if (items.child_items[0].confirmation === true) {
    //       this.setState({
    //         productConfirmationCheck: true,
    //         blockItemToScan: items.child_items[0],
    //         blockItemType: 'bulk_scan'
    //       });
    //       blockScan = true;
    //     } else if (items.confirmation === true) {
    //       this.setState({
    //         productConfirmationCheck: true,
    //         blockItemToScan: items,
    //         blockItemType: 'bulk_scan'
    //       });
    //       blockScan = true;
    //     }
    //   }
    // }
  };
  /* BULK SCAN END */

  /* TYPE SCAN START*/

  setStateCallback = changes => {
    this.setState(changes);
  };

  setEnableSerial = value => {
    enableSerial = value;
  };

  setConfirmProductConfirmation = value => {
    confirmProductConfirmation = value;
  };

  setIsBulk = value => {
    isBulkScan = value;
  };
  typeScanError = qty => {
    let msg = `${i18n.t(
      'scanpackItem.Scanpack_qty_exceed_msg_part1'
    )} ${qty} ${i18n.t('scanpackItem.Scanpack_qty_exceed_msg_part2')}`;
    this.alertBox(
      i18n.t('scanpackItem.Scanpack_Item_Typecount_exceed_error'),
      true
    );
    this.props.isHaptics && Vibration.vibrate(400);
    this.responseAction('scan_fail');
    this.setState({bar_code: ''});
    barCodeInput = '';
    return true;
  };

  typeScanResponse = items => {
    if (items.length > 0) {
      this.responseAction('scan_success');
    } else if (this.boxChampCompletionDeferred()) {
      this.responseAction('scan_success');
    } else {
      this.responseAction('order_complete');
      this.scannAllItems(this.props?.Order?.basicinfo?.id);
    }
  };

  isBoxChampCompletionPending = () => {
    if (this._boxChampCompletionReleased) return false;
    const view = this.getBoxChampView();
    if (!view) return false;
    if (this.getBoxChampHandoff({ignoreModal: true}).kind === HANDOFF_IDLE &&
        this.boxChampOrderPacked()) {
      return false;
    }
    return true;
  };

  boxChampCompletionDeferred = () => {
    if (!this.isBoxChampCompletionPending()) return false;
    this._boxChampCompletionPending = true;
    return true;
  };

  releaseBoxChampCompletionIfSettled = () => {
    if (!this._boxChampCompletionPending) return;
    const view = this.getBoxChampView();
    if (!view) {
      this._boxChampCompletionPending = false;
      return;
    }
    if (this.getBoxChampHandoff({ignoreModal: true}).kind !== HANDOFF_IDLE) return;
    if (!this.boxChampOrderPacked()) return;
    this.finishBoxChampOrder();
  };
  submitTypeScan = () => {
    console.log('called 9999');
    enableSerial = submitTypeScan(
      this.setStateCallback,
      this.state.order,
      this.props?.Order,
      this.state.typeScanCount,
      this.state.scan_pack_settings,
      this.state.localLogs,
      this.state.type,
      this.state.typeScanState,
      this.state.typeScanDeductCountState,
      this.state.activeBoxIndex,
      this.state.userInfo,
      enableSerial,
      this.typeScanResponse,
      this.typeScanError,
      this.updateLog
    );
  };
  /* TYPE SCAN END */
  getAddNextItemMessage = () => {
    let isUserAllowed = this.state.userData?.role.add_edit_order_items;
    if (isUserAllowed || allowed) {
      return i18n.t('AddNextBarcode.search_item_msg');
    } else {
      return i18n.t('AddNextBarcode.confirmation_code_msg');
    }
  };

  handleAddItemToOrder = async () => {
    let isUserAllowed = this.state.userData?.role.add_edit_order_items;
    if (!isUserAllowed && !allowed) {
      this.checkUserPermissions();
    }
    if (isUserAllowed || allowed) {
      this.setState({
        addNextItemLoading: true
      });
      this.searchProduct();
    }
  };

  searchProduct = async () => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    const gtin14 = extractGtin14FromBarcode(this.state.addItemToOrderInput);
    axios({
      method: 'get',
      url: `${url}/products/search.json?barcode=${
        gtin14 || this.state.addItemToOrderInput
      }&search=${'test'}`,
      headers: {Authorization: `Bearer ${access_token}`}
    }).then(res => {
      if (res.data[0]?.id && res.data[0]?.status === 'active') {
        addItemFlag = true;
        const currentBoxName = this.props?.Order?.boxes?.[this.state.activeBoxIndex]?.name || '';
        this.props.AddOrderItems(this.state.order?.order.id, {
          productids: [res.data[0]?.id],
          qty: 1,
          on_ex: 'on GPX',
          is_allowed: true,
          add_to_scanned_list: true,
          box_name: currentBoxName
        }).then(() => {
          this.props.GetOrderDetail(this.state.order?.order);
        });
        return;
      }
      if (res.data[0]?.status !== 'active') {
        this.alertBox(i18n.t('order.addItemToOrderError'), true);
        this.setState({
          addNextItemLoading: false,
          addItemToOrderInput: ''
        });
        return;
      }
      this.setState({
        addNextItemLoading: false,
        addItemToOrderInput: ''
      });
      failSound.play();
    });
  };

  checkUserPermissions = async () => {
    this.setState({addNextItemLoading: true});
    let userInput = this.state.addItemToOrderInput;
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    axios({
      method: 'get',
      url: `${url}/users/1/?confirmation_code=${userInput}&format=json`,
      headers: {Authorization: `Bearer ${access_token}`},
      confirmation_code: userInput
    }).then(res => {
      if (
        res.data.user?.confirmation_code === userInput &&
        res.data.user?.role.add_edit_order_items
      ) {
        this.setState({addNextItemLoading: false, addItemToOrderInput: ''});
        allowed = true;
        return;
      }
      this.setState({addNextItemLoading: false, addItemToOrderInput: ''});
      allowed = false;
      failSound.play();
    });
  };

  alertBox = (message, skip, messageTypeSuccess) => {
    if (messageTypeSuccess === true) {
      this.setState({
        popUpModelShow: true,
        message: message,
        messageTypeSuccess: true
      });
    } else {
      this.setState({popUpModelShow: true, message: message});
    }
    setTimeout(
      function () {
        this.setState({
          popUpModelShow: false,
          message: '',
          messageTypeSuccess: false
        });
      }.bind(this),
      4000
    );
    try {
      this.InputField.current.focus();
      // this.barcode.current.focus()
    } catch (error) {}
  };

  closeAlert = () => {
    this.setState({
      alert: false,
      notes_fromPacker: '',
      typeScanAlert: false,
      typeScanCount: '',
      popUpModelShow: false,
      addBarcodeWindow: false,
      addItemToOrderInput: '',
      bar_code: '',
      addItemToOrder: false,
      message: '',
      // serialRecordPopUpShow: false,
      serialRecordInput: '',
      serialRecordTwo: '',
      serialRecordOne: '',
      clickScanConfirmation: false,
      confirmationCheckItem: null,
      clickScanConfirmInput: '',
      // productConfirmationCheck: false,
      errorMessageProductConfirmationCheck: false,
      errorMessageClickScanConfirmation: false,
      alertBoxTracking: false,
      alertBoxShipping: false
      // orderConfirmPopUp: false
    });
    this.currentFocus();
    barCodeInput = '';
    enableSerial = false;
  };
  closeErrorAlert = () => {
    this.setState({
      errorMessageClickScanConfirmation: false,
      clickScanConfirmInput: ''
    });
  };
  noBarcodeScan = item => {};
  SubmitBypassLog = async data => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    axios({
      method: 'post',
      url: `${url}/orders/save_by_passed_log.json`,
      headers: {Authorization: `Bearer ${access_token}`},
      data
    }).catch(error => {
      console.log(error);
    });
  };
  addByPassedLog = async () => {
    let logging = await AsyncStorage.getItem('Logging');
    let LoggingArray = JSON.parse(logging);
    let userName = this.state?.userInfo?.name;
    let SKU = '';
    let lastLog = {};
    ({LoggingArray, SKU, lastLog} = handleByPassLog(
      LoggingArray,
      userName,
      this.state?.order
    ));
    await AsyncStorage.setItem('Logging', JSON.stringify(LoggingArray));
    let localLogs = this.state.localLogs;
    localLogs.splice(0, 0, lastLog);
    let data = {
      sku: SKU,
      id: this.state.order.order.id
    };
    this.SubmitBypassLog(data);
  };
  closeProductConfirmationCheckPopUp = () => {
    //Change this function bcoz handle Comment this code for handle GROOV-2704 (Kit activity Issue)
    if (this.state.kitConfirmation) {
      this.setState({
        productConfirmationCheck: false,
        kitConfirmation: false,
        kitInstructions: '',
        productConfirmationCheckInput: ''
      });
      return;
    }
    isModalCleared = true;
    this.setState({productConfirmationCheck: false});
    if (isModalCleared) {
      if (clickBarcodeVal !== '') {
        this.scanBarcode(clickBarcodeVal, typeValue);
      } else {
        this.scanBarcode();
      }
    }
    this.addByPassedLog();
  };
  /*Product Confirmation Submit Start*/
  ProductConfirmationCheckFun = () => {
    let userCode = this.state.userInfo.confirmation_code;
    let userInput = this.state.productConfirmationCheckInput;
    // debugger
    if (userInput !== '') {
      if (userCode === userInput) {
        // debugger
        // 12345678900
        if (this.state.kitConfirmation) {
          this.setState({
            productConfirmationCheck: false,
            kitConfirmation: false,
            kitInstructions: '',
            productConfirmationCheckInput: ''
          });
          return;
        }
        this.setState({productConfirmationCheck: false});

        //Comment this code for handle GROOV-2704 (Kit activity Issue)

        // this.clickScan(unscamIte);
        // if (this.state.blockItemType === 'item_present') {
        //   confirmProductConfirmation = true;
        //   this.clickScan(this.state.blockItemToScan);
        // }
        // if (this.state.blockItemType === 'barcode') {
        //   confirmProductConfirmation = true;
        //   this.scanBarcode();
        // }
        // if (this.state.blockItemType === 'bulk_scan') {
        //   confirmProductConfirmation = true;
        //   this.scanAllItem();
        // }
        isModalCleared = true;
        this.setState({
          productConfirmationCheckInput: '',
          productConfirmationCheck: false
        });
        if (isModalCleared) {
          if (clickBarcodeVal !== '') {
            this.scanBarcode(clickBarcodeVal, typeValue);
          } else {
            this.scanBarcode();
          }
        }
      } else {
        this.setState({productConfirmationCheckInput: ''});
        // this.setState({userInput: "",})
        this.responseAction('not_ready');
        this.alertBox(
          i18n.t('productConfirmationPopup.productConfirmationAlert')
        );
      }
    } else {
      if (this.state.generalSettings.strict_cc === true) {
        this.responseAction('not_ready');
      } else {
        if (this.state.blockItemType === 'item_present') {
          confirmProductConfirmation = true;
          this.clickScan(this.state.blockItemToScan);
        }
        if (this.state.blockItemType === 'barcode') {
          confirmProductConfirmation = true;
          this.scanBarcode();
        }
        if (this.state.blockItemType === 'bulk_scan') {
          confirmProductConfirmation = true;
          this.scanAllItem();
        }
        this.setState({
          productConfirmationCheckInput: '',
          productConfirmationCheck: false
        });
        isModalCleared = true;
        userInput !== '' && this.scanBarcode(clickBarcodeVal, typeValue);
      }
    }
  };
  /*Product Confirmation Submit End*/

  /*Product Confirmation Input Field On Change Start*/
  handleProductConfirmationCheckInput = e => {
    this.setState({
      productConfirmationCheckInput: e,
      errorMessageProductConfirmationCheck: false
    });
  };
  /*Product Confirmation Input Field On Change End*/

  /*Order Confirmation Submit Start*/
  OrderConfirmationCheckFun = () => {
    let userCode = this.state.userInfo.confirmation_code;
    // console.log("userCode",userCode)
    let userInput = this.state.OrderConfirmationCheckInput;
    if (userInput !== '') {
      // debugger
      if (userCode === userInput) {
        this.setState({orderConfirmPopUp: false});
        this.setState({OrderConfirmationCheckInput: ''});
      } else {
        this.setState({OrderConfirmationCheckInput: ''});
        this.alertBox(
          i18n.t('orderConfirmationPopup.orderConfirmationMismatch')
        );
        this.responseAction('not_ready');
      }
    } else {
      // debugger
      if (this.state.generalSettings.strict_cc === true) {
        this.responseAction('not_ready');
      } else {
        this.setState({orderConfirmPopUp: false});
        this.currentFocus();
      }
    }
  };

  OrderConfirmationClosePopup = () => {
    this.setState({orderConfirmPopUp: false});
  };
  /*Order Confirmation Submit End*/

  /*Order Confirmation Input Field On Change Start*/
  handleOrderConfirmationCheckInput = e => {
    this.setState({
      OrderConfirmationCheckInput: e,
      errorMessageOrderConfirmationCheck: false
    });
  };
  /*Order Confirmation Input Field On Change End*/

  /* RESTART ACTION BARCODE METHOD START*/
  // restart = () => {
  //   let order = this.state.order
  //   if(order){
  //     let temp = []
  //     let unscanned_items = order.order.unscanned_items
  //     let scanned_items = order.order.scanned_items
  //     order.order.scanned_items.map((scan , index) => {
  //         if(scan.qty_remaining !== 0){
  //           scan.qty_remaining = scan.scanned_qty
  //           scan.scanned_qty = 0
  //           unscanned_items.unshift(scan)
  //         }
  //     })
  //     order.order.scanned_items = []
  //   }
  // }
  /* RESTART ACTION BARCODE METHOD END*/
  handleRestartPrompt = () => {
    this.setState({openRestartPrompt: true});
  };
  restartButton = () => {
    let {order} = this.state;
    let scan_pack_settings = this.state.scan_pack_settings;
    let localLogs = this.state.localLogs;
    let temp_order = RestartLog(
      order,
      scan_pack_settings,
      localLogs,
      this.state?.userInfo?.name
    );
    this.updateLog(temp_order, 'RESTART');
    if (this.state.serialRecordInput === '') {
      // localLogs.push(temp_order)
      localLogs.splice(0, 0, temp_order);
    }
    this.props.navigation.navigate('ScanPack');
  };

  addNote = () => {
    if (this.state.order) {
      let order = this.state.order;
      let notes_fromPacker = order.order.notes_fromPacker;
      this.setState({
        alert: true,
        notes_fromPacker: notes_fromPacker === null ? '' : notes_fromPacker,
        noteFlag: true
      });
    }
  };

  saveChanges = async () => {
    let getItem = await AsyncStorage.getItem('logsArray');
    let count = getItem !== null && JSON.parse(getItem);
    if (count && count.length > 0) {
      this.alertBox(i18n.t('scanpackItem.Scanpack_success_msg'), true);
      this.multipleTime('submitLog');
    }
  };

  checkIsToOpen = (barCode, type) => {
    //these two params will use for click scan fun
    clickBarcodeVal = barCode;
    typeValue = type;
    let itemExist = false;
    barCodeInput = this.getBarcodeInputValue();
    let packing_instructions_conf = GetPackingInstructionConf(
      this?.state?.order
    );
    let product; // this variable is used when a user enters random barcode
    if (barCodeInput === '*' || barCodeInput === 'RESTART') {
      isModalCleared = true;
      return;
    }
    //check barcode is present in un_scanned items
    if (barCodeInput !== '') {
      let data = this.state?.order?.order.unscanned_items;
      if (
        this.state.scan_pack_settings.escape_string_enabled &&
        type !== 'item_present'
      ) {
        const {barCodeWithoutSpaces} = processBarCode(
          barCodeInput,
          this.state.scan_pack_settings
        );
        barCodeInput = barCodeWithoutSpaces;
      }
      ({itemExist, product, packing_instructions_conf} = CheckItemExists(
        data,
        packing_instructions_conf,
        barCodeInput
      ));
      if (!itemExist) {
        isModalCleared = true;
        return;
      }
      this.setState({isBarcodeEnter: true});
    }
    if (isModalCleared) return;

    if (
      this.props?.bothSettings?.data?.data?.general_setting
        ?.conf_code_product_instruction === 'never'
    ) {
      isModalCleared = true;
      return;
    }
    if (
      this.props?.bothSettings?.data?.data?.general_setting
        ?.conf_code_product_instruction === 'optional' &&
      !packing_instructions_conf
    ) {
      isModalCleared = true;
      return;
    }
    this.setProductConfirmationCheckState(product);
  };

  setProductConfirmationCheckState = product => {
    let instructionCheck = InstructionCheck(product, this.state?.order);
    let qtyCheck = QtyCheck(product, this.state?.order);
    if (qtyCheck && instructionCheck) {
      this.setState({productConfirmationCheck: true});
      isModalCleared = false;
    } else {
      this.setState({productConfirmationCheck: false});
      isModalCleared = true;
    }
  };

  goPrev = () => {
    this.setState({activeBoxIndex: this.state.activeBoxIndex - 1});
  };
  goNext = () => {
    this.setState({activeBoxIndex: this.state.activeBoxIndex + 1});
  };

  //changes for multibox.
  printSlipFun = () => {
    let Order = this.props?.Order;
    let boxId = Order?.boxes[this.state?.activeBoxIndex]?.id;
    let boxItemCount = Order?.order_item_boxes
      ?.filter(data => data.box_id === boxId)?.length || 0;
    if (boxItemCount === 0) {
      this.multiBoxStateUpdate(true);
      return;
    }
    let item = {
      box_ids: boxId,
      orderArray: [{id: Order?.basicinfo?.id}]
    };
    this.props.PrintSlip(item);
  };
  addBox = () => {
    let multiPerBoxSetting =
      this.props?.bothSettings?.data?.data?.general_setting
        ?.per_box_packing_slips;
    let detail = {
      id: this.props?.Order?.basicinfo?.id,
      orderDetail: this.state.data
    };
    let item = {
      name: `Box ${this?.props?.Order?.boxes.length + 1}`,
      order_id: this.props?.Order?.basicinfo?.id
    };
    this.props.AddBox(item, this.goNext, this.props?.Order?.boxes, detail);
    if (multiPerBoxSetting === 'when_new_boxes_are_started') {
      this.printSlipFun();
      const scanPackSettings = this.props?.bothSettings?.data?.data?.scanpack_setting;
      if (scanPackSettings?.enable_reprint_option)
      {
        const orderNumber = this.props?.Order?.basicinfo?.increment_id;
        this.triggerReprintAfterScan(orderNumber, 'packing_slip');
      }
    }
  };

  getBarcodeInputValue = isClickScanFun => {
    if (isClickScanFun === false) {
      return false;
    }
    if (isClickScan) {
      return '';
    }
    if (this.state.bar_code === '') {
      return barCodeInput;
    } else {
      let barcode = this.state.bar_code.trim();
      const gs1BarcodeRegex = /\(11\)(\d{6})|\(15\)(\d{6})|\(17\)(\d{6})|\(10\)([A-Za-z0-9]+)|\(21\)([A-Za-z0-9]+)/g;
      const gtinRegex = /\(01\)(\d{12,14})/;

      if (gs1BarcodeRegex.test(barcode)) {
        console.log("Valid GS1 barcode format");

        const gtinMatch = barcode.match(gtinRegex);

        if (gtinMatch) {
          let orignalBarcode = gtinMatch[1];
          console.log('orignalBarcode',orignalBarcode);
          barcode = orignalBarcode;
        }
        // const modifiedStr = barcode.slice(4);
        // let orignalBarcode = modifiedStr.substring(0, 14);
      } else {
        console.log("Invalid GS1 barcode format");
      }
      return barcode;
    }
  };
  //Changes for Multibox.
  multiBoxStateUpdate = (emptyBoxPrint = false) => {
    this.setState({multiBoxAlertState: true, emptyBoxPrint});
    setTimeout(() => {
      this.setState({multiBoxAlertState: false, emptyBoxPrint: false});
    }, 2000);
  };
  onCloseAlertMultiBox = () => {
    this.setState({multiBoxAlertState: false, emptyBoxPrint: false});
  };

  showAlert = message => {
    this.alertBox(message);
  };

  setTypeInCountModal = value => {
    typeInCountModal = value;
  };

  resetBarCodeInput = () => {
    barCodeInput = '';
  };

  formatBarCode = barcode => {
    let orignalBarcode = barcode;
    // GS1-128 must have GTIN (01) + at least one additional AI code
    const gs1BarcodeRegex =
      /^01(\d{14})((15\d{6})|(21\w{1,20})|(11\d{6})|(17\d{6})|(10\w{1,20})).*/;
    const gs1Match = barcode.match(gs1BarcodeRegex);
   
    if (gs1Match) {
      let modifiedStr = barcode.slice(2);
      orignalBarcode = modifiedStr.substring(0, 14);
      console.log('orignalBarcode',orignalBarcode);
      }
    return orignalBarcode;
  };

  /*SCAN BARCODE METHOD START*/
  scanBarcode = (clickBarcode, type) => {
    let boxItemProps = this.props?.Order?.order_item_boxes;
    let boxProps = this.props?.Order?.boxes;
    let boxFilter = boxItemProps?.filter(
      i => i?.box_id == boxProps[boxProps?.length - 1]?.id
    );

    // ENFORCEMENT state — deliberately ignoreModal.
    //
    // boxChampModalOpen() exists to hide the hand-off card while a pop-up is on screen,
    // and it does that by making handoffState report idle. Reading that same suppressed
    // state here silently switched the box scan gate OFF: with kind forced to
    // HANDOFF_IDLE, classifyPausedInput returns {action: 'pass_through'}, so a genuine
    // HANDOFF_PAUSED stopped rejecting item scans and they fell through to the legacy
    // handler with no buzz and no message for as long as any of those flags was set.
    //
    // The order-completion paths already take the modal-ignoring state for exactly this
    // reason (isBoxChampCompletionPending / releaseBoxChampCompletionIfSettled) so that
    // completion is not released while a modal masks a live hand-off. The scan gate gets
    // the same treatment. Display still reads the suppressed state — the card render at
    // the bottom of this file calls getBoxChampHandoff() with no argument.
    const boxChampState = this.getBoxChampHandoff({ignoreModal: true});
    if (boxChampState.kind !== HANDOFF_IDLE || this.getBoxChampView()) {
      const scannedValue = (
        typeof clickBarcode === 'string'
          ? clickBarcode
          : this.getBarcodeInputValue()
      )?.trim();
      const verdict = classifyPausedInput(scannedValue, {
        state: boxChampState,
        catalog: this.state.boxChampCatalog,
        unboxedBarcodes: this.boxChampUnboxedBarcodes(),
        settings:
          this.props?.bothSettings?.data?.data?.scanpack_setting ||
          this.state?.scan_pack_settings ||
          {}
      });
      if (verdict.action === 'confirm') {
        isClickScan = false;
        this.setState({bar_code: ''});
        barCodeInput = '';
        this.confirmBoxChampHandoff();
        return;
      }
      if (verdict.action === 'reject') {
        isClickScan = false;
        notReadySound.play();
        const rejectionText = this.boxChampRejectionText(verdict, boxChampState);
        // boxChampHandoffMessage is rendered by the hand-off card, and the card returns
        // null whenever the DISPLAY state is idle (BoxChampHandoffCard.js:95) — which is
        // precisely the case a modal creates. Now that the gate keeps rejecting under a
        // modal, a rejection there would otherwise be a buzz with nowhere for the words
        // to land. Mirror the text into the set-aside notice, which renders independently
        // of the card — the same escape hatch confirmBoxChampHandoff already uses for its
        // success notice (see the comment there). Only when the card is actually hidden,
        // and the echo is retired again in componentDidUpdate the moment the card can
        // render it itself, so the packer never reads the same sentence in two banners at
        // once. The message stays parked on boxChampHandoffMessage throughout, so the
        // card picks it up unchanged when the modal closes.
        //
        // Writing the message is NOT on its own enough to make it readable: the in-flow
        // notice is stacked underneath the very pop-ups this mirror exists to survive.
        // The escalation layer near the end of render() is what actually puts it in front
        // of them, and it is what this branch depends on. Two pop-ups it still cannot beat
        // are recorded there and in the report — do not assume "message set" means "packer
        // saw it".
        const cardHidden = this.getBoxChampHandoff().kind === HANDOFF_IDLE;
        if (cardHidden) clearTimeout(this._boxChampConfirmationTimer);
        this.setState({
          bar_code: '',
          boxChampHandoffDismissedKey: null,
          boxChampHandoffMessage: rejectionText,
          ...(cardHidden
            ? {
                boxChampSetAsideMessage: rejectionText,
                boxChampSetAsideConfirmation: false
              }
            : {})
        });
        barCodeInput = '';
        return;
      }
      // These two fall-throughs stay gated on the same state the gate enforces with, so
      // "no hand-off pending" means the real thing rather than "a pop-up is masking one".
      // With genuinely nothing pending they behave exactly as before. With a hand-off
      // pending they no longer run — box substitution and early set-aside were never
      // meant to be reachable mid-hand-off, and reaching them required a modal to be up.
      if (
        boxChampState.kind === HANDOFF_IDLE &&
        this.handleBoxChampBoxScan(scannedValue)
      ) {
        isClickScan = false;
        this.setState({bar_code: ''});
        return;
      }
      if (
        boxChampState.kind === HANDOFF_IDLE &&
        this.boxChampEarlySetAside(scannedValue, type)
      ) {
        isClickScan = false;
        this.setState({bar_code: ''});
        return;
      }
      const legacyBoxNav = String(
        typeof clickBarcode === 'string' ? clickBarcode : clickBarcode?.currentTarget?.value ?? scannedValue ?? ''
      ).trim().toUpperCase();
      if ((legacyBoxNav === 'BOXPREV' || legacyBoxNav === 'BOXNEXT') && this.getBoxChampView()) {
        isClickScan = false;
        // GROOV-4994 (defect cleanup #1): this is a deliberate no-op acknowledgement —
        // manual box nav isn't available on a planned order, but the packer did nothing
        // wrong — not an error, so it must not sound like one. Reuse the existing neutral
        // "setAside" tone (beep-03.mp3, already the low-key confirmation sound this same
        // boxChampSetAsideMessage family uses elsewhere in this file) instead of the
        // error/buzz notReadySound.
        this.playSound('setAside');
        clearTimeout(this._boxChampConfirmationTimer);
        this.setState({
          bar_code: '',
          boxChampSetAsideMessage:
            "Manual box navigation isn't available on a planned order — seal or confirm the current box, or scan its barcode, to move between boxes.",
          boxChampSetAsideConfirmation: false
        });
        barCodeInput = '';
        return;
      }
      if (this.state.boxChampPendingSubstitution) {
        clearTimeout(this._boxChampConfirmationTimer);
        this.setState({
          boxChampPendingSubstitution: null,
          boxChampSetAsideMessage: '',
          boxChampSetAsideConfirmation: false
        });
      }
    }
    this.checkIsToOpen(clickBarcode, type);
    // changes for multibox.
    if (this.state.generalSettings.multi_box_shipments) {
      if (clickBarcode?.currentTarget?.value === 'BOXPREV') {
        if (this.state.activeBoxIndex === 0) {
          notReadySound.play();
          this.setState({bar_code: ''});
          return;
        }
        this.goPrev();
        this.setState({bar_code: ''});
        return;
      }
      if (
        clickBarcode?.currentTarget?.value === 'BOXNEXT' &&
        boxItemProps[boxProps?.length - 1] &&
        boxFilter.length > 0 &&
        boxProps[boxProps.length - 1]?.source !== 'box_champ'
      ) {
        if(!this.state.popInternet){
          boxProps.push({name :  `Box ${this?.props?.Order?.boxes.length + 1}`, id :boxProps[boxProps.length -1]?.id + 1})
        }
        this.addBox();
        this.goNext();
        this.setState({bar_code: ''});
        return;
      } else if (
        clickBarcode?.currentTarget?.value === 'BOXNEXT' &&
        this.state.activeBoxIndex < boxProps?.length - 1
      ) {
        this.goNext();
        this.setState({bar_code: ''});
        return;
      } else if (
        clickBarcode?.currentTarget?.value === 'BOXNEXT' &&
        (boxFilter?.length === 0 ||
          boxProps[boxProps.length - 1]?.source === 'box_champ')
      ) {
        this.multiBoxStateUpdate();
        notReadySound.play();
        this.setState({bar_code: ''});
        return;
      }
    }
    if (this.state.order && isModalCleared) {
      let order = this.state.order;
      let scan_pack_settings = this.state.scan_pack_settings;
      let localScannedItems = this.state.scanned_items;
      let scanned_items = order.order.scanned_items;
      let notes_fromPacker = order.order.notes_fromPacker;
      let unscanned_items = order.order.unscanned_items;
      let bar_code = this.getBarcodeInputValue()?.trim();
      let event_code = this.getBarcodeInputValue()?.trim();
      let ActionBarcode = false;
      let product_id = 0;
      let product_main_id = null;
      // let product_kit_id = 0;
      let is_kit = false;
      product_confirm = bar_code;

      let formattedBarcode = bar_code;
      let originalScannedBarcode = bar_code;

      // FE-2 (GROOV-4923): a scanned BoxChamp box barcode is a box-verify scan — navigate
      // to that box and mark it verified, NOT a product scan. D-9 guarantees a box barcode
      // never equals a product barcode, so this never steals a product scan; manual boxes
      // carry no barcode, so it is a no-op without BoxChamp (works without multi_box_shipments).
      const boxMatch = matchScannedBox(bar_code, this.props?.Order?.boxes);
      if (boxMatch.isBoxScan) {
        const matchedBox = this.props?.Order?.boxes?.[boxMatch.matchedIndex];
        const verifiedBoxIds = Array.from(
          new Set([...(this.state.verifiedBoxIds || []), matchedBox?.id])
        );
        this.boxChampPlaySuccessSound();
        this.setState({activeBoxIndex: boxMatch.matchedIndex, verifiedBoxIds, bar_code: ''});
        this.boxChampShowConfirmation(`${matchedBox?.name || 'Box'} verified.`);
        return;
      }
      // GS1-128 must have GTIN (01) + at least one additional AI code
      const gs1BarcodeRegex =
        /^01(\d{14})((15\d{6})|(21\w{1,20})|(11\d{6})|(17\d{6})|(10\w{1,20})).*/;

      const gs1Match = formattedBarcode.match(gs1BarcodeRegex);
      if (gs1Match) {
        const modifiedStr = formattedBarcode.slice(2);
        const orignalBarcode = modifiedStr.substring(0, 14);
        bar_code = orignalBarcode;
      }

      let currentItem =
        unscanned_items.length > 0
          ? unscanned_items.find(item =>
              (item.barcodes || []).some(barcodeObj =>
                barcodeEntryMatches(barcodeObj, bar_code)
              )
            )
          : null;
      currentItem =
        unscanned_items[0].child_items && !currentItem
          ? unscanned_items[0].child_items.find(item =>
              (item.barcodes || []).some(barcodeObj =>
                barcodeEntryMatches(barcodeObj, bar_code)
              )
            )
          : currentItem;
      let foundWithExtractedGTIN = currentItem ? true : false;
      let remain_qty = currentItem ? currentItem.qty_remaining : null;
      bar_code = product_confirm;
      if (type === 'item_present') {
        bar_code = clickBarcode;
        event_code = clickBarcode;
        let tempArr = [
          {
            // barcode: "noBarcode",
            barcode: ' ',
            id: 0,
            is_multipack_barcode: true,
            packing_count: '1'
          }
        ];
        // console.log("order check here man--->",order.order)
        order.order.unscanned_items.map((noCode, index) => {
          // debugger
          if (noCode.barcodes && noCode.barcodes.length === 0) {
            noCode.barcodes = tempArr;
          }
          if (noCode.child_items && noCode.child_items.length > 0) {
            noCode.child_items.map((childCode, index) => {
              if (childCode.barcodes && childCode.barcodes.length === 0) {
                childCode.barcodes = tempArr;
              }
            });
            // noCode.barcodes = tempArr
          }
        });

        order.order.scanned_items.length > 0 &&
          order.order.scanned_items.map((noCode, index) => {
            if (noCode.barcodes && noCode.barcodes.length === 0) {
              noCode.barcodes = tempArr;
            }
          });
      } else {
        let input = this.getBarcodeInputValue();
        bar_code = input === '' ? this.state.forSerialRecord : input;
      }
      let findKit3 = false;
      let log = this.state.log;
      let order_num = order.order.id;
      let next_state = order.next_state;
      let general_settings = this.state.general_settings;
      let master_switch = general_settings && general_settings.master_switch;
      let temp_order = {};
      let stop_add_log = false;
      let lowercase = false;
      let skipError = false;
      let event_scanned = false;
      let SKU = '';
      let Log_count = '';
      let localLogs = this.state.localLogs;
      let product_name = '';
      let rejectLocalLog = true;
      let Action_Type = '';
      let order_complete_flag = false;
      let qty_remain = 0;
      let swapunscan = 0;
      // start logic for scanning_sequence
      const setClickAttributes = unscanned_items => {
        processClickAndPassScan(unscanned_items, this.clickScan);
        addLog = false;
        skipError = true;
        ActionBarcode = true;
      };

      const processPartialRemoveBarcode = () => {
        skipError = true;
        if (this.boxChampCompletionDeferred()) {
          this.responseAction('scan_success');
          ActionBarcode = true;
          return;
        }
        this.responseAction('order_complete');
        if (!this.isBoxChampCompletionPending()) {
          setTimeout(() => {
            this.props.navigation.navigate('ScanPack');
          }, 100);
        }
        this.scannAllItems(this.props?.Order?.basicinfo?.id);
        ActionBarcode = true;
      };
      let scanAccess =
        scan_pack_settings.scanning_sequence === 'items_sequence' ? 0 : '';
      if (bar_code === 'RESTART' && scan_pack_settings.restart_code_enabled) {
        this.handleRestartPrompt();
      }
      if(scan_pack_settings?.not_fulfilled && bar_code === scan_pack_settings?.not_fulfilled_barcode){
        handleNotFulfilledBarcode(
          this.state.order,
          this.state.notFullFilledItems,
          this.setState.bind(this),
          this.responseAction,
          this.props.handleItemOutOfStock
        );
        return;
      }
      if (bar_code !== '') {
        if (
          scan_pack_settings.escape_string_enabled &&
          type !== 'item_present'
        ) {
          const result = processBarCode(bar_code, scan_pack_settings);
          bar_code = result.barCodeWithoutSpaces;
        }
        if (
          this.state.scan_pack_settings.string_removal_enabled &&
          barCodeInput
        ) {
          bar_code = removeStringFromBarcode(
            barCodeInput,
            this.state.scan_pack_settings.string_removal
          );
        }
        if (scan_pack_settings.note_from_packer_code_enabled) {
          if (scan_pack_settings.note_from_packer_code === bar_code) {
            stop_add_log = true;
            skipError = true;
            this.setState({
              alert: true,
              notes_fromPacker:
                notes_fromPacker === null ? '' : notes_fromPacker,
              noteFlag: true,
              bar_code: ''
            });
            barCodeInput = '';
          }
        }
        if (
          scan_pack_settings &&
          scan_pack_settings.restart_code_enabled &&
          scan_pack_settings.restart_code === bar_code
        ) {
          skipError = true;
          Action_Type = 'RESTART';
          ActionBarcode = true;
          // this.responseAction("restart_action_complete")
        }
        // Code for type count check
        if (scan_pack_settings.type_scan_code_enabled) {
          const result = checkTypeCount(
            scan_pack_settings,
            unscanned_items,
            this.showAlert,
            this.setTypeInCountModal,
            this.resetBarCodeInput,
            this.setStateCallback,
            this.state.typeScanState,
            typeInCountModal,
            bar_code
          );
          skipError = result?.skipError || skipError;
          stop_add_log = result?.stop_add_log || stop_add_log;
        }
        if (scan_pack_settings.scanned) {
          if (scan_pack_settings.scanned_barcode === bar_code && this.getBoxChampView() && !this.boxChampOrderPacked()) {
            skipError = true;
            ActionBarcode = true;
            notReadySound.play();
            clearTimeout(this._boxChampConfirmationTimer);
            this.setState({
              bar_code: '',
              boxChampSetAsideMessage: 'Scan-all is not available on a planned order — pack it box by box',
              boxChampSetAsideConfirmation: false
            });
          } else if (scan_pack_settings.scanned_barcode === bar_code) {
            skipError = true;
            event_scanned = true;
            barcode_copy = bar_code;
            let Order = this.state.order && this.state.order.order;
            Order['unscanned_items'] = [];
            this.setState({Order});
            this.responseAction('order_complete');
            this.scannAllItems(this.props?.Order?.basicinfo?.id);
            ActionBarcode = true;
            // stop_add_log = true
          }
        }
        if (scan_pack_settings.service_issue_code_enabled) {
          if (scan_pack_settings.service_issue_code === bar_code) {
            this.setState({
              alert: true,
              notes_fromPacker:
                notes_fromPacker === null ? '' : notes_fromPacker,
              issueFlag: true
            });
            skipError = true;
          }
        }
        if (scan_pack_settings.click_scan) {
          if (scan_pack_settings.click_scan_barcode === bar_code) {
            setClickAttributes(unscanned_items);
            return;
          }
        }
        if (scan_pack_settings.pass_scan) {
          if (scan_pack_settings.pass_scan_barcode === bar_code) {
            setClickAttributes(unscanned_items);
            return;
          }
        }
        if (scan_pack_settings.add_next) {
          if (scan_pack_settings.add_next_barcode === bar_code) {
            this.setState({addItemToOrder: true});
            return;
          }
        }
        if (unscanned_items[0]?.product_type === 'individual') {
          // debugger
          if (
            unscanned_items[0].child_items &&
            unscanned_items[0].child_items.length > 0
          ) {
            if (
              scan_pack_settings.remove_barcode &&
              scan_pack_settings.remove_barcode === bar_code
            ) {
              SKU = unscanned_items[0].child_items[0].sku;
              product_id = unscanned_items[0].product_id;
              product_main_id = unscanned_items[0].child_items[0].product_id;
              unscanned_items[0].child_items.shift();
              unscanned_items[0].child_items.length === 0 &&
                unscanned_items.shift();
              this.responseAction('scan_success');
              skipError = true;
              ActionBarcode = true;
            }
            if (
              scan_pack_settings.partial &&
              scan_pack_settings.partial_barcode === bar_code
            ) {
              processPartialRemoveBarcode();
            }
          }
        } else {
          if (unscanned_items && unscanned_items.length > 0) {
            if (
              scan_pack_settings.remove_enabled &&
              scan_pack_settings.remove_barcode === bar_code
            ) {
              product_id = unscanned_items[0].product_id;
              SKU = unscanned_items[0].sku;
              unscanned_items.shift();
              this.responseAction('scan_success');
              skipError = true;
              ActionBarcode = true;
            }
            if (
              scan_pack_settings.partial &&
              scan_pack_settings.partial_barcode === bar_code
            ) {
              processPartialRemoveBarcode();
            }
          }
        }
        if (
          scan_pack_settings.scanning_sequence === 'any_sequence' ||
          (scan_pack_settings.scanning_sequence === 'kit_packing_mode' &&
            master_switch === false)
        ) {
          bar_code = bar_code.toLowerCase();
          lowercase = true;
        }

        if (unscanned_items.length > 0) {
          if (
            scan_pack_settings.scanning_sequence === 'any_sequence'
              ? 'any_sequence'
              : 'items_sequence' ||
                scan_pack_settings.scanning_sequence === 'kit_packing_mode'
              ? 'kit_packing_mode'
              : 'items_sequence'
          ) {
            let scanpush = false;
            let itemFound = false;
            let listPartially_Scanned = [];
            let formattedBarCodeForMatching = this.formatBarCode(bar_code) || bar_code;
            if (formattedBarCodeForMatching !== bar_code && originalScannedBarcode && !foundWithExtractedGTIN) {
              // Keep bar_code as is
            } else {
              bar_code = formattedBarCodeForMatching;
            }
            unscanned_items.length > 0 &&
              unscanned_items.map((item, index) => {
                swapunscan = index;
                const result = skipBarcodeFunction(
                  lowercase,
                  bar_code,
                  scan_pack_settings,
                  item,
                  unscanned_items,
                  index,
                  this.showAlert,
                  this.responseAction
                );

                sku = result.sku || sku;
                product_id = result.product_id || product_id;
                qty_remain = result.qty_remain || qty_remain;
                itemFound = result.itemFound || itemFound;
                order_complete_flag =
                  result.order_complete_flag || order_complete_flag;
                kitItem = result.kitItem || kitItem;
                ActionBarcode = result.ActionBarcode || ActionBarcode;
                // for Partially_Scanned logic start
                // console.log("partially-scan",item.partially_scanned)
                if (
                  item.partially_scanned == true &&
                  item.child_items.length > 0
                ) {
                  // listPartially_Scanned
                  item.child_items.map(unscanItem => {
                    (unscanItem.barcodes || []).map(bar => {
                      if (
                        item['qty_remain'] +
                          unscanItem['product_qty_in_kit'] -
                          unscanItem['product_qty_in_kit'] <
                        unscanItem['qty_remaining']
                      )
                        listPartially_Scanned.push(bar['barcode']);
                    });
                  });
                }
                // console.log("line no 1866 ",index)
                scanAccess =
                  scan_pack_settings.scanning_sequence === 'items_sequence'
                    ? 0
                    : index;
                if (index === scanAccess) {
                  {
                    item &&
                    item.product_type === 'individual' &&
                    item.child_items &&
                    item.child_items.length > 0
                      ? item &&
                        item.child_items.map((childItem, childIndex) => {
                          // debugger
                          scanAccess =
                            scan_pack_settings.scanning_sequence ===
                            'items_sequence'
                              ? 0
                              : childIndex;
                          if (childIndex === scanAccess) {
                            (childItem.barcodes || []).map(barcode => {
                              // debugger
                              let Barcode =
                                lowercase === true
                                  ? barcode.barcode?.toLowerCase()
                                  : barcode.barcode;
                              if (
                                Barcode === bar_code &&
                                scanpush === false &&
                                item.qty_remaining > 0
                              ) {
                                // childItem qty_remaining assign to remain_qty for multi-pack barcode issue resolve
                                remain_qty = childItem.qty_remaining;
                                let serialScanAccess = false;
                                if (
                                  enableSerial ||
                                  (childItem.record_serial === false &&
                                    childItem.second_record_serial === false)
                                ) {
                                  serialScanAccess = true;
                                } else {
                                  if (
                                    childItem.record_serial ||
                                    childItem.second_record_serial
                                  ) {
                                    let eventType =
                                      type === 'item_present'
                                        ? 'clickscan'
                                        : 'barcode';
                                    rejectLocalLog = false;
                                    // for serial record text
                                    if (childItem.record_serial) {
                                      this.setState({
                                        serialRecordText: i18n.t(
                                          'serialRecord.serial_number'
                                        )
                                      });
                                    } else if (
                                      childItem.record_serial === false &&
                                      childItem.second_record_serial === true
                                    ) {
                                      this.setState({
                                        serialRecordText: i18n.t(
                                          'serialRecord.serial_number_two'
                                        )
                                      });
                                    }
                                    currentItemForSerialScan = childItem;
                                    isSerialScan = true;
                                    SKU = childItem.sku;
                                    this.setState({
                                      serialRecordPopUpShow: true,
                                      type: eventType
                                    });
                                  }
                                }
                                if (
                                  blockScan === false ||
                                  confirmProductConfirmation === true
                                ) {
                                  if (serialScanAccess) {
                                    let result;
                                    if (scanned_items.length > 0) {
                                      scanned_items.map(
                                        (scan, scanItemIndex) => {
                                          (scan.barcodes || []).map(scancode => {
                                            let Scancode =
                                              lowercase === true
                                                ? scancode.barcode?.toLowerCase()
                                                : scancode.barcode;
                                            result = handleScanning(
                                              scanItemIndex,
                                              swapunscan,
                                              childIndex,
                                              scan,
                                              barcode,
                                              bar_code,
                                              Scancode,
                                              scancode,
                                              type,
                                              childItem,
                                              Barcode,
                                              item,
                                              unscanned_items,
                                              scanned_items,
                                              scanpush,
                                              this.setStateCallback,
                                              scanAccess
                                            );
                                            SKU = result.SKU || SKU;
                                            Log_count =
                                              result.Log_count || Log_count;
                                            product_id =
                                              result.product_id || product_id;
                                            is_kit = result.is_kit || is_kit;
                                            product_name =
                                              result.product_name ||
                                              product_name;
                                            qty_remain =
                                              result.qty_remain || qty_remain;
                                            scanned_items =
                                              result?.scanned_items ||
                                              scanned_items;
                                            unscanned_items =
                                              result?.unscanned_items ||
                                              unscanned_items;
                                            (item = result.item || item),
                                              (childItem =
                                                result.childItem || childItem);
                                            scanpush =
                                              result.scanpush || scanpush;
                                          });
                                        }
                                      );
                                    } else {
                                      if (
                                        Barcode === bar_code &&
                                        childItem.qty_remaining >=
                                          parseInt(barcode.packing_count)
                                      ) {
                                        let result = handleScanningForUnscan(
                                          childItem,
                                          scanpush,
                                          type,
                                          barcode,
                                          item,
                                          childIndex,
                                          scanAccess,
                                          swapunscan,
                                          unscanned_items,
                                          scanned_items,
                                          index,
                                          this.setStateCallback
                                        );
                                        childItem =
                                          result.childItem || childItem;
                                        type = result.type || type;
                                        childIndex =
                                          result.childIndex || childIndex;
                                        is_kit = result.is_kit || is_kit;
                                        product_name =
                                          result.product_name || product_name;
                                        qty_remain =
                                          result.qty_remain || qty_remain;
                                        scanned_items =
                                          result?.scanned_items ||
                                          scanned_items;
                                        unscanned_items =
                                          result?.unscanned_items ||
                                          unscanned_items;
                                        (item = result.item || item),
                                          (childItem =
                                            result.childItem || childItem);
                                        scanpush = result.scanpush || scanpush;
                                        scanAccess =
                                          result.scanAccess || scanAccess;
                                        swapunscan =
                                          result.swapunscan || swapunscan;
                                        index = result.index || index;
                                        Log_count =
                                          result.Log_count || Log_count;
                                      }
                                    }
                                    if (unscanned_items.length > 0) {
                                      if (serialScanAccess) {
                                        if (type === 'item_present') {
                                          barcode_copy = Barcode;
                                          this.responseAction('scan_success');
                                        } else {
                                          // remain_qty
                                          if (
                                            remain_qty >=
                                            parseInt(barcode.packing_count)
                                          ) {
                                            barcode_copy = Barcode;
                                            this.responseAction('scan_success');
                                          } else {
                                            this.alertBox(
                                              i18n.t(
                                                'scanpackItem.Scanpack_multipack_msg'
                                              )
                                            );
                                          }
                                        }
                                      }
                                    } else {
                                      barcode_copy = Barcode;
                                      order_complete_flag = true;
                                      if (this.boxChampCompletionDeferred()) {
                                        this.responseAction('scan_success');
                                      } else {
                                      this.responseAction('order_complete');
                                      if (scan_pack_settings.post_scanning_option === 'None' && scan_pack_settings.post_scanning_option_second === 'None')
                                       {
                                        this.scannAllItems(
                                          this.props?.Order?.basicinfo?.id
                                        );
                                      }
                                      }
                                    }
                                    if (
                                      (this.state.blockItemToScan &&
                                        this.state.blockItemToScan.name !==
                                          childItem.name) ||
                                      childItem.qty_remaining === 0
                                    ) {
                                      confirmProductConfirmation = false;
                                    }
                                  } else {
                                    //changes for GROOV-3330 kit item issue
                                    // order_complete_flag = true;
                                    // this.responseAction("order_complete")
                                  }
                                  if (
                                    (this.state.blockItemToScan &&
                                      this.state.blockItemToScan.name !==
                                        childItem.name) ||
                                    childItem.qty_remaining === 0
                                  ) {
                                    confirmProductConfirmation = false;
                                  }
                                  itemFound = true;
                                }
                              }
                            });
                          }
                        })
                      : item && item.product_type === 'depends'
                      ? item &&
                        (item.barcodes || []).map((barcode, barcodeIndex) => {
                          let Barcode =
                            lowercase === true
                              ? barcode.barcode?.toLowerCase()
                              : barcode.barcode;
                          let mainItem = false;
                          //We will work form here
                          unscanned_items.map(un => {
                            // debugger
                            (un.barcodes || []).map(bar => {
                              if (bar.barcode === bar_code) {
                                mainItem = true;
                              }
                            });
                          });
                          if (Barcode === bar_code && scanpush === false) {
                            // debugger
                            let serialScanAccess = false;
                            if (
                              enableSerial ||
                              (item.record_serial === false &&
                                item.second_record_serial === false)
                            ) {
                              serialScanAccess = true;
                            } else {
                              if (
                                item.record_serial ||
                                item.second_record_serial
                              ) {
                                let eventType =
                                  type === 'item_present'
                                    ? 'clickscan'
                                    : 'barcode';
                                rejectLocalLog = false;
                                // for serial record text
                                if (item.record_serial) {
                                  this.setState({
                                    serialRecordText: i18n.t(
                                      'serialRecord.serial_number'
                                    )
                                  });
                                } else if (
                                  item.record_serial === false &&
                                  item.second_record_serial === true
                                ) {
                                  this.setState({
                                    serialRecordText: i18n.t(
                                      'serialRecord.serial_number_two'
                                    )
                                  });
                                }
                                this.setState({
                                  serialRecordPopUpShow: true,
                                  type: eventType
                                });
                              }
                            }
                            if (confirmProductConfirmation === false) {
                            }
                            if (
                              blockScan === false ||
                              confirmProductConfirmation === true
                            ) {
                              if (serialScanAccess) {
                                if (scanned_items.length > 0) {
                                  scanned_items.map((scan, scanIndex) => {
                                    (scan.barcodes || []).map(
                                      (scancode, scancodeIndex) => {
                                        let Scancode =
                                          lowercase === true
                                            ? scancode.barcode?.toLowerCase()
                                            : scancode.barcode;
                                        if (
                                          type === 'item_present'
                                            ? item.qty_remaining >= 1
                                            : item.qty_remaining >=
                                              parseInt(barcode.packing_count)
                                        ) {
                                          let result = scanForNoBarocode(
                                            Scancode,
                                            scancode,
                                            item,
                                            bar_code,
                                            scanpush,
                                            Barcode,
                                            barcode,
                                            unscanned_items,
                                            this.setStateCallback,
                                            scan,
                                            scanned_items,
                                            scanAccess,
                                            type,
                                            scanIndex
                                          );
                                          (item = result.item || item),
                                            (SKU = result.SKU || SKU),
                                            (scan = result.scan || scan),
                                            (scanned_items =
                                              result.scanned_items ||
                                              scanned_items),
                                            (Log_count =
                                              result.Log_count || Log_count),
                                            (scanpush =
                                              result.scanpush || scanpush),
                                            (product_name =
                                              result.product_name ||
                                              product_name),
                                            (qty_remain =
                                              result.qty_remain || qty_remain);
                                        }
                                      }
                                    );
                                  });
                                } else {
                                  if (
                                    Barcode === bar_code &&
                                    item.qty_remaining >=
                                      parseInt(barcode.packing_count)
                                  ) {
                                    // debugger
                                    if (
                                      item.qty_remaining === 1 &&
                                      scanpush === false
                                    ) {
                                      if (type === 'item_present') {
                                        item.qty_remaining =
                                          item.qty_remaining - 1;
                                        item.scanned_qty = item.scanned_qty + 1;
                                      } else {
                                        item.qty_remaining =
                                          item.qty_remaining -
                                          parseInt(barcode.packing_count);
                                        item.scanned_qty =
                                          item.scanned_qty +
                                          parseInt(barcode.packing_count);
                                      }
                                      // scanned_items.push(item)
                                      scanned_items.splice(0, 0, item);
                                      // debugger
                                      unscanned_items.splice(scanAccess, 1);
                                      this.setState({
                                        typeScanState: item.sku
                                      });
                                      scanpush = true;
                                      SKU = item.sku;
                                      Log_count = barcode.packing_count;
                                      product_name = item.name;
                                      qty_remain = item.qty_remaining;
                                    } else {
                                      if (scanpush === false) {
                                        if (type === 'item_present') {
                                          item.qty_remaining =
                                            item.qty_remaining - 1;
                                          item.scanned_qty =
                                            item.scanned_qty + 1;
                                        } else {
                                          item.qty_remaining =
                                            item.qty_remaining -
                                            parseInt(barcode.packing_count);
                                          item.scanned_qty =
                                            item.scanned_qty +
                                            parseInt(barcode.packing_count);
                                        }
                                        // scanned_items.push(item)
                                        scanned_items.splice(0, 0, item);
                                        this.setState({
                                          typeScanState: item.sku
                                        });
                                        scanpush = true;
                                        SKU = item.sku;
                                        Log_count = barcode.packing_count;
                                        product_name = item.name;
                                        qty_remain = item.qty_remaining;
                                      }
                                    }
                                  }
                                }
                              }
                              if (unscanned_items.length > 0) {
                                if (serialScanAccess) {
                                  if (type === 'item_present') {
                                    barcode_copy = Barcode;
                                    this.responseAction('scan_success');
                                  } else {
                                    if (
                                      remain_qty >=
                                      parseInt(barcode.packing_count)
                                    ) {
                                      barcode_copy = Barcode;
                                      this.InputField.current.focus();
                                      this.responseAction('scan_success');
                                    } else {
                                      this.alertBox(
                                        i18n.t(
                                          'scanpackItem.Scanpack_multipack_msg'
                                        )
                                      );
                                    }
                                  }
                                }
                              } else {
                                barcode_copy = Barcode;
                                order_complete_flag = true;
                                // this.responseAction("order_complete")
                              }
                              itemFound = true;
                              if (
                                (this.state.blockItemToScan &&
                                  this.state.blockItemToScan.name !==
                                    item.name) ||
                                item?.qty_remaining === 0
                              ) {
                                confirmProductConfirmation = false;
                              }
                            }
                          } else {
                            if (
                              item.product_type === 'depends' &&
                              mainItem === false
                            ) {
                              item &&
                                item.child_items.map(
                                  (childItem, childItemIndex) => {
                                    // debugger
                                    (childItem.barcodes || []).map(
                                      (
                                        childItemBarcode,
                                        childItemBarcodeIndex
                                      ) => {
                                        let Barcode =
                                          lowercase === true
                                            ? childItemBarcode.barcode?.toLowerCase()
                                            : childItemBarcode.barcode;
                                        // let serialScanAccess = false
                                        if (
                                          Barcode === bar_code &&
                                          scanpush === false &&
                                          item.qty_remaining > 0
                                        ) {
                                          let serialScanAccess = false;
                                          if (
                                            enableSerial ||
                                            (childItem.record_serial ===
                                              false &&
                                              childItem.second_record_serial ===
                                                false)
                                          ) {
                                            serialScanAccess = true;
                                          } else {
                                            if (
                                              childItem.record_serial ||
                                              childItem.second_record_serial
                                            ) {
                                              let eventType =
                                                type === 'item_present'
                                                  ? 'clickscan'
                                                  : 'barcode';
                                              rejectLocalLog = false;
                                              // for serial record text
                                              if (childItem.record_serial) {
                                                this.setState({
                                                  serialRecordText: i18n.t(
                                                    'serialRecord.serial_number'
                                                  )
                                                });
                                              } else if (
                                                childItem.record_serial ===
                                                  false &&
                                                childItem.second_record_serial ===
                                                  true
                                              ) {
                                                this.setState({
                                                  serialRecordText: i18n.t(
                                                    'serialRecord.serial_number_two'
                                                  )
                                                });
                                              }
                                              this.setState({
                                                serialRecordPopUpShow: true,
                                                type: eventType
                                              });
                                            }
                                          }
                                          if (serialScanAccess) {
                                            let tempItem = Object.assign(
                                              {},
                                              item
                                            );
                                            let tempItem1 = Object.assign(
                                              {},
                                              item
                                            );
                                            let tempItemChildArr = [];
                                            let tempItem1ChildArr = [];
                                            let arr = [];
                                            tempItem.qty_remaining = 1;
                                            tempItem.product_type =
                                              'individual';
                                            let kitDivide =
                                              tempItem1.total_qty ||
                                              tempItem1.qty_remaining +
                                                (tempItem1.scanned_qty || 0);
                                            if (!kitDivide || kitDivide <= 0) {
                                              kitDivide = 1;
                                            }
                                            tempItem.child_items.map(child => {
                                              let newCopy = Object.assign(
                                                {},
                                                child
                                              );
                                              const originalTotalQty =
                                                Math.max(
                                                  child.total_qty || 0,
                                                  child.qty_remaining +
                                                    (child.scanned_qty || 0)
                                                );
                                              const perKitQty =
                                                originalTotalQty / kitDivide;
                                              const perKitScannedQty =
                                                (child.scanned_qty || 0) /
                                                kitDivide;
                                              newCopy.total_qty =
                                                originalTotalQty;
                                              newCopy.qty_remaining =
                                                perKitQty;
                                              newCopy.scanned_qty =
                                                perKitScannedQty;
                                              tempItemChildArr.push(newCopy);
                                            });
                                            tempItem.child_items =
                                              tempItemChildArr;
                                            tempItem1.qty_remaining =
                                              tempItem1.qty_remaining - 1;
                                            tempItem1.product_type =
                                              'depends';
                                            tempItem1.child_items.map(
                                              childTemp => {
                                                let newCopy = Object.assign(
                                                  {},
                                                  childTemp
                                                );
                                                const originalTotalQty =
                                                  Math.max(
                                                    childTemp.total_qty || 0,
                                                    childTemp.qty_remaining +
                                                      (childTemp.scanned_qty ||
                                                        0)
                                                  );
                                                const perKitQty =
                                                  originalTotalQty / kitDivide;
                                                const perKitScannedQty =
                                                  (childTemp.scanned_qty || 0) /
                                                  kitDivide;
                                                const finalQtyRemaining =
                                                  childTemp.qty_remaining -
                                                  perKitQty;
                                                const finalScannedQty =
                                                  (childTemp.scanned_qty || 0) -
                                                  perKitScannedQty;
                                                newCopy.total_qty =
                                                  originalTotalQty;
                                                newCopy.qty_remaining =
                                                  finalQtyRemaining;
                                                newCopy.scanned_qty =
                                                  finalScannedQty;
                                                tempItem1ChildArr.push(newCopy);
                                                tempItem1.child_items =
                                                  tempItem1ChildArr;
                                                arr.push(tempItem, tempItem1);
                                              }
                                            );
                                            // unscanned_items[index] = arr[0]
                                            // if(arr[1].qty_remaining > 1){
                                            if (arr[1]?.qty_remaining > 0) {
                                              unscanned_items.splice(
                                                index,
                                                1,
                                                arr[0],
                                                arr[1]
                                              );
                                            } else {
                                              unscanned_items.splice(
                                                index,
                                                1,
                                                arr[0]
                                              );
                                            }
                                            // }
                                          }
                                          unscanned_items.map(
                                            (
                                              updateProduct,
                                              updateProductIndex
                                            ) => {
                                              updateProduct &&
                                                updateProduct.child_items &&
                                                updateProduct.child_items.map(
                                                  (
                                                    updateChildItem,
                                                    updatedChildItemIndex
                                                  ) => {
                                                    (updateChildItem.barcodes || []).map(
                                                      barcode => {
                                                        let Barcode =
                                                          lowercase === true
                                                            ? barcode.barcode?.toLowerCase()
                                                            : barcode.barcode;
                                                        // debugger

                                                        if (
                                                          Barcode ===
                                                            bar_code &&
                                                          scanpush === false
                                                        ) {
                                                          let serialScanAccess = false;
                                                          if (
                                                            enableSerial ||
                                                            (updateChildItem.record_serial ===
                                                              false &&
                                                              updateChildItem.second_record_serial ===
                                                                false)
                                                          ) {
                                                            serialScanAccess = true;
                                                          } else {
                                                            if (
                                                              updateChildItem.record_serial ||
                                                              updateChildItem.second_record_serial
                                                            ) {
                                                              let eventType =
                                                                type ===
                                                                'item_present'
                                                                  ? 'clickscan'
                                                                  : 'barcode';
                                                              rejectLocalLog = false;
                                                              // for serial record text
                                                              if (
                                                                updateChildItem.record_serial
                                                              ) {
                                                                this.setState({
                                                                  serialRecordText:
                                                                    i18n.t(
                                                                      'serialRecord.serial_number'
                                                                    )
                                                                });
                                                              } else if (
                                                                updateChildItem.record_serial ===
                                                                  false &&
                                                                updateChildItem.second_record_serial ===
                                                                  true
                                                              ) {
                                                                this.setState({
                                                                  serialRecordText:
                                                                    i18n.t(
                                                                      'serialRecord.serial_number_two'
                                                                    )
                                                                });
                                                              }
                                                              this.setState({
                                                                serialRecordPopUpShow: true,
                                                                type: eventType
                                                              });
                                                            }
                                                          }
                                                          if (
                                                            confirmProductConfirmation ===
                                                            false
                                                          ) {
                                                          }
                                                          if (
                                                            blockScan ===
                                                              false ||
                                                            confirmProductConfirmation ===
                                                              true
                                                          ) {
                                                            if (
                                                              serialScanAccess
                                                            ) {
                                                              if (
                                                                scanned_items.length >
                                                                0
                                                              ) {
                                                                scanned_items.map(
                                                                  (
                                                                    scan,
                                                                    scanIndex
                                                                  ) => {
                                                                    (scan.barcodes || []).map(
                                                                      scancode => {
                                                                        let Scancode =
                                                                          lowercase ===
                                                                          true
                                                                            ? scancode.barcode?.toLowerCase()
                                                                            : scancode.barcode;
                                                                        if (
                                                                          type ===
                                                                          'item_present'
                                                                            ? updateChildItem.qty_remaining >=
                                                                              1
                                                                            : updateChildItem.qty_remaining >=
                                                                              parseInt(
                                                                                barcode.packing_count
                                                                              )
                                                                        ) {
                                                                          if (
                                                                            Scancode ===
                                                                              Barcode &&
                                                                            Scancode ===
                                                                              bar_code &&
                                                                            scan.order_item_id ===
                                                                              item.order_item_id
                                                                          ) {
                                                                            if (
                                                                              scan.qty_remaining ===
                                                                                1 &&
                                                                              scanpush ===
                                                                                false
                                                                            ) {
                                                                              if (
                                                                                type ===
                                                                                'item_present'
                                                                              ) {
                                                                                updateChildItem.scanned_qty =
                                                                                  updateChildItem.scanned_qty +
                                                                                  1;
                                                                                updateChildItem.qty_remaining =
                                                                                  updateChildItem.qty_remaining -
                                                                                  1;
                                                                                //scan.scanned_qty = updateChildItem.scanned_qty
                                                                                //scan.qty_remaining = updateChildItem.qty_remaining
                                                                              } else {
                                                                                updateChildItem.scanned_qty =
                                                                                  updateChildItem.scanned_qty +
                                                                                  parseInt(
                                                                                    barcode.packing_count
                                                                                  );
                                                                                updateChildItem.qty_remaining =
                                                                                  updateChildItem.qty_remaining -
                                                                                  parseInt(
                                                                                    barcode.packing_count
                                                                                  );
                                                                                //scan.scanned_qty = updateChildItem.scanned_qty
                                                                                //scan.qty_remaining = updateChildItem.qty_remaining
                                                                              }
                                                                              updateProduct.child_items.splice(
                                                                                updatedChildItemIndex,
                                                                                1
                                                                              );
                                                                              scanned_items.splice(
                                                                                scanIndex,
                                                                                1
                                                                              );
                                                                              scanned_items.splice(
                                                                                0,
                                                                                0,
                                                                                scan
                                                                              );
                                                                              this.setState(
                                                                                {
                                                                                  typeScanState:
                                                                                    updateChildItem.sku
                                                                                }
                                                                              );
                                                                              scanpush = true;
                                                                              SKU =
                                                                                updateChildItem.sku;
                                                                              Log_count =
                                                                                barcode.packing_count;
                                                                              product_name =
                                                                                updateChildItem.name;
                                                                              qty_remain =
                                                                                updateChildItem.qty_remaining;
                                                                            } else {
                                                                              if (
                                                                                scan.qty_remaining >
                                                                                  0 &&
                                                                                scanpush ===
                                                                                  false
                                                                              ) {
                                                                                if (
                                                                                  type ===
                                                                                  'item_present'
                                                                                ) {
                                                                                  updateChildItem.scanned_qty =
                                                                                    updateChildItem.scanned_qty +
                                                                                    1;
                                                                                  updateChildItem.qty_remaining =
                                                                                    updateChildItem.qty_remaining -
                                                                                    1;
                                                                                  //scan.scanned_qty = updateChildItem.scanned_qty
                                                                                  //scan.qty_remaining = updateChildItem.qty_remaining
                                                                                  updateChildItem.qty_remaining ===
                                                                                    0 &&
                                                                                    updateProduct.child_items.splice(
                                                                                      index,
                                                                                      1
                                                                                    );
                                                                                } else {
                                                                                  updateChildItem.scanned_qty =
                                                                                    updateChildItem.scanned_qty +
                                                                                    parseInt(
                                                                                      barcode.packing_count
                                                                                    );
                                                                                  updateChildItem.qty_remaining =
                                                                                    updateChildItem.qty_remaining -
                                                                                    parseInt(
                                                                                      barcode.packing_count
                                                                                    );
                                                                                  //scan.scanned_qty = updateChildItem.scanned_qty
                                                                                  //scan.qty_remaining = updateChildItem.qty_remaining
                                                                                  updateChildItem.qty_remaining ===
                                                                                    0 &&
                                                                                    updateProduct.child_items.splice(
                                                                                      index,
                                                                                      1
                                                                                    );
                                                                                }
                                                                                scanned_items.splice(
                                                                                  scanIndex,
                                                                                  1
                                                                                );
                                                                                scanned_items.splice(
                                                                                  0,
                                                                                  0,
                                                                                  scan
                                                                                );
                                                                                this.setState(
                                                                                  {
                                                                                    typeScanState:
                                                                                      updateChildItem.sku
                                                                                  }
                                                                                );
                                                                                scanpush = true;
                                                                                SKU =
                                                                                  updateChildItem.sku;
                                                                                Log_count =
                                                                                  barcode.packing_count;
                                                                                product_name =
                                                                                  updateChildItem.name;
                                                                                qty_remain =
                                                                                  updateChildItem.qty_remaining;
                                                                              }
                                                                              if (
                                                                                updateChildItem.qty_remaining ===
                                                                                0
                                                                              ) {
                                                                                item.child_items.splice(
                                                                                  scanAccess,
                                                                                  1
                                                                                );
                                                                                item
                                                                                  .child_items
                                                                                  .length ===
                                                                                  0 &&
                                                                                  unscanned_items.splice(
                                                                                    index,
                                                                                    1
                                                                                  );
                                                                              }
                                                                            }
                                                                          } else {
                                                                            if (
                                                                              Barcode ===
                                                                                bar_code &&
                                                                              updateChildItem.qty_remaining >=
                                                                                1
                                                                            ) {
                                                                              if (
                                                                                updateChildItem.qty_remaining ===
                                                                                  1 &&
                                                                                scanpush ===
                                                                                  false
                                                                              ) {
                                                                                if (
                                                                                  type ===
                                                                                  'item_present'
                                                                                ) {
                                                                                  updateChildItem.qty_remaining =
                                                                                    updateChildItem.qty_remaining -
                                                                                    1;
                                                                                  updateChildItem.scanned_qty =
                                                                                    updateChildItem.scanned_qty +
                                                                                    1;
                                                                                } else {
                                                                                  updateChildItem.qty_remaining =
                                                                                    updateChildItem.qty_remaining -
                                                                                    parseInt(
                                                                                      barcode.packing_count
                                                                                    );
                                                                                  updateChildItem.scanned_qty =
                                                                                    updateChildItem.scanned_qty +
                                                                                    parseInt(
                                                                                      barcode.packing_count
                                                                                    );
                                                                                }
                                                                                //scanned_items.push(updateChildItem)
                                                                                scanned_items.splice(
                                                                                  0,
                                                                                  0,
                                                                                  updateChildItem
                                                                                );
                                                                                updateProduct.child_items.splice(
                                                                                  updatedChildItemIndex,
                                                                                  1
                                                                                );
                                                                                //scanned_items.splice(scanIndex , 1)
                                                                                //scanned_items.splice(0, 0, scan)
                                                                                this.setState(
                                                                                  {
                                                                                    typeScanState:
                                                                                      updateChildItem.sku
                                                                                  }
                                                                                );
                                                                                scanpush = true;
                                                                                SKU =
                                                                                  updateChildItem.sku;
                                                                                Log_count =
                                                                                  barcode.packing_count;
                                                                                product_name =
                                                                                  updateChildItem.name;
                                                                                qty_remain =
                                                                                  updateChildItem.qty_remaining;
                                                                              } else {
                                                                                if (
                                                                                  scanpush ===
                                                                                  false
                                                                                ) {
                                                                                  if (
                                                                                    type ===
                                                                                    'item_present'
                                                                                  ) {
                                                                                    updateChildItem.qty_remaining =
                                                                                      updateChildItem.qty_remaining -
                                                                                      1;
                                                                                    updateChildItem.scanned_qty =
                                                                                      updateChildItem.scanned_qty +
                                                                                      1;
                                                                                    //scan.scanned_qty = updateChildItem.scanned_qty
                                                                                    //scan.qty_remaining = updateChildItem.qty_remaining
                                                                                  } else {
                                                                                    updateChildItem.qty_remaining =
                                                                                      updateChildItem.qty_remaining -
                                                                                      parseInt(
                                                                                        barcode.packing_count
                                                                                      );
                                                                                    updateChildItem.scanned_qty =
                                                                                      updateChildItem.scanned_qty +
                                                                                      parseInt(
                                                                                        barcode.packing_count
                                                                                      );
                                                                                    //scan.scanned_qty = updateChildItem.scanned_qty
                                                                                    //scan.qty_remaining = updateChildItem.qty_remaining
                                                                                  }
                                                                                  //scanned_items.push(updateChildItem)
                                                                                  scanned_items.splice(
                                                                                    0,
                                                                                    0,
                                                                                    updateChildItem
                                                                                  );
                                                                                  //scanned_items.splice(scanIndex , 1)
                                                                                  //scanned_items.splice(0, 0, scan)
                                                                                  this.setState(
                                                                                    {
                                                                                      typeScanState:
                                                                                        updateChildItem.sku
                                                                                    }
                                                                                  );
                                                                                  scanpush = true;
                                                                                  SKU =
                                                                                    updateChildItem.sku;
                                                                                  Log_count =
                                                                                    barcode.packing_count;
                                                                                  product_name =
                                                                                    updateChildItem.name;
                                                                                  qty_remain =
                                                                                    updateChildItem.qty_remaining;
                                                                                }
                                                                              }
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    );
                                                                  }
                                                                );
                                                              } else {
                                                                if (
                                                                  Barcode ===
                                                                    bar_code &&
                                                                  updateChildItem.qty_remaining >=
                                                                    parseInt(
                                                                      barcode.packing_count
                                                                    )
                                                                ) {
                                                                  if (
                                                                    updateChildItem.qty_remaining ===
                                                                      1 &&
                                                                    scanpush ===
                                                                      false
                                                                  ) {
                                                                    if (
                                                                      type ===
                                                                      'item_present'
                                                                    ) {
                                                                      updateChildItem.qty_remaining =
                                                                        updateChildItem.qty_remaining -
                                                                        1;
                                                                      updateChildItem.scanned_qty =
                                                                        updateChildItem.scanned_qty +
                                                                        1;
                                                                    } else {
                                                                      updateChildItem.qty_remaining =
                                                                        updateChildItem.qty_remaining -
                                                                        parseInt(
                                                                          barcode.packing_count
                                                                        );
                                                                      updateChildItem.scanned_qty =
                                                                        updateChildItem.scanned_qty +
                                                                        parseInt(
                                                                          barcode.packing_count
                                                                        );
                                                                    }
                                                                    //scanned_items.push(updateChildItem)
                                                                    scanned_items.splice(
                                                                      0,
                                                                      0,
                                                                      updateChildItem
                                                                    );
                                                                    updateProduct.child_items.splice(
                                                                      updatedChildItemIndex,
                                                                      1
                                                                    );
                                                                    // item.child_items.splice(scanAccess , 1 )
                                                                    // item.child_items.length === 0 && unscanned_items.splice(scanAccess , 1)
                                                                    this.setState(
                                                                      {
                                                                        typeScanState:
                                                                          updateChildItem.sku
                                                                      }
                                                                    );
                                                                    scanpush = true;
                                                                    SKU =
                                                                      updateChildItem.sku;
                                                                    Log_count =
                                                                      barcode.packing_count;
                                                                    product_name =
                                                                      updateChildItem.name;
                                                                    qty_remain =
                                                                      updateChildItem.qty_remaining;
                                                                  } else {
                                                                    if (
                                                                      scanpush ===
                                                                      false
                                                                    ) {
                                                                      if (
                                                                        type ===
                                                                        'item_present'
                                                                      ) {
                                                                        updateChildItem.qty_remaining =
                                                                          updateChildItem.qty_remaining -
                                                                          1;
                                                                        updateChildItem.scanned_qty =
                                                                          updateChildItem.scanned_qty +
                                                                          1;
                                                                      } else {
                                                                        updateChildItem.qty_remaining =
                                                                          updateChildItem.qty_remaining -
                                                                          parseInt(
                                                                            barcode.packing_count
                                                                          );
                                                                        updateChildItem.scanned_qty =
                                                                          updateChildItem.scanned_qty +
                                                                          parseInt(
                                                                            barcode.packing_count
                                                                          );
                                                                      }
                                                                      //scanned_items.push(updateChildItem)
                                                                      scanned_items.splice(
                                                                        0,
                                                                        0,
                                                                        updateChildItem
                                                                      );
                                                                      this.setState(
                                                                        {
                                                                          typeScanState:
                                                                            updateChildItem.sku
                                                                        }
                                                                      );
                                                                      scanpush = true;
                                                                      SKU =
                                                                        updateChildItem.sku;
                                                                      Log_count =
                                                                        barcode.packing_count;
                                                                      product_name =
                                                                        updateChildItem.name;
                                                                      qty_remain =
                                                                        updateChildItem.qty_remaining;
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                            if (
                                                              unscanned_items.length >
                                                              0
                                                            ) {
                                                              if (
                                                                serialScanAccess
                                                              ) {
                                                                if (
                                                                  type ===
                                                                  'item_present'
                                                                ) {
                                                                  this.responseAction(
                                                                    'scan_success'
                                                                  );
                                                                } else {
                                                                  if (
                                                                    remain_qty >=
                                                                    parseInt(
                                                                      barcode.packing_count
                                                                    )
                                                                  ) {
                                                                    this.responseAction(
                                                                      'scan_success'
                                                                    );
                                                                  } else {
                                                                    remain_qty &&
                                                                      remain_qty >=
                                                                        0 &&
                                                                      this.alertBox(
                                                                        i18n.t(
                                                                          'scanpackItem.Scanpack_multipack_msg'
                                                                        )
                                                                      );
                                                                  }
                                                                }
                                                              }
                                                            } else {
                                                              order_complete_flag = true;
                                                              // this.responseAction("order_complete")
                                                            }
                                                            itemFound = true;
                                                            if (
                                                              (this.state
                                                                .blockItemToScan &&
                                                                this.state
                                                                  .blockItemToScan
                                                                  .name !==
                                                                  updateChildItem.name) ||
                                                              updateChildItem.qty_remaining ===
                                                                0
                                                            ) {
                                                              confirmProductConfirmation = false;
                                                            }
                                                          }
                                                        }
                                                      }
                                                    );
                                                  }
                                                );
                                            }
                                          );
                                        }
                                      }
                                    );
                                  }
                                );
                              // debugger
                              item.qty_remaining === 0 &&
                                unscanned_items.splice(index, 1);
                            }
                          }
                        })
                      : item &&
                        (item.barcodes || []).map((barcode, index) => {
                          // debugger
                          let Barcode =
                            lowercase === true
                              ? barcode.barcode?.toLowerCase()
                              : barcode.barcode;
                          if (Barcode === bar_code && scanpush === false) {
                            let serialScanAccess = false;
                            if (
                              enableSerial ||
                              (item.record_serial === false &&
                                item.second_record_serial === false)
                            ) {
                              serialScanAccess = true;
                            } else {
                              if (
                                item.record_serial ||
                                item.second_record_serial
                              ) {
                                let eventType =
                                  type === 'item_present'
                                    ? 'clickscan'
                                    : 'barcode';
                                rejectLocalLog = false;
                                // for serial record text
                                if (item.record_serial) {
                                  currentItemForSerialScan = item;
                                  this.setState({
                                    serialRecordPopUpShow: true,
                                    type: eventType,
                                    forSerialRecord: bar_code,
                                    serialRecordText: i18n.t(
                                      'serialRecord.serial_number'
                                    )
                                  });

                                  // this.setState({ serialRecordText: "serial record one" })
                                } else if (
                                  item.record_serial === false &&
                                  item.second_record_serial === true
                                ) {
                                  this.setState({
                                    serialRecordPopUpShow: true,
                                    type: eventType,
                                    forSerialRecord: bar_code,
                                    serialRecordText: i18n.t(
                                      'serialRecord.serial_number_two'
                                    )
                                  });

                                  // this.setState({ serialRecordText: "serial record second" })
                                }
                                // this.setState({ serialRecordPopUpShow: true, type: eventType, forSerialRecord: bar_code })
                              }
                            }
                            if (
                              blockScan === false ||
                              confirmProductConfirmation === true
                            ) {
                              if (serialScanAccess) {
                                let indexScan = 0;
                                if (scanned_items.length > 0) {
                                  // for scanned product duplication fix with index
                                  scanned_items.map((scan, index) => {
                                    // debugger
                                    (scan.barcodes || []).map(barcode => {
                                      let Scancode =
                                        lowercase === true
                                          ? barcode.barcode?.toLowerCase()
                                          : barcode.barcode;
                                      if (
                                        type === 'item_present'
                                          ? item.qty_remaining >= 1
                                          : item.qty_remaining >=
                                            parseInt(barcode.packing_count)
                                      ) {
                                        if (
                                          Scancode === Barcode &&
                                          Barcode === bar_code &&
                                          item.order_item_id ===
                                            scan.order_item_id
                                        ) {
                                          // console.log("-------->", Scancode, index)
                                          indexScan = index;
                                        }
                                      }
                                    });
                                  });
                                  // end here duplication product logic
                                  scanned_items.map((scan, scanItemIndex) => {
                                    if (
                                      scan.order_item_id === item.order_item_id
                                    ) {
                                      (scan.barcodes || []).map(scancode => {
                                        let Scancode =
                                          lowercase === true
                                            ? scancode.barcode?.toLowerCase()
                                            : scancode.barcode;
                                        if (
                                          type === 'item_present'
                                            ? item.qty_remaining >= 1
                                            : item.qty_remaining >=
                                              parseInt(barcode.packing_count)
                                        ) {
                                          if (
                                            Scancode === Barcode &&
                                            Barcode === bar_code &&
                                            item.order_item_id ===
                                              scan.order_item_id
                                          ) {
                                            if (
                                              scan.qty_remaining === 1 &&
                                              scanpush === false
                                            ) {
                                              if (type === 'item_present') {
                                                item.qty_remaining =
                                                  item.qty_remaining - 1;
                                                item.scanned_qty =
                                                  item.scanned_qty + 1;
                                                // client issue resolve 24/02/22
                                                scan.qty_remaining =
                                                  item.qty_remaining;
                                                scan.scanned_qty =
                                                  item.scanned_qty;
                                              } else {
                                                if (item.qty_remaining > 0) {
                                                  item.qty_remaining =
                                                    item.qty_remaining -
                                                    parseInt(
                                                      barcode.packing_count
                                                    );
                                                  item.scanned_qty =
                                                    item.scanned_qty +
                                                    parseInt(
                                                      barcode.packing_count
                                                    );
                                                  scan.qty_remaining =
                                                    item.qty_remaining;
                                                  scan.scanned_qty =
                                                    item.scanned_qty;
                                                }
                                              }
                                              // console.log("scanne item11", swapunscan)
                                              // debugger
                                              unscanned_items.splice(
                                                scanAccess,
                                                1
                                              );

                                              scanned_items.splice(
                                                scanItemIndex,
                                                1
                                              );
                                              scanned_items.splice(0, 0, scan);
                                              this.setState({
                                                typeScanState: item.sku
                                              });
                                              scanpush = true;
                                              SKU = item.sku;
                                              Log_count = barcode.packing_count;
                                              product_name = item.name;
                                              qty_remain = item.qty_remaining;
                                            } else {
                                              if (
                                                scan.qty_remaining > 1 &&
                                                scanpush === false
                                              ) {
                                                // debugger
                                                if (
                                                  type === 'item_present' &&
                                                  item.qty_remaining > 0
                                                ) {
                                                  item.qty_remaining =
                                                    item.qty_remaining - 1;
                                                  item.scanned_qty =
                                                    item.scanned_qty + 1;
                                                  // unCommented these 2 line for client issues 25/01/22
                                                  scan.qty_remaining =
                                                    item.qty_remaining;
                                                  scan.scanned_qty =
                                                    item.scanned_qty;
                                                } else {
                                                  if (item.qty_remaining > 0) {
                                                    item.scanned_qty =
                                                      item.scanned_qty +
                                                      parseInt(
                                                        barcode.packing_count
                                                      );
                                                    item.qty_remaining =
                                                      item.qty_remaining -
                                                      parseInt(
                                                        barcode.packing_count
                                                      );
                                                    scan.qty_remaining =
                                                      item.qty_remaining;
                                                    scan.scanned_qty =
                                                      item.scanned_qty;
                                                    // console.log("item scanned qty===>",item.scanned_qty)
                                                    // console.log("item qty remaining check--->",item.qty_remaining)
                                                  }
                                                }
                                                // console.log("scanne item22", swapunscan)
                                                unscanned_items.splice(
                                                  swapunscan,
                                                  1
                                                );
                                                unscanned_items.unshift(item);
                                                scanned_items.splice(
                                                  scanItemIndex,
                                                  1
                                                );
                                                scanned_items.splice(
                                                  0,
                                                  0,
                                                  scan
                                                );
                                                this.setState({
                                                  typeScanState: item.sku
                                                });
                                                scanpush = true;
                                                SKU = item.sku;
                                                Log_count =
                                                  barcode.packing_count;
                                                product_name = item.name;
                                                qty_remain = item.qty_remaining;
                                                // console.log("qty_remain check here",qty_remain)
                                              }
                                              if (item.qty_remaining === 0) {
                                                // debugger
                                                unscanned_items.splice(
                                                  scanAccess,
                                                  1
                                                );
                                              }
                                            }
                                          } else {
                                            if (
                                              Scancode !== bar_code &&
                                              item.scanned_qty === 0
                                            ) {
                                              if (
                                                item.qty_remaining === 1 &&
                                                scanpush === false
                                              ) {
                                                if (type === 'item_present') {
                                                  item.qty_remaining =
                                                    item.qty_remaining - 1;
                                                  item.scanned_qty =
                                                    item.scanned_qty + 1;
                                                } else {
                                                  if (item.qty_remaining > 0) {
                                                    item.qty_remaining =
                                                      item.qty_remaining -
                                                      parseInt(
                                                        barcode.packing_count
                                                      );
                                                    item.scanned_qty =
                                                      item.scanned_qty +
                                                      parseInt(
                                                        barcode.packing_count
                                                      );
                                                  }
                                                }
                                                // scanned_items.push(item)
                                                // console.log("scanned item33", swapunscan)
                                                scanned_items.splice(
                                                  0,
                                                  0,
                                                  item
                                                );
                                                // debugger
                                                unscanned_items.splice(
                                                  scanAccess,
                                                  1
                                                );
                                                // debugger
                                                this.setState({
                                                  typeScanState: item.sku
                                                });
                                                scanpush = true;
                                                SKU = item.sku;
                                                Log_count =
                                                  barcode.packing_count;
                                                product_name = item.name;
                                                qty_remain = item.qty_remaining;
                                              } else {
                                                if (
                                                  scanpush === false &&
                                                  item.qty_remaining > 0
                                                ) {
                                                  if (type === 'item_present') {
                                                    item.qty_remaining =
                                                      item.qty_remaining - 1;
                                                    item.scanned_qty =
                                                      item.scanned_qty + 1;
                                                  } else {
                                                    if (
                                                      item.qty_remaining > 0
                                                    ) {
                                                      item.qty_remaining =
                                                        item.qty_remaining -
                                                        parseInt(
                                                          barcode.packing_count
                                                        );
                                                      item.scanned_qty =
                                                        item.scanned_qty +
                                                        parseInt(
                                                          barcode.packing_count
                                                        );
                                                    }
                                                  }
                                                  // scanned_items.push(item)
                                                  // console.log("scanned item---->", swapunscan)
                                                  unscanned_items.splice(
                                                    swapunscan,
                                                    1
                                                  );
                                                  unscanned_items.unshift(item);
                                                  scanned_items.splice(
                                                    0,
                                                    0,
                                                    item
                                                  );
                                                  this.setState({
                                                    typeScanState: item.sku
                                                  });
                                                  scanpush = true;
                                                  SKU = item.sku;
                                                  Log_count =
                                                    barcode.packing_count;
                                                  product_name = item.name;
                                                  qty_remain =
                                                    item.qty_remaining;
                                                }
                                              }
                                            }
                                          }
                                        }
                                      });
                                    } else {
                                      //share barcode start when barcode is same//
                                      if (
                                        Barcode === bar_code &&
                                        item.qty_remaining >=
                                          parseInt(barcode.packing_count)
                                      ) {
                                        if (
                                          item.qty_remaining === 1 &&
                                          scanpush === false
                                        ) {
                                          if (type === 'item_present') {
                                            item.qty_remaining =
                                              item.qty_remaining - 1;
                                            item.scanned_qty =
                                              item.scanned_qty + 1;
                                          } else {
                                            if (item.qty_remaining > 0) {
                                              item.qty_remaining =
                                                item.qty_remaining -
                                                parseInt(barcode.packing_count);
                                              item.scanned_qty =
                                                item.scanned_qty +
                                                parseInt(barcode.packing_count);
                                            }
                                          }
                                          // scanned_items.push(item)
                                          // console.log("scanned item",scanned_items)
                                          if (indexScan > 0) {
                                            scanned_items.splice(indexScan, 1);
                                          }
                                          // console.log("scanned item-22--->", swapunscan)

                                          scanned_items.splice(0, 0, item);
                                          // unscanned_items.splice(scanAccess, 1)
                                          // debugger
                                          unscanned_items.splice(scanAccess, 1);

                                          this.setState({
                                            typeScanState: item.sku
                                          });
                                          scanpush = true;
                                          SKU = item.sku;
                                          Log_count = barcode.packing_count;
                                          product_name = item.name;
                                          qty_remain = item.qty_remaining;
                                        } else {
                                          if (
                                            scanpush === false &&
                                            item.qty_remaining > 0
                                          ) {
                                            if (type === 'item_present') {
                                              item.qty_remaining =
                                                item.qty_remaining - 1;
                                              item.scanned_qty =
                                                item.scanned_qty + 1;
                                            } else {
                                              if (item.qty_remaining > 0) {
                                                item.qty_remaining =
                                                  item.qty_remaining -
                                                  parseInt(
                                                    barcode.packing_count
                                                  );
                                                item.scanned_qty =
                                                  item.scanned_qty +
                                                  parseInt(
                                                    barcode.packing_count
                                                  );
                                              }
                                            }
                                            // scanned_items.push(item)
                                            // scanned_items.splice(scanItemIndex , 1)
                                            // let check = scanned_items.splice(indexScan  , 1)
                                            if (indexScan > 0) {
                                              // debugger
                                              scanned_items.splice(
                                                indexScan,
                                                1
                                              );
                                            }
                                            // console.log("scanned444", swapunscan)
                                            unscanned_items.splice(
                                              swapunscan,
                                              1
                                            );
                                            unscanned_items.unshift(item);
                                            scanned_items.splice(0, 0, item);
                                            this.setState({
                                              typeScanState: item.sku
                                            });
                                            scanpush = true;
                                            SKU = item.sku;
                                            Log_count = barcode.packing_count;
                                            product_name = item.name;
                                            qty_remain = item.qty_remaining;
                                          }
                                        }
                                      }
                                      //share barcode end when barcode is same//
                                    }
                                  });
                                } else {
                                  if (
                                    Barcode === bar_code &&
                                    item.qty_remaining >=
                                      parseInt(barcode.packing_count)
                                  ) {
                                    if (
                                      item.qty_remaining === 1 &&
                                      scanpush === false
                                    ) {
                                      if (type === 'item_present') {
                                        item.qty_remaining =
                                          item.qty_remaining - 1;
                                        item.scanned_qty = item.scanned_qty + 1;
                                      } else {
                                        if (item.qty_remaining > 0) {
                                          item.qty_remaining =
                                            item.qty_remaining -
                                            parseInt(barcode.packing_count);
                                          item.scanned_qty =
                                            item.scanned_qty +
                                            parseInt(barcode.packing_count);
                                        }
                                      }
                                      // scanned_items.push(item)
                                      scanned_items.splice(0, 0, item);
                                      // debugger
                                      unscanned_items.splice(scanAccess, 1);
                                      // debugger
                                      this.setState({
                                        typeScanState: item.sku
                                      });
                                      scanpush = true;
                                      SKU = item.sku;
                                      Log_count = barcode.packing_count;
                                      product_name = item.name;
                                      qty_remain = item.qty_remaining;
                                    } else {
                                      if (
                                        scanpush === false &&
                                        item.qty_remaining > 0
                                      ) {
                                        if (type === 'item_present') {
                                          item.qty_remaining =
                                            item.qty_remaining - 1;
                                          item.scanned_qty =
                                            item.scanned_qty + 1;
                                        } else {
                                          if (item.qty_remaining > 0) {
                                            item.qty_remaining =
                                              item.qty_remaining -
                                              parseInt(barcode.packing_count);
                                            item.scanned_qty =
                                              item.scanned_qty +
                                              parseInt(barcode.packing_count);
                                          }
                                        }
                                        // scanned_items.push(item)
                                        // console.log("scanned",scanned_items)
                                        // console.log("scanned item--44-->", swapunscan)
                                        unscanned_items.splice(swapunscan, 1);
                                        unscanned_items.unshift(item);
                                        scanned_items.splice(0, 0, item);
                                        this.setState({
                                          typeScanState: item.sku
                                        });
                                        scanpush = true;
                                        SKU = item.sku;
                                        Log_count = barcode.packing_count;
                                        product_name = item.name;
                                        qty_remain = item.qty_remaining;
                                      }
                                    }
                                  }
                                }
                              }
                              if (unscanned_items.length > 0) {
                                if (serialScanAccess) {
                                  if (type === 'item_present') {
                                    barcode_copy = Barcode;
                                    this.InputField?.current?.focus();
                                    this.responseAction('scan_success');
                                  } else {
                                    if (
                                      remain_qty >=
                                        parseInt(barcode.packing_count) ||
                                      remain_qty === null
                                    ) {
                                      barcode_copy = Barcode;
                                      this.responseAction('scan_success');
                                    } else {
                                      this.alertBox(
                                        i18n.t(
                                          'scanpackItem.Scanpack_multipack_msg'
                                        )
                                      );
                                    }
                                  }
                                }
                              } else {
                                barcode_copy = Barcode;
                                order_complete_flag = true;
                                // this.responseAction("order_complete")
                              }
                              if (
                                (this.state.blockItemToScan &&
                                  this.state.blockItemToScan.name !==
                                    item.name) ||
                                item.qty_remaining === 0
                              ) {
                                confirmProductConfirmation = false;
                              }
                              itemFound = true;
                            }
                          }
                        });
                  }
                }
                return item;
              });
            if (skipError === false) {
              // debugger
              this.props.isHaptics && Vibration.vibrate(400);
              itemFound === false ? this.responseAction('scan_fail') : '';
            }
          }
        } else {
          order_complete_flag = true;
          // this.responseAction("order_complete")
        }
        // console.log(" 2902 last time ",order.order.unscanned_items)
        order.order.unscanned_items.map((noCode, index) => {
          // debugger
          if (
            noCode.barcodes &&
            noCode.barcodes.length === 1 &&
            noCode.barcodes[0].barcode === ' '
          ) {
            // if (noCode.barcodes && noCode.barcodes.length === 1 && noCode.barcodes[0].barcode === "noBarcode") {
            noCode.barcodes = [];
          }
        });
        if (this.state.serialRecordInput !== '') {
          temp_order = updateSerialLog;
        } else {
          let setting_check = this.props?.bothSettings?.data?.data;
          // let setting_check = this.props.bothSettings?.data?.data?.scanpack_setting;
          let clickScanInput = setting_check?.scanpack_setting?.click_scan
            ? setting_check?.scanpack_setting?.click_scan_barcode
            : '';
          let passInput = setting_check?.scanpack_setting?.pass_scan
            ? setting_check?.scanpack_setting?.pass_scan_barcode
            : '';
          let barCodeValue = this.getBarcodeInputValue();
          let offsetNew = setting_check?.general_setting?.time_zone_offset;
          if (
            setting_check?.scanpack_setting?.partial &&
            setting_check?.scanpack_setting?.partial_barcode ===
              bar_code.toUpperCase()
          ) {
            temp_order['id'] = order_num;
            temp_order['input'] =
              event_code === clickScanInput || event_code === passInput
                ? barcode_copy
                : event_code;
            if (type !== 'item_present') {
              temp_order['state'] = 'scanpack.rfp.default';
            }
            temp_order['on_ex'] = 'on GPX';
            temp_order['event'] = 'regular';
          } else {
            temp_order['input'] =
              event_code === clickScanInput || event_code === passInput
                ? barcode_copy
                : event_code;
            temp_order['id'] = order_num;
            // GROOV-4994 (bug 3): this.state.activeBoxIndex only advances via
            // goPrev/goNext clicks or a box-barcode-scan match elsewhere in this file —
            // it is NOT touched by confirmBoxChampHandoff, which is what actually seals/
            // advances a box on both the confirm-card tap and the box-scan-verification
            // seal-scan path. That left a window, immediately after confirming/sealing a
            // box, where this label read the JUST-COMPLETED box's name instead of the
            // one items are now actually being scanned into — corrupting the activity
            // log text for every subsequent scan in the new box, not just the first.
            //
            // getBoxChampView()'s projection is the same always-current source of truth
            // updateLog() already uses for the real data.box_id sent to the backend
            // (getBoxChampActiveBoxId(), line ~6079) — read the box name from that same
            // resolved view/entry (not a fresh this.props.Order.boxes lookup by id) so
            // this can never disagree with which placement candidate
            // (this.props.Order vs this.state.order?.order — see champPlacementFrom in
            // boxChampGuided.js) getBoxChampView() actually resolved against; the two
            // are not always the same object (this.props.Order is the redux-global
            // order, this.state.order?.order the route/local copy this component reads
            // and writes as items are scanned). Falls back to the legacy
            // activeBoxIndex-based lookup, untouched, for non-BoxChamp orders (the view
            // is null there).
            temp_order['box_name'] =
              (() => {
                const guidedView = this.getBoxChampView();
                const activeEntry =
                  guidedView && guidedView.projection.activeIndex >= 0
                    ? guidedView.projection.boxes[guidedView.projection.activeIndex]
                    : null;
                // GROOV-4994 (PR #481 review): activeIndex is -1 not only for
                // non-BoxChamp orders but also for the narrow window where a genuine
                // plan exists and every box is momentarily complete (the last item of
                // the last box just scanned, confirmation modal about to show). Falling
                // straight through to the stale this.state.activeBoxIndex there
                // reintroduces the exact bug this method exists to fix, just for that
                // window. boxChampPendingConfirmationBoxId() is the same
                // packer-acknowledgment signal scanned_items.js's getBoxChampActiveEntry
                // already trusts for this — look the box up by that id before falling
                // back to the legacy cursor.
                const pendingId = this.boxChampPendingConfirmationBoxId();
                const pendingBox =
                  pendingId != null
                    ? this.props?.Order?.boxes?.find(b => b.id === pendingId)
                    : null;
                const box =
                  activeEntry?.box ??
                  pendingBox ??
                  this.props?.Order?.boxes?.[this.state.activeBoxIndex];
                return box?.name;
              })() ?? 'BOX 1';
            temp_order['kit_product_id'] = product_main_id;
            temp_order['product_id'] = product_id;
            temp_order['is_kit'] = is_kit;
            // product_kit_id = unscanned_items[0].product_id;
            // is_kit = true
            // unscanned_items.length > 0 ? unscanned_items[0].order_item_id : (scanned_items.length > 0 ? scanned_items[0].order_item_id : ""
            temp_order['order_item_id'] =
              scanned_items.length > 0 ? scanned_items[0].order_item_id : '';
            // temp_order['time'] = new Date();
            temp_order['time'] = moment().utcOffset(offsetNew);
            temp_order['rem_qty'] = remain_qty;
            temp_order['qty_rem'] = qty_remain;
            temp_order['SKU'] = SKU
              ? SKU
              : unscanned_items?.length > 0 &&
                unscanned_items[0]?.child_items?.length > 0
              ? unscanned_items[0]?.child_items[0]?.sku
              : unscanned_items[0]?.sku;
            temp_order['Log_count'] = Log_count;
            temp_order['product_name'] = product_name;
            temp_order['name'] =
              this.state.userInfo && this.state.userInfo.name
                ? this.state.userInfo.name
                : '';
            temp_order['actionBarcode'] = ActionBarcode;
            if (type !== 'item_present') {
              temp_order['state'] = 'scanpack.rfp.default';
            }
            temp_order['increment_id'] = order.order.increment_id;
            sku = kitItem ? sku : temp_order['SKU'];
            temp_order['SKU'] = kitItem ? sku : temp_order['SKU'];
            temp_order['removeSkipableItem'] =
              kitItem && scan_pack_settings.remove_skipped ? true : false;
            temp_order['input'] = kitItem ? 'SKIP' : temp_order['input'];
            kitItem = kitItem === true ? false : kitItem;
            temp_order['event'] =
              barCodeValue === '' ||
              barCodeValue === clickScanInput ||
              barCodeValue === passInput ||
              barCodeValue != barCodeValue
                ? 'click_scan'
                : 'regular';
            // For wrong scanning in mobile view.
            // temp_order['event'] = (this.state.windowWidth >= 900 ? this.state.bar_code === '' || this.state.bar_code === clickScanInput || this.state.bar_code === passInput || this.state.bar_code != this.state.bar_code : barCodeValue === '' || barCodeValue === clickScanInput || barCodeValue === passInput || barCodeValue != barCodeValue) ? "click_scan" : "regular"
            temp_order['updated_at'] = order.order.updated_at;
            temp_order['on_ex'] = 'on GPX';
            event_scanned === true
              ? (temp_order['event'] = 'scanned')
              : temp_order['event'];
          }
          // console.log("temp order check here----->",temp_order)
          isSerialScan === false
            ? this.setState({prodConfCheck: true, bar_code: ''})
            : (isSerialScan = false);
          if (isClickScan) {
            isClickScan = false;
          }
          // barCodeInput = ''
        }
        // event_scanned === true ? temp_order["event"] = "scanned" : temp_order["event"]
        if (stop_add_log !== true && temp_order !== undefined) {
          if (order_complete_flag) {
            this.updateLog(temp_order, 'order_complete');
          } else {
            this.updateLog(temp_order, Action_Type);
          }
          if (this.state.serialRecordInput === '' && rejectLocalLog) {
            // localLogs.push(temp_order)
            localLogs.splice(0, 0, temp_order);
            addLog = true;
          }
        }
        this.setState({scanned_items: scanned_items, serialRecordInput: ''});
        blockScan = false;
      } else {
        // if (bar_code === "" && this.state.serialRecordInput === "") {
        if (
          event.keyCode === 13 &&
          bar_code === '' &&
          this.state.serialRecordInput === ''
        ) {
          this.responseAction('not_ready');
        }
      }
    }
    try {
      // this.barcode.current.focus();
    } catch (error) {}
    enableSerial = false;
    isModalCleared = false;
  };

  /*SCAN BARCODE METHOD END*/

  /* CLICK SCAN METHOD START */
  clickScan = (item, fromActionBarcode, isShiftKey = false) => {
    if (!fromActionBarcode) {
      this.setState({isClicked: !this.state.isClicked});
      isClickScan = true;
    }
    let scan_pack_settings = this.state.scan_pack_settings;
    let access =
      fromActionBarcode === 'actionbarcode'
        ? scan_pack_settings.click_scan ||
          item.click_scan_enabled !== 'off' ||
          this.state.userInfo?.override_pass_scanning ||
          isShiftKey
        : scan_pack_settings.enable_click_sku;
    // console.log("access here-->",access)

    if (access && item) {
      if (
        item.click_scan_enabled === 'on' ||
        item.click_scan_enabled === 'on_with_confirmation' ||
        this.state.userInfo?.override_pass_scanning ||
        isShiftKey
      ) {
        if (item.click_scan_enabled === 'on_with_confirmation') {
          this.setState({
            clickScanConfirmation: true,
            confirmationCheckItem: item
          });
        } else {
          // let barcode = item.barcodes && item.barcodes.length === 0 ? "noBarcode" : item.barcodes[0].barcode
          let barcode =
            item.barcodes && item.barcodes.length === 0
              ? ' '
              : item.barcodes[0].barcode;
          this.scanBarcode(barcode, 'item_present');
        }
      } else {
        this.alertBox(i18n.t('scanpackItem.Scanpack_pass_fun_msg'));
        notReadySound.play();
        this.setState({bar_code: ''});
        barCodeInput = '';
        isClickScan = false;
      }
    } else {
      this.alertBox(i18n.t('scanpackItem.Scanpack_pass_fun_msg'));
      isClickScan = false;
    }
    this.props.updateProductList(null);
  };
  /* CLICK SCAN METHOD END*/

  /*Click Scan Confirmation Pop Up Start*/
  clickScanConfirmFun = () => {
    let userInfo = this.state.userInfo;
    let item = this.state.confirmationCheckItem;

    if (item && userInfo) {
      if (
        this.state.userInfo.confirmation_code ===
        this.state.clickScanConfirmInput
      ) {
        let barcode = item.barcodes[0].barcode;
        this.scanBarcode(barcode, 'item_present');
        this.setState({
          clickScanConfirmation: false,
          confirmationCheckItem: null,
          clickScanConfirmInput: ''
        });
      } else {
        if (
          this.state.general_settings &&
          this.state.general_settings.strict_cc
        ) {
          this.setState({
            errorMessageClickScanConfirmation: true,
            clickScanConfirmInput: ''
          });
          notReadySound.play();
        } else {
          let barcode = item.barcodes[0].barcode;
          this.scanBarcode(barcode, 'item_present');
          this.setState({
            clickScanConfirmation: false,
            confirmationCheckItem: null,
            clickScanConfirmInput: ''
          });
        }
      }
    }
  };
  /*Click Scan Confirmation Pop Up End*/

  /*Click Scan Confirmation On Change Start*/
  handleClickScanConfirmInput = e => {
    this.setState({
      clickScanConfirmInput: e,
      errorMessageClickScanConfirmation: false
    });
  };
  /*Click Scan Confirmation On Change End*/

  /*METHOD TO UPDATE EVERY EVNET LOG START*/
  updateLog = async (logData, type) => {
    let data = {...logData};

    if (data.uid == null) data.uid = newGestureUid();

    const scanned_items = this.state.order?.order?.scanned_items || [];
    data = addNotFulfilledFlagToLog(data, scanned_items);

    const guidedActiveBoxId = this.getBoxChampActiveBoxId();
    const PLAN_OPS = ['handoff', 'box_substitute', 'box_combine', 'box_split'];
    if (PLAN_OPS.includes(data.event)) {
    } else if (guidedActiveBoxId != null) {
      data.box_id = guidedActiveBoxId;
      data.guided = true;
    } else {
      data.box_id = this.props?.Order?.boxes?.[this.state.activeBoxIndex]?.id;
    }
    let temp = [];
    let getItem = await AsyncStorage.getItem('logsArray');
    // console.log("updatelog function",getItem)
    let logging = await AsyncStorage.getItem('Logging');
    let LoggingArray = JSON.parse(logging);
    if (LoggingArray && LoggingArray.length >= 80) {
      var indexToRemove = 0;
      var numberToRemove = 1;
      LoggingArray.splice(indexToRemove, numberToRemove);
    }
    LoggingArray && LoggingArray.length > 0
      ? LoggingArray.push(data)
      : (LoggingArray = [data]);
    let arr = await appendLog(data);
    if(!this.state.popInternet){
      let boxOrder = this.props?.Order
      let boxItemProps = this.props?.Order?.order_item_boxes;
      let boxProps = this.props?.Order?.boxes || [];
      if(!boxProps.length){
        boxProps.push({name : arr[0].box_name, id: `unique-1`})
      }
      let currentScannedItem = boxOrder?.items?.find((item) => item.iteminfo.id === arr[0]?.order_item_id)
      let result =  boxItemProps?.filter((item) => item.box_id === boxProps[this.state.activeBoxIndex]?.id && item.product_id == currentScannedItem?.productinfo?.id)
      if(!result?.length){
        let cloneObject = {}
        cloneObject['id']  = Math.random();
        cloneObject['created_at'] = new Date()
        cloneObject['updated_at']= new Date()
        cloneObject['item_qty'] = 1
        cloneObject['box_id'] = boxProps[this.state.activeBoxIndex]?.id
        cloneObject['order_item_id'] = currentScannedItem?.iteminfo?.id
        cloneObject['product_id'] = currentScannedItem?.productinfo?.id
        boxItemProps.push(cloneObject)
      }else{
        result[0].item_qty +=1
      }
      boxOrder.items.forEach((item)=> {
        if(item.iteminfo.id === currentScannedItem?.iteminfo?.id)  item.iteminfo.scanned_qty += 1
      })
    }
    if((isPrintOrderBarcode === false) || (type !== 'order_complete' && isPrintOrderBarcode === true)){
      
      this.multipleTime();
    }
    // let getItem1 = await AsyncStorage.getItem("logsArray")
    // console.log("updatelog function-----1",getItem1)

    if (logData && logData.event === 'scanned') {
      
      this.multipleTime();
    }
    if (type === 'issue') {
      
      this.multipleTime();
      this.nav(this.state.order);
    }
    if (type === 'RESTART') {
      
      this.multipleTime();
      this.nav(this.state.order);
    }
    if (type === 'order_complete') {
      this.multipleTimeRunning = false;
      this.multipleTime();
      let orderId = this.props?.Order?.basicinfo?.id;
      let packCheck =
        this.state?.general_settings?.packing_cam == false &&
        this.state.scan_pack_settings.camera_option != 'photo'
          ? true
          : false;
      if (
        this.state.scan_pack_settings.post_scanning_option === 'None' &&
        !packCheck
      ) {
        if (
          this.state?.general_settings?.packing_cam == false ||
          this.state?.scanpackSettings?.packing_cam_enabled === false
        ) {
          this.responseAction('complete_order');
          this.scannAllItems(this.props?.Order?.basicinfo?.id);
        }
      }
      if (
        this.state.scan_pack_settings.post_scanning_option === 'None' &&
        isOrderComplete === false
      ) {
        this.responseAction('complete_order');
      }
    }
    if (type === 'type_scan_complete') {
      this.multipleTimeRunning = false;
      this.multipleTime();
    }
    if (type === 'recordTracking') {
      // this.responseAction("complete_order")
      this.multipleTimeRunning = false;
      this.multipleTime();
      if (
        this.state?.scan_pack_settings?.post_scanning_option_second === 'None'
      ) {
        this.responseAction('complete_order');
        this.setState({newState: false});
        this.scannAllItems(this.props?.Order?.basicinfo?.id);
      }
      this.setState({trackingOrderInput: ''});
      this.setState({alertBoxTracking: false});
    }
    await AsyncStorage.setItem('Logging', JSON.stringify(LoggingArray));
    let settingsHere = this.props?.bothSettings?.data?.data?.scanpack_setting;
    let stateOrder = this.state?.order?.order;
    if (
      settingsHere?.post_scanning_option != 'None' &&
      type != 'recordTracking' &&
      type != 'tracking' &&
      (settingsHere?.post_scanning_option_second === 'Verify' ||
        settingsHere?.post_scanning_option_second === 'Record' ||
        settingsHere?.post_scanning_option != 'None') &&
      !settingsHere?.capture_image_option &&
      settingsHere?.email_customer_option &&
      !this.state.functionalityPerformed &&
      !this.isBoxChampCompletionPending() &&
      stateOrder?.unscanned_items.length === 0
    ) {
      this.props.emailCustomer(stateOrder?.id);
      this.setState({
        functionalityPerformed: true
      });
    }
  };
  /*METHOD TO UPDATE EVERY EVNET LOG END*/
  showNotesFun = () => {
    this.setState({
      tags_toPackerFlag: true,
      notes_toPackerFlag: true
    });
  };
  close = type => {
    if (this.state.order) {
      let scan_pack_settings = this.state.scan_pack_settings;
      if (type === 'show_customer_notes') {
        scan_pack_settings['show_customer_notes'] = false;
      }
      if (type === 'show_internal_notes') {
        scan_pack_settings['show_internal_notes'] = false;
      }
      if (type === 'notes_toPacker') {
        this.setState({notes_toPacker_enable: false});
      }
      this.setState({scan_pack_settings});
    }
    // try {
    //   this.barcode.current.focus()
    // } catch (error) {
    // }
  };

  leaveComponent = async (order, type) => {
    if (type === 'submitLog') {
      this.multipleTime();
    }
  };

  updateDimensions = () => {
    this.setState({
      windowWidth: window.innerWidth
    });
  };
  componentWillUnmount() {
    this._isMounted = false;
    // GROOV-4994 (defect cleanup #6): clear the boxChampShowConfirmation timer so its
    // deferred setState can't fire after unmount even in the window before the
    // _isMounted guard above would otherwise short-circuit it.
    clearTimeout(this._boxChampConfirmationTimer);
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    successSound.pause();
    notReadySound.pause();
    failSound.pause();
    completeSoun.pause();
    let Order = this.state.order;
    searchOrderCheck = false;
    ScanPackSettingsAccess = false;
    GeneralSettingAccess = false;
    orderSaveSuccess = false;
    updateLogSuccess = true;
    updateFromProductSuccess = false;
    if (Order) {
      this.leaveComponent(Order);
      this.setState({oldOne: null});
      this.props.SearchScanpackOrder('', false);
    }
    window.removeEventListener('resize', this.updateDimensions);
    //this.multipleTime('submitLog');
    this.props.GetProductDetail(0);
  }

  hideShipment = () => {
    this.setState({showshipments: false});
  };

  callShipmentOrder = order => {
    let shipmentOrder = this.state.shipmentOrder;
    if (order.increment_id !== '') {
      callOrderSuccess = true;
      shipmentOrder.input = order.increment_id;
      this.hitApi(shipmentOrder);
    }
  };

  //according to the plateform call the function
  hitApi = shipmentOrder => {
    if (Platform.OS === 'ios' || Platform.OS === 'android') {
      this.InternetCheck(shipmentOrder);
    } else {
      this.props.SearchScanpackOrder(shipmentOrder);
    }
  };

  /*Check the connection for the ios and android start*/
  InternetCheck = async shipmentOrder => {
    const connectionInfo = await NetInfo.fetch();
    if (connectionInfo.isConnected) {
      this.props.SearchScanpackOrder(shipmentOrder);
    } else {
      this.setState({errorMessageShow: true});
    }
  };
  /*Check the connection for the ios and android end*/

  enableToggle(e) {
    if (this.props.route && this.props.route.params) {
      if (e === 1) {
        this.props.route.params.item(true);
      } else {
        this.props.route.params.item(false);
      }
    }
  }

  isActionCode = code => {
    const setting = this.state.scan_pack_settings;

    const stringCode = code.toString();
    return (
      stringCode === setting.skip_code ||
      stringCode === setting.note_from_packer_code ||
      stringCode === setting.service_issue_code ||
      stringCode === setting.restart_code
    );
  };

  serialRecordFun() {
    this.state?.userInfo?.confirmation_code;
    let {order} = this.state;
    let scanPackSetting = this.state?.scan_pack_settings;
    let input = this?.state?.serialRecordInput;
    let inputLength = input.length;
    let match = false;
    if (scanPackSetting.require_serial_lot) {
      if (scanPackSetting.valid_prefixes) {
        let prefix = scanPackSetting.valid_prefixes.split(',');
        let prefixLength;
        let userInput;
        let access = false;
        let confirmationAll =
          this.state?.userInfo?.all_users_confirmation_code?.some(element =>
            element?.includes(input)
          );
        let allBarcodes = this.state?.userInfo?.all_barcodes?.some(element =>
          element?.includes(input)
        );
        let allActionCode = this.isActionCode(input);
        prefix &&
          prefix.length > 0 &&
          prefix.map(serial => {
            prefixLength = serial.length;
            userInput = input.slice(0, prefixLength);
            if (
              userInput === serial &&
              !confirmationAll &&
              !allBarcodes &&
              !allActionCode
            ) {
              access = true;
            }
          });
        if (access) {
          match = true;
          enableSerial = true;
        } else {
          // debugger
          this.responseAction('scan_fail', 'serialRecord');
          if (
            confirmationAll === true ||
            allBarcodes === true ||
            allActionCode === true
          ) {
            this.alertBox(
              i18n.t('scanpackItem.Scanpack_barcode_found_or_special_code_msg')
            );
          } else {
            this.alertBox(i18n.t('scanpackItem.Scanpack_required_serial_msg'));
          }
          // this.setState({ type: this.state.type, serialRecordInput: "", serialRecordOne: "", serialRecordTwo: "" })
          // this.setState({ serialRecordOne: "", serialRecordTwo: "" })
          this.setState({type: this.state.type, serialRecordInput: ''});
          match = false;
          enableSerial = false;
        }
      } else {
        match = true;
        enableSerial = true;
      }
    } else {
      match = true;
      enableSerial = true;
    }
    let type = this.state.type;
    let item = order?.order?.unscanned_items[0] ?? null;
    let order_id = order?.order?.id;
    if (match) {
      if (currentItemForSerialScan !== undefined) {
        item = currentItemForSerialScan;
        currentItemForSerialScan = undefined;
      }
      if (item.child_items?.length > 0 && item.child_items[0]) {
        this.serialRecordCommonFunction(item.child_items[0], type, order_id);
      } else {
        this.serialRecordCommonFunction(item, type, order_id);
      }
    }
  }
  serialRecordCommonFunction(item, type, order_id) {
    let localLogs = this.state.localLogs;
    if (item.record_serial && item.second_record_serial) {
      if (this.state.serialRecordOne === '') {
        this.setState({
          serialRecordOne: this.state?.serialRecordInput,
          serialRecordText: i18n.t('serialRecord.serial_number_two')
        });
        this.setState({serialRecordInput: ''});
        updateSerialLog = serialLogUpdate(
          type,
          item,
          'recordOne',
          order_id,
          true,
          this.state.serialRecordInput,
          this.state.userInfo,
          localLogs
        );
      } else {
        this.setState({serialRecordTwo: this.state?.serialRecordInput});
        enableSerial = true;
        this.setState({serialRecordPopUpShow: false});
        serialLogUpdate(
          type,
          item,
          'recordTwo',
          order_id,
          true,
          this.state.serialRecordInput,
          this.state.userInfo,
          localLogs
        );
        this.allTypeScan(type, item);
      }
    } else {
      if (item.record_serial) {
        updateSerialLog = serialLogUpdate(
          type,
          item,
          'recordOne',
          order_id,
          false,
          this.state.serialRecordInput,
          this.state.userInfo,
          localLogs
        );
      } else {
        updateSerialLog = serialLogUpdate(
          type,
          item,
          'recordTwo',
          order_id,
          false,
          this.state.serialRecordInput,
          this.state.userInfo,
          localLogs
        );
      }
      this.allTypeScan(type, item);
      this.setState({
        serialRecordPopUpShow: false,
        type: '',
        serialRecordInput: ''
      });
    }
  }

  allTypeScan = (type, item, recordSerial) => {
    this.setState({
      productConfirmationPopup: false,
      type: '',
      serialRecordInput: ''
    });
    isModalCleared = true;
    if (type === 'clickscan') {
      // debugger
      this.clickScan(item);
      isClickScan = false;
    }
    if (type === 'barcode') {
      this.scanBarcode();
      this.setState({bar_code: ''});
      barCodeInput = '';
    }
    if (type === 'scan_all_item') {
      this.scanAllItem('scan_all_item');
    }
    if (type === 'submit_type_scan') {
      this.submitTypeScan('submit_type_scan');
    }
  };

  handleSerialRecordInput = e => {
    this.setState({serialRecordInput: e});
  };

  /*Product Detail Nav Start*/
  redirectToItemDetail(product) {
    if (product && product.product_id) {
      this.props.ClearSearchProduct();
      this.props.navigation.navigate('ProductDetail', {
        productInfo: product.product_id,
        orderID: this.state.order.order.id,
        increment_id: this.state.order.order.increment_id,
        userData: this.state.userData
      });
    }
  }
  /*Product Detail Nav End*/

  removeFocus() {
    // this.barcode.blur()
    // this.barcode.current.focus()
  }

  onKeyUp(keyName, e, handle) {
    this.setState({focusBarcode: true});
  }

  onKeyDown(keyName, e, handle) {
    this.setState({focusBarcode: true});
  }

  navButton = () => {
    this.props.CheckIsListMode(!this.props.isListMode);
    this.setState(
      {
        reRenderFocus: true,
        unscannedItemShow: false,
        nextItemShow: true,
        scannedItemShow: false
      },
      () => {
        // console.log("Update");
      }
    );
    setTimeout(
      function () {
        this.setState({reRenderFocus: false, message: ''});
      }.bind(this),
      1
    );
  };

  navButtonLeft = () => {
    this.props.CheckIsListMode(!this.props.isListMode);
    this.setState(
      {
        reRenderFocus: true,
        unscannedItemShow: true,
        nextItemShow: false,
        scannedItemShow: false
      },
      () => {
        // console.log("Update");
      }
    );
    setTimeout(
      function () {
        this.setState({reRenderFocus: false, message: ''});
      }.bind(this),
      1
    );
  };

  showScannedList = () => {
    this.setState({
      reRenderFocus: true,
      unscannedList: false,
      scannedList: true,
      logList: false
    });
    setTimeout(
      function () {
        this.setState({reRenderFocus: false, message: ''});
      }.bind(this),
      1
    );
  };

  showUnscannedList = () => {
    this.setState({
      reRenderFocus: true,
      unscannedList: true,
      scannedList: false,
      logList: false
    });
    setTimeout(
      function () {
        this.setState({reRenderFocus: false, message: ''});
      }.bind(this),
      1
    );
  };

  showLogList = () => {
    this.setState({
      reRenderFocus: true,
      unscannedList: false,
      scannedList: false,
      logList: true
    });
    setTimeout(
      function () {
        this.setState({reRenderFocus: false, message: ''});
      }.bind(this),
      1
    );
  };

  closeNotes = () => {
    // console.log('close Notes called')
    this.setState({
      notes_toPackerFlag: false,
      notes_internalFlag: false,
      customer_commentsFlag: false,
      tags_toPackerFlag: false
    });
    this.currentFocus();
  };

  assignUniquebarcode = from => {
    this.setState({
      shareBarcodeShow: false,
      alias: false,
      addBarcodeWindow: false,
      addBarcodeText: ''
    });
  };

  proceedAliasing = () => {
    let alias_product_data_id = this.state.updateProduct.alias_product_data.id;
    let current_product_data_id = [];
    current_product_data_id.push(
      this.state.updateProduct.current_product_data.id
    );
    let details = {
      product_alias_ids: current_product_data_id
    };
    this.props.updateProductAlias(alias_product_data_id, details);
    this.props.SearchScanpackOrder('', false);
    updateProductInfoSuccess = true;
    updateFromProductSuccess = true;
    updateAliasSuccess = true;
  };

  sameBarcode = () => {
    if (!this.state.addBarcodeText?.trim()) {
      return;
    }
    const gtin14 = extractGtin14FromBarcode(this.state.addBarcodeText);
    let newHash = {
      value: gtin14 || this.state.addBarcodeText,
      var: 'barcode',
      id: this.state.addBarcodeItem.product_id,
      permit_same_barcode: true
    };
    this.props.updateProductList(newHash);
    this.setState({
      updateProductApiCall: new Date(),
      shareBarcodeShow: false,
      alias: false
    });
    updateProductApi = true;
  };

  //make the item temporary suggested
  changeTheSuggestedItem = (itemSku, childItemSku) => {
    this.state.isBarcodeEnter === true &&
      this.setState({isBarcodeEnter: false});
    const order = this?.state?.order;
    const orderData = ShuffleTheItem(order, itemSku, childItemSku);
    this.setState({order: orderData});
  };

  drawerClose = () => {
    this.props.route.params.closeDrawer();
  };
  packingCamFun = pack_scanning_option => {
    if (
      this?.state?.order &&
      this?.state?.order?.order &&
      this?.state?.order?.order?.unscanned_items &&
      this?.state?.order?.order?.unscanned_items?.length === 0 &&
      pack_scanning_option == 'after_post_scan_packing_1' &&
      this?.state?.scan_pack_settings?.post_scanning_option == 'None' &&
      this.state?.scan_pack_settings?.packing_option == 'after_packing'
    ) {
      this.setState({packing_cam_options: false});
      this.props.navigation.navigate('PackingCam', {
        order: this?.state?.order.order
      });
    }
  };
  getshipment = (storeId, orderId) => {
    let data = {};
    data['store_id'] = storeId;
    data['order_id'] = orderId;
    this.setState({shipping_easy: true});

    this.props.Getshipment(data);
  };
  //Check Internate connectiion Here
  test = async () => {
    let num = await InterNetChecks();
    if (num !== true) {
      this.setState({popInternet: false});
    } else {
      this.setState({popInternet: true});
    }
  };

  closeSerialRecord = () => {
    this.setState({serialRecordPopUpShow: false});
  };
  scannAllItems = orderId => {
    if (this.boxChampCompletionDeferred()) return;
    setTimeout(() => {
      this.props?.route?.params?.data?.order?.unscanned_items.length === 0 &&
        this.props?.FullOrderScan(orderId);
    }, 1000);
  };

  triggerReprintIfEnabled = async () => {
    try {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');

      const settingsResponse = await axios({
        method: 'get',
        url: `${url}/settings/get_setting.json`,
        headers: {Authorization: `Bearer ${access_token}`}
      });

      const scanPackSettings = settingsResponse?.data?.data?.scanpack_setting;
      const generalSettings = settingsResponse?.data?.data?.general_setting;

      if (scanPackSettings?.enable_reprint_option) {
        const orderNumber = this.props?.Order?.basicinfo?.increment_id;
        if (scanPackSettings.post_scanning_option === 'Barcode') {
          this.triggerReprintAfterScan(orderNumber, 'order_barcode');
        } else if (scanPackSettings.post_scanning_option === 'PackingSlip') {
          this.triggerReprintAfterScan(orderNumber, 'packing_slip');
        } else if (generalSettings?.multi_box_shipments && generalSettings?.per_box_packing_slips === 'when_order_is_complete') {
          this.triggerReprintAfterScan(orderNumber, 'packing_slip');
        }
      }
    } catch (error) {
      console.error('Error fetching settings for reprint:', error);
    }
  };

  triggerReprintAfterScan = async (orderNumber, printType) => {
    try {
      let scanPackSettings = this.state?.scan_pack_settings || {};
      if (!scanPackSettings.enable_reprint_option) {
        const bothSettings = this.props?.bothSettings?.data?.data?.scanpack_setting;
        if (bothSettings) {
          scanPackSettings = bothSettings;
        }
      }

      if (!scanPackSettings.enable_reprint_option) {
        return;
      }

      // Verify direct printing is enabled for this print type
      const generalSettings = this.props?.bothSettings?.data?.data?.general_setting;
      const isDirectPrintingEnabled = printType === 'order_barcode'
        ? generalSettings?.print_post_scanning_barcodes
        : generalSettings?.print_packing_slips;

      if (!isDirectPrintingEnabled) {
        return;
      }

      let printerKey;
      if (printType === 'order_barcode') {
        printerKey = 'user_selected_printer_order_barcode_label';
      } else {
        const packingSlipSize = await AsyncStorage.getItem('Packing_slip_size');
        printerKey = `user_selected_printer_packing_slip_${packingSlipSize}`;
      }

      const selectedPrinterStr = await AsyncStorage.getItem(printerKey);

      if (!selectedPrinterStr || selectedPrinterStr.length === 0) {
        return;
      }

      const selectedPrinter = JSON.parse(selectedPrinterStr);
      const printJobData = {
        orderNumber: orderNumber,
        printType: printType,
        printer: selectedPrinter,
        url: null
      };

      await storeLastPrintJob(printJobData, scanPackSettings, selectedPrinter);
      await AsyncStorage.setItem('reprint_trigger', JSON.stringify({
        orderNumber: orderNumber,
        printType: printType,
        timestamp: new Date().getTime()
      }));
    } catch (error) {
      console.error('Error in triggerReprintAfterScan:', error);
    }
  };

  render() {
    let orderCompleteSound =
      this.state?.scan_pack_settings?.order_complete_image_time;
    let fixedOrderCompleteSound =
      orderCompleteSound === undefined
        ? this.state?.bothSettings?.data?.data?.scanpack_setting
            ?.order_complete_image_time
        : orderCompleteSound;
    let orderEditPermission =
      this.props?.route?.params?.userdata?.role?.add_edit_order_items;
    // logic for order cup 2572c
    let unScannedItem = this?.state?.order?.order?.unscanned_items[0];
    let instructionCheck =
      unScannedItem?.child_items?.length > 0
        ? unScannedItem?.child_items[0]?.instruction
        : unScannedItem?.instruction;
    //Add this code for handle GROOV-2704 (Kit activity Issue)
    let scannedQtyNew =
      this?.state?.order?.order?.scanned_items[0]?.scanned_qty === 1;

    let scannedQty =
      unScannedItem?.child_items?.length > 0
        ? unScannedItem?.child_items[0]?.scanned_qty === 1
        : unScannedItem?.scanned_qty === 1;
    let instructionChekFor =
      !!this?.state?.order?.order?.scanned_items[0]?.instruction?.length;
    let callOrder = this?.props?.callOrder?.data?.order?.[0];
    let cofCodeProductInstruction =
      this?.state?.general_settings?.conf_code_product_instruction;
    if (
      confirmProductConfirmation === false &&
      (cofCodeProductInstruction === 'always' ||
        cofCodeProductInstruction === 'optional') &&
      this.props?.product?.basicinfo?.packing_instructions_conf &&
      instructionCheck !== null &&
      instructionCheck !== '' &&
      this?.state?.order?.order?.unscanned_items.length > 0 &&
      scannedQty &&
      this.state.prodConfCheck === true &&
      product_confirm != '*'
    ) {
      this.setState({prodConfCheck: false});
    }
    const {order} = this?.state ?? {};
    const {unscanned_items} = order?.order ?? {};
    if (
      unscanned_items?.length === 0 &&
      !this.isBoxChampCompletionPending() &&
      this?.state?.scan_pack_settings?.return_to_orders === false &&
      callOrder?.popup_shipping_label &&
      callOrder?.store_type === 'ShippingEasy' &&
      this.state.shipping_easy
    ) {
      this.setState({shipping_easy: false});
      if (callOrder?.shipment_id !== '') {
        let shippingeasy_url = `http://app.shippingeasy.com/shipments/${parseInt(
          callOrder?.shipment_id
        )}/edit`;
        // window.open(shippingeasy_url, "", "width=1366,height=650,top=100,left=110")
        window.open(
          shippingeasy_url,
          '',
          'width=' + screen.availWidth + ',height=' + screen.availHeight
        );
        // window.open(shippingeasy_url, "",)
      } else {
        this.getshipment(callOrder?.store_id, callOrder?.id);
      }
    }
    if (
      callOrder?.order_cup_direct_shipping === true &&
      unscanned_items?.length === 0 &&
      !this.isBoxChampCompletionPending() &&
      this.state.order_cup === true
    ) {
      this.setState({order_cup: false});
      let general_settings_order =
        this?.props?.bothSettings?.data?.data?.general_setting;
      let custom_key_value = {
        // custom_field_one: this?.state?.general_settings?.custom_field_one,
        // custom_field_two: this?.state?.general_settings?.custom_field_two
        custom_field_one: general_settings_order?.custom_field_one,
        custom_field_two: general_settings_order?.custom_field_two
      };
      let key = Object.keys(custom_key_value).filter(key => {
        return custom_key_value[key] === 'UOID';
      })[0];
      if (key !== undefined && callOrder?.order_info[key]) {
        let url =
          'https://ship.ordercup.com/pick_and_pack/ship?uoid=' +
          callOrder?.order_info[key];
        window.open(
          url,
          'Groovepacker - OrderCup Direct Shipping',
          'width=' + screen.availWidth + ',height=' + screen.availHeight
        );
      }
    }

    if (
      callOrder?.open_shopify_create_shipping_label === true &&
      callOrder?.store_type === 'Shopify' &&
      unscanned_items?.length === 0 &&
      !this.isBoxChampCompletionPending() &&
      this.state.shopify_shipping === true
    ) {
      this.setState({shopify_shipping: false});
      if (callOrder?.store_order_id && callOrder?.shopify_store_name) {
        let shopify_url = `https://admin.shopify.com/store/${callOrder.shopify_store_name}/orders/${callOrder.store_order_id}`;
          window.open(
            shopify_url,
            'Groovepacker - Shopify Shipping Label',
            'width=' + screen.availWidth + ',height=' + screen.availHeight
          );
      }
    }

    //End 2572

    const config = {velocityThreshold: 1, directionalOffsetThreshold: 80};
    // const config = { velocityThreshold: 1, directionalOffsetThreshold: 80, gestureIsClickThreshold : 5 };
    const props = this.props;
    const Order = this.state.order && this.state.order.order;
    let bothSettingHere =
      this.props?.bothSettings?.data?.data?.scanpack_setting;
    if (
      !this.state.newState &&
      unscanned_items?.length === 0 &&
      !this.isBoxChampCompletionPending() &&
      this?.state?.scanpackSettings?.camera_option == 'photo' &&
      //while kit it's not open packing_cam page
      // this.state?.general_settings?.packing_cam === true &&
      bothSettingHere?.capture_image_option !== 'do_not_take_image' &&
      this.props?.Order?.storeinfo?.disable_packing_cam === false &&
      this.state?.scanpackSettings?.packing_cam_enabled === true &&
      this?.props?.route?.params?.packingcamPage !== 'PackingCam'
    ) {
      // this.responseAction('order_complete')
      this.setState({newState: true});
      this.props.navigation.navigate('PackingCam', {
        cameraInstance: this.cameraRef.current,
        cameraOption: bothSettingHere?.capture_image_option,
        order: this?.state?.order.order,
        postScanning: this?.state?.scan_pack_settings?.post_scanning_option,
        post_scanning_option_second:
          this?.state?.scan_pack_settings?.post_scanning_option_second,
        settingCheck: this.props,
        userRole: this.props?.route?.params?.userdata || null,
        multipleTime: this.multipleTime,
        isPrintOrderBarcode: isPrintOrderBarcode,
        resetIsPrintOrderBarcode: this.resetIsPrintOrderBarcode
      });
    } else if (
      !this.state.newState &&
      Order?.status === 'awaiting' &&
      unscanned_items?.length === 0 &&
      (this.props?.Order?.storeinfo?.disable_packing_cam ||
        bothSettingHere?.capture_image_option === 'do_not_take_image') &&
      bothSettingHere?.post_scanning_option === 'None' &&
      bothSettingHere?.post_scanning_option_second === 'None'
    ) {
      // this.responseAction('complete_order');
      if (
        bothSettingHere?.email_customer_option &&
        !this.props?.Order?.storeinfo?.disable_packing_cam &&
        !this.isBoxChampCompletionPending()
      ) {
        setTimeout(()=>{
          this.forceUpdate();
          this.props.navigation.navigate('ScanPack')
        }, fixedOrderCompleteSound * 1000)
      }
    }
    // else{
    //   this.props.navigation.navigate("", { order: this?.state?.order.order })
    // }
    // if (this?.state?.order && this?.state?.order?.order && this?.state?.order?.order?.unscanned_items && this?.state?.order?.order?.unscanned_items?.length === 0 && this?.state?.scan_pack_settings?.packing_option == "after_packing") {
    //   let page = "ScanPackItem"
    //   // if(this.state.gp55.)
    //     this.props.navigation.navigate("PackingCam", { order: this?.state?.order.order ,page : page})

    // }

    // for 2593 issue

    const settings = this.state?.scan_pack_settings;
    if (
      (this.props?.bothSettings?.data?.data?.scanpack_setting?.order_verification ||
        settings?.order_verification) &&
      (Order?.unscanned_items?.length === 0 || this.boxChampOrderPacked()) &&
      !this.isBoxChampCompletionPending() &&
      !this._boxChampVerificationFired
    ) {
      this._boxChampVerificationFired = true;
      this.responseAction('complete_order');
      this.scannAllItems(this.props?.Order?.basicinfo?.id);
      setTimeout(() => {
        this.props.navigation.navigate('OrderDetail', {
          from: 'ScanPackItem',
          item: this.state?.order.order,
          userData: this.props?.route?.params?.userdata
        });
        // this.props.navigation.navigate('ScanPack', {
        //   showScannedMessageAlert: true
        // });
        // this.setState({ popUpModelShow: false, message: "", messageTypeSuccess: false });
      }, 1000);
    }
    //End 2593 issue
    if (
      this.state.scan_pack_settings?.post_scanning_option === 'PackingSlip' ||
      this.state.scan_pack_settings?.post_scanning_option === 'Barcode'
    ) {
      // this.setState({ scan_pack_settings: { post_scanning_option: 'None' } });
      //Add condition for GROOV-3339
      if (
        this.state.scan_pack_settings?.post_scanning_option_second !=
          'Record' &&
        this.state.scan_pack_settings?.post_scanning_option_second != 'verify'
      ) {
        let settings = this.state.scan_pack_settings;
        settings.post_scanning_option = 'None';
        this.setState({scan_pack_settings: settings});
      }
    }
    // debugger
    Order &&
      Order.status === 'scanned' &&
      this.props.navigation.navigate('ScanPack', { showScannedMessage: true });
    Order &&
      Order.status === 'cancelled' &&
      this.props.navigation.navigate('ScanPack', { showCancelledMessage: true })
    return (
      <View
        key="main"
        onStartShouldSetResponder={() => this.drawerClose()}
        style={{height: '100%', flex: 1}}>
        {this.state.printingLabel && (
          <View style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999, justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.35)'}}>
            <View style={{padding: 24, borderRadius: 10, backgroundColor: '#fff', alignItems: 'center'}}>
              <ActivityIndicator size="large" />
              <Text style={{marginTop: 10, fontWeight: 'bold'}}>Printing…</Text>
            </View>
          </View>
        )}
        {this.props.showCartAssignmentToast && <AssignmentToast />}
        {
          <React.Fragment>
            {this.state.modalVisible && (
              <PrinterShow
                dataPrinter={this.state.printers}
                handlePrinterSelection={async printer => {
                  // let dimensionShipping= this?.props?.ssLabel?.dimensions.split('x')
                  let directPrint =
                    this.props?.ssLabelData?.ss_label_data?.direct_printed;
                  let dimensionShipping = directPrint
                    ? this.props?.ssLabelData?.ss_label_data?.dimensions.split(
                        'x'
                      )
                    : this?.props?.ssLabel?.dimensions.split('x');
                  let messageUrl = directPrint
                    ? this.props?.ssLabelData?.ss_label_data?.direct_printed_url
                    : this.props.ssLabel?.url;
                  let printerState = await handlePrinterSelection(
                    printer,
                    messageUrl,
                    this.props?.bothSettings?.data?.data?.general_setting,
                    'shipping_label',
                    {width: dimensionShipping[0], height: dimensionShipping[1]}
                  );
                  this.setState({modalVisible: false});
                  this.setState({selectedPrinter: printerState.type});
                  this.props.navigation.navigate('ScanPack');
                }}
                closePrompt={() => {
                  this.setState({modalVisible: false});
                }}></PrinterShow>
            )}
            {this.state.loader &&
              Order &&
              Order.unscanned_items.length != 0 && (
                <View style={styles.activityContainer}>
                  <ActivityIndicator size="large" color="#000" />
                  <View>
                    <Text
                      style={{
                        textAlign: 'center',
                        color: '#fff',
                        fontSize: 16
                      }}>
                      Loading...
                    </Text>
                  </View>
                </View>
              )}
            {Order && this.state.scan_pack_settings && (
              <View
                style={[
                  globalStyles.flex1,
                  {height: '100%', position: 'relative'}
                ]}>
                {this.state.orderConfirmPopUp &&
                  this?.state?.order?.order?.unscanned_items?.length !== 0 && (
                    <OrderConfirmationPopUp
                      OrderConfirmationCheckFun={() =>
                        this.OrderConfirmationCheckFun()
                      }
                      OrderConfirmationClosePopup={() => {
                        this.OrderConfirmationClosePopup();
                      }}
                      OrderConfirmationCheckInput={
                        this.state.OrderConfirmationCheckInput
                      }
                      errorMessageOrderConfirmationCheck={
                        this.state.errorMessageOrderConfirmationCheck
                      }
                      handleOrderConfirmationCheckInput={e =>
                        this.handleOrderConfirmationCheckInput(e)
                      }
                      datcheckHere={() => this.getdata()}
                      // closeAlert={this.closeAlert.bind(this)}
                      orderDetails={this.state.order && this.state.order.order}
                      popupShow={this.state.orderConfirmPopUp}
                      {...this.props}
                    />
                  )}
                
                <TTSEnablementPrompt />
                
                <ProductAlias
                  alias={this.state.alias}
                  Product={this.state.Product}
                  updateProduct={this.state.updateProduct}
                  windowWidth={this.state.windowWidth}
                  assignUniquebarcode={from => this.assignUniquebarcode(from)}
                  shareBarcodeMethod={() => {
                    this.setState({shareBarcodeShow: true, alias: false});
                  }}
                  proceedAliasing={() => this.proceedAliasing()}
                  shareBarcodeShow={this.state.shareBarcodeShow}
                  sameBarcode={() => this.sameBarcode()}
                />

                {
                  //Succes Image , Error Image , Order Complete Image
                  this.state.responseShowAction && (
                    <ResponseView
                      orderCompleteAction={this.state.orderCompleteAction}
                      scanSuccessAction={this.state.scanSuccessAction}
                      // scanFailAction={this.state.scanFailAction}
                      scanFailAction={this.state.scanFailAction}
                      scanPackSetting={this.state.scan_pack_settings}
                      generalSetting={this.state.general_settings}
                    />
                  )
                }
                {this.state.multiBoxAlertState && (
                  <MultiBoxAlert
                    emptyBoxPrint={this.state.emptyBoxPrint}
                    onCloseAlertMultiBox={() => this.onCloseAlertMultiBox()}
                  />
                )}
                {this.state.serviceIssuePrompt && (
                  <Alert
                    closeAlert={() => {
                      this.setState({serviceIssuePrompt: false});
                      RootNavigation.navigate('ScanPack');
                    }}
                    submitAlert={() => this.ServiceIssueFun()}
                    notes_fromPacker={this.state.serviceIssueInput}
                    noteUpdate={text =>
                      this.setState({serviceIssueInput: text})
                    }
                    loading={this.state.orderSearchLoading}
                    scanPackSetting={this.state.scan_pack_settings}
                    generalSetting={this.state.general_settings}
                    msg={this.getServiceIssueMsg()}
                    heading={'scanpackItem.service_Issue_msg'}
                    showIcon={false}
                    showButtons={false}
                  />
                )}
                {
                  //Type Scan Count Pop Up
                  this.state.typeScanAlert && (
                    <TypeScanAlert
                      closeAlert={this.closeAlert.bind(this)}
                      typeScanCount={this.state.typeScanCount}
                      typeScanCountUpdate={text =>
                        this.setState({typeScanCount: text})
                      }
                      submitTypeScan={this.submitTypeScan.bind(this)}
                      // submitTypeScan={this.serialRecordCheck.bind(this , "submit_type_scan")}
                      scanPackSetting={this.state.scan_pack_settings}
                      generalSetting={this.state.general_settings}
                    />
                  )
                }
                {
                  // Add item to order Pop Up
                  this.state.addItemToOrder && (
                    <CommonPrompt
                      closeAlert={this.closeAlert.bind(this)}
                      onSubmitEditing={() => {
                        this.handleAddItemToOrder();
                      }}
                      value={this.state.addItemToOrderInput}
                      onChangeText={text =>
                        this.setState({addItemToOrderInput: text})
                      }
                      loading={this.state.addNextItemLoading}
                      placeholder={'Ready for product Scan'}
                      placeholderTextColor={'#acacad'}
                      message={this.getAddNextItemMessage()}
                      showIcon={true}
                      showButtons={false}
                    />
                  )
                }
                {
                  // Add Note Pop Up
                  this.state.alert && (
                    <Alert
                      closeAlert={this.closeAlert.bind(this)}
                      submitAlert={this.submitAlert.bind(this)}
                      notes_fromPacker={this.state.notes_fromPacker}
                      noteUpdate={text =>
                        this.setState({notes_fromPacker: text})
                      }
                      scanPackSetting={this.state.scan_pack_settings}
                      generalSetting={this.state.general_settings}
                      showIcon={true}
                      showButtons={true}
                    />
                  )
                }

                {
                  // Notification Pop Up for messages
                  this.state.popUpModelShow && (
                    <PopUpModel
                      closeAlert={this.closeAlert.bind(this)}
                      message={this.state.message}
                      messageTypeSuccess={
                        this.state.messageTypeSuccess ? true : false
                      }
                    />
                  )
                }
                {
                  // Serial Record Pop Up
                  this.state.serialRecordPopUpShow && (
                    <SerialRecord
                      serialRecordFun={() => this.serialRecordFun()}
                      serialRecordText={this.state.serialRecordText}
                      serialRecordInput={this.state.serialRecordInput}
                      handleSerialRecordInput={e =>
                        this.handleSerialRecordInput(e)
                      }
                      // closeAlert={this.closeAlert.bind(this)}
                      closeSerialRecord={() => this.closeSerialRecord()}
                      serialRecord={() => this.serialRecord}
                      {...this.props}
                    />
                  )
                }
                <SerialRecordingNoteModal
                  item={this.state?.order?.order?.unscanned_items?.[0]}
                />
                {
                  // Click Scan Confirmation Pop Up
                  this.state.clickScanConfirmation && (
                    <ClickScanConfirmationPopUp
                      clickScanConfirmFun={() => this.clickScanConfirmFun()}
                      clickScanConfirmInput={this.state.clickScanConfirmInput}
                      errorMessageClickScanConfirmation={
                        this.state.errorMessageClickScanConfirmation
                      }
                      handleClickScanConfirmInput={e =>
                        this.handleClickScanConfirmInput(e)
                      }
                      closeAlert={this.closeAlert.bind(this)}
                      closeErrorAlert={this.closeErrorAlert.bind(this)}
                      serialFocus={this.myInput}
                      windowWidth={this.state.windowWidth}
                    />
                  )
                }

                {
                  // Add Barcode Pop Up
                  this.state.addBarcodeWindow && (
                    <AddBarcode
                      closeAlert={e => this.closeAlert(e)}
                      addBarcodeSubmit={e => this.addBarcodeSubmit(e)}
                      addBarcodeText={this.state.addBarcodeText}
                      addBarcodeChange={text =>
                        this.setState({addBarcodeText: text})
                      }
                      addBarcodeWindow={this.state.addBarcodeWindow}
                    />
                  )
                }

                {
                  // Notification Pop Up for messages
                  this.state.popUpModelShow && (
                    <PopUpModel
                      closeAlert={this.closeAlert.bind(this)}
                      message={this.state.message}
                    />
                  )
                }
                {
                  // Click Scan Confirmation Pop Up
                  this.state.clickScanConfirmation && (
                    <ClickScanConfirmationPopUp
                      clickScanConfirmFun={() => this.clickScanConfirmFun()}
                      clickScanConfirmInput={this.state.clickScanConfirmInput}
                      errorMessageClickScanConfirmation={
                        this.state.errorMessageClickScanConfirmation
                      }
                      handleClickScanConfirmInput={e =>
                        this.handleClickScanConfirmInput(e)
                      }
                      closeAlert={this.closeAlert.bind(this)}
                      closeErrorAlert={this.closeErrorAlert.bind(this)}
                      serialFocus={this.myInput}
                      windowWidth={this.state.windowWidth}
                    />
                  )
                }

                {
                  //productConfirmationCheck
                  //Add conditions for GROOV-2704
                  this.state.productConfirmationCheck && (
                    <ProductConfirmationCheck
                      ProductConfirmationCheckFun={() =>
                        this.ProductConfirmationCheckFun()
                      }
                      closeProductConfirmationCheckPopUp={() =>
                        this.closeProductConfirmationCheckPopUp()
                      }
                      order={this.state.order}
                      sku={this.state.bar_code !== '' ? sku : ''}
                      scannedBarcode={this.state.bar_code}
                      kitInstructions={this.state.kitInstructions}
                      productInstructions={
                        this.state.bar_code !== ''
                          ? this.props?.product?.packing_instructions
                          : ''
                      }
                      ProductConfirmationCheckInput={
                        this.state.productConfirmationCheckInput
                      }
                      errorMessageProductConfirmationCheck={
                        this.state.errorMessageProductConfirmationCheck
                      }
                      handleProductConfirmationCheckInput={e =>
                        this.handleProductConfirmationCheckInput(e)
                      }
                      closeAlert={this.closeAlert.bind(this)}
                      instruction={this.state.blockItemToScan}
                      datcheckHere={() => this.getdata()}
                      Product={this.state.Product}
                      {...this.props}
                    />
                  )
                }
                {this.state.openRestartPrompt && (
                  <Prompt
                    onPressCancel={() => {
                      this.setState({openRestartPrompt: false});
                    }}
                    onPressOk={() => {
                      this.setState({openRestartPrompt: false});
                      this.restartButton();
                    }}
                    msg={i18n.t('scanpackItem.restartAlert')}
                  />
                )}
                {this.state.alertBoxTracking && (
                  <AlertBoxTrackingNumber
                    onChangeText={text => {
                      this.setState({trackingOrderInput: text});
                    }}
                    alertBoxOpenTracking={() => {
                      this.alertBoxOpenTracking();
                    }}
                    onSubmitEditing={this.trackingSubmit.bind(
                      this,
                      this.state.trackingOrderInput
                    )}
                    trackingOrderInput={this.state.trackingOrderInput}
                    closeAlert={this.closeAlert.bind(this)}
                  />
                )}
                {this.state.alertBoxShipping && (
                  <AlertBoxShippingLabel
                    trackState={trackState}
                    editPermissionCheck={orderEditPermission}
                    orderConfirmationPer={this.state.orderConfirmationPer}
                    navigation={this.props.navigation}
                    alertBoxOpenShipping={() => {
                      this.alertBoxOpenShipping();
                    }}
                    order={this.state.order}
                    onChangeText={text => {
                      this.setState({trackingOrderInput: text});
                    }}
                    onSubmitEditing={this.trackingSubmit.bind(
                      this,
                      this.state.trackingOrderInput
                    )}
                    trackingOrderInput={this.state.trackingOrderInput}
                    closeAlert={this.closeAlert.bind(this)}
                  />
                )}

                {this.state.popInternet === false ? (
                  <View style={{postion: 'absolute', top: '20%', zIndex: 99}}>
                    <InerternetConnectionAlert offlineMessageRef={this.offlineMessageRef} offlineMessage={this.props.offlineMessage}/>
                  </View>
                ) : (
                  <View></View>
                )}
                {this.state.scan_pack_settings.post_scanning_option !==
                  'None' &&
                Order &&
                Order.unscanned_items.length === 0 &&
                !this.isBoxChampCompletionPending() ? (
                  <ConfirmTrackingNumber
                    postScanningFieldLabel={this.state.postScanningFieldLabel}
                    order={this.state.order}
                    statecheck={this.state.verifylabel}
                    scanPackSetting={this.state.scan_pack_settings}
                    alertBoxTracking={this.state.alertBoxTracking}
                    alertBoxShipping={this.state.alertBoxShipping}
                    postScanningOrderNumber={this.state.postScanningOrderNumber}
                    trackingOrderInput={this.state.trackingOrderInput}
                    onChangeText={text => {
                      this.setState({trackingOrderInput: text});
                    }}
                    onSubmitEditing={this.trackingSubmit.bind(
                      this,
                      this.state.trackingOrderInput
                    )}
                    postScanningMessageDetail={
                      this.state.postScanningMessageDetail
                    }
                  />
                ) : (
                  <React.Fragment>
                    {this.props.route &&
                      this.props.route.params &&
                      this.state.order && (
                        <Hotkeys
                          keyName="enter"
                          onKeyDown={this.onKeyDown.bind(this)}
                          onKeyUp={this.onKeyUp.bind(this)}>
                          <View style={{flex: 1}}>
                            {/* Measure the combined BoxChamp banner height so the
                                mobile view (position:fixed) can start below it
                                instead of overlapping it. */}
                            <View
                              style={{backgroundColor: '#142130', zIndex: 1000}}
                              onLayout={e =>
                                this.setState({
                                  boxChampBannerHeight: e.nativeEvent.layout.height,
                                })
                              }>
                            <BoxChampRecalculatingNotice
                              visible={
                                this.state.boxChampRecalculating ||
                                shouldShowRecalculatingNotice(
                                  this.props.Order,
                                  this.props?.bothSettings?.data?.data?.general_setting?.is_box_champ,
                                  (this.state.order?.order?.scanned_items?.length || 0) > 0
                                )
                              }
                              onRefetch={this.refreshBoxChampBoxes}
                            />
                            <BoxChampPlanErrorNotice
                              message={this.state.boxChampPlanError}
                              onDismiss={() => this.setState({boxChampPlanError: ''})}
                              onRetry={this.retryBoxChampPlan}
                            />
                            <BoxChampOversizeWarning warnings={this.props.Order?.box_champ_warnings} />
                            <BoxChampSetAsideNotice
                              message={this.state.boxChampSetAsideMessage}
                              tone={this.state.boxChampSetAsideConfirmation ? 'info' : 'warning'}
                              onDismiss={() => {
                                clearTimeout(this._boxChampConfirmationTimer);
                                this.setState({
                                  boxChampSetAsideMessage: '',
                                  boxChampSetAsideConfirmation: false
                                });
                              }}
                            />
                            <BoxChampHandoffCard
                              state={this.getBoxChampHandoff()}
                              onConfirm={this.confirmBoxChampHandoff}
                              dismissed={this.boxChampHandoffDismissed()}
                              onClose={this.dismissBoxChampHandoff}
                              onShow={this.showBoxChampHandoff}
                              onScan={this.scanFromBoxChampHandoff}
                              message={this.state.boxChampHandoffMessage}
                              setAsideItems={this.getBoxChampSetAsideItems()}
                              sealedContents={this.getBoxChampSealedContents()}
                              positionLabel={this.getBoxChampSealPosition()}
                            />
                            <BoxChampOptionsSheet
                              visible={this.state.boxChampOptionsBoxId !== null}
                              options={this.getBoxChampOptions()}
                              catalog={this.state.boxChampCatalog}
                              serverError={this.state.boxChampAddBoxError}
                              catalogError={this.state.boxChampCatalogError}
                              onRetryCatalog={this.retryBoxChampCatalog}
                              onSubstitute={this.handleBoxChampSubstitute}
                              onCombine={this.handleBoxChampCombine}
                              onSplit={this.handleBoxChampSplit}
                              onAddBox={this.handleBoxChampAddBox}
                              onClose={this.closeBoxChampOptions}
                            />
                            {this.props?.bothSettings?.data?.data?.general_setting?.is_box_champ && (
                              <BoxChampDimsForm
                                testID="boxchamp-dims-form"
                                items={getItemsNeedingDims(this.state.order?.order?.unscanned_items)}
                                weightUnit={
                                  this.props?.bothSettings?.data?.data?.general_setting
                                    ?.product_weight_format
                                }
                                weightRequired={
                                  this.props?.bothSettings?.data?.data?.general_setting
                                    ?.box_champ_weight_check_enabled !== false &&
                                  Number(
                                    this.props?.bothSettings?.data?.data?.general_setting
                                      ?.box_champ_default_weight || 0,
                                  ) <= 0
                                }
                                onModalToggle={open =>
                                  this.setState({boxChampDimsModalOpen: open})
                                }
                                onSaveAll={this.handleBoxChampDimsSaveAll}
                              />
                            )}
                            </View>
                            {Platform.OS === 'web' ? (
                              <View style={{flex: 1}}>
                                {this.state.windowWidth >= 900 ? (
                                  <View style={{flex: 1, flexDirection: 'row'}}>
                                    <View
                                      style={{
                                        flex: 2,
                                        backgroundColor: '#4A6179'
                                      }}>
                                      <UnscannedItems
                                        {...this.props}
                                        order={this.state.order}
                                        notFullFilledItems={this.state.notFullFilledItems}
                                        openBoxChampOptions={
                                          this.boxChampPaused() ? undefined : this.openBoxChampOptions
                                        }
                                        currentFocus={() => this.currentFocus()}
                                        clickScan={e => this.clickScan(e)}
                                        scanPackSetting={
                                          this.state.scan_pack_settings
                                        }
                                        generalSetting={
                                          this.state.general_settings
                                        }
                                        redirectToItemDetail={e =>
                                          this.redirectToItemDetail(e)
                                        }
                                        unscannedItemPerPage={
                                          this.state.unscannedItemPerPage
                                        }
                                        shuffleTheItem={(
                                          itemSKU,
                                          childItemSKU
                                        ) =>
                                          this.changeTheSuggestedItem(
                                            itemSKU,
                                            childItemSKU
                                          )
                                        }
                                        InputField={this.InputField}
                                        scannedList={this.state.scannedList}
                                        unscannedList={this.state.unscannedList}
                                        logList={this.state.logList}
                                        showUnscannedList={() =>
                                          this.showUnscannedList()
                                        }
                                        showScannedList={() =>
                                          this.showScannedList()
                                        }
                                        showLogList={() => this.showLogList()}
                                        localLogs={this.state.localLogs}
                                        userData={this.state.userData}
                                        typeScanState={this.state.typeScanState}
                                        setType={this.setType}
                                        checkCount={this.checkCount}
                                        popInternet={this.state.popInternet}
                                        isBarcodeEnter={
                                          this.state.isBarcodeEnter
                                        }
                                        setIsBarcodeEnter={() => {
                                          this.setState({
                                            isBarcodeEnter: false
                                          });
                                        }}
                                      />
                                    </View>
                                    <View style={{flex: 4}}>
                                      {this.state.loadOrderSpinner ? (
                                        <View style={{marginTop: 100}}>
                                          <ActivityIndicator
                                            size="large"
                                            color="#000"
                                          />
                                          <View>
                                            <Text style={{textAlign: 'center'}}>
                                              Fetch more item to scan...
                                            </Text>
                                          </View>
                                        </View>
                                      ) : (
                                        <NextItems
                                        notFullFilledItems={this.state.notFullFilledItems}
                                        boxChampSealConfirmedBoxIds={this.state.boxChampSealConfirmedBoxIds}
                                        boxChampPendingConfirmationBoxId={this.boxChampPendingConfirmationBoxId()}
                                          {...this.props}
                                          boxChampBannerHeight={this.state.boxChampBannerHeight}
                                          openBoxChampOptions={
                                          this.boxChampPaused() ? undefined : this.openBoxChampOptions
                                        }
                                          offlineMessageRef={this.offlineMessageRef}
                                          verifiedBoxIds={this.state.verifiedBoxIds}
                                          // changes for multibox.
                                          normalFun={this.normalFun}
                                          goPrev={() => this.goPrev()}
                                          activeBoxIndex={
                                            this.state.activeBoxIndex
                                          }
                                          multiBoxStateUpdate={() =>
                                            this.multiBoxStateUpdate()
                                          }
                                          order={this.state.order}
                                          currentFocus={() =>
                                            this.currentFocus()
                                          }
                                          barcodeRef={this.barcode}
                                          access_token={this.state.token}
                                          barcodeState={this.state.bar_code}
                                          removeFocus={() => this.removeFocus()}
                                          width={this.state.windowWidth}
                                          serialRecordPopUpShow={
                                            this.state.serialRecordPopUpShow
                                          }
                                          clickScan={(
                                            e,
                                            actionsBarcode,
                                            isShiftKey
                                          ) => {
                                            this.clickScan(
                                              e,
                                              actionsBarcode,
                                              isShiftKey
                                            );
                                          }}
                                          // clickScan={this.serialRecordCheck.bind(this , "clickscan")}
                                          scanAllItem={e =>{
                                            this.scanAllItem(e)
                                          }}
                                          // scanAllItem={this.serialRecordCheck.bind(this , "scan_all_item")}
                                          scanBarcode={e =>{
                                            this.scanBarcode(e)
                                          }}
                                          // scanBarcode={this.serialRecordCheck.bind(this , "barcode")}
                                          stateUpdate={text =>
                                            this.setState({bar_code: text})
                                          }
                                          shuffleTheItem={(
                                            itemSKU,
                                            childItemSKU
                                          ) =>
                                            this.changeTheSuggestedItem(
                                              itemSKU,
                                              childItemSKU
                                            )
                                          }
                                          scanPackSetting={
                                            this.state.scan_pack_settings
                                          }
                                          generalSetting={
                                            this.state.general_settings
                                          }
                                          activities={
                                            props &&
                                            props.Order &&
                                            props.Order.activities
                                          }
                                          localLogs={this.state.localLogs}
                                          restartButton={() =>
                                            this.handleRestartPrompt()
                                          }
                                          redirectToItemDetail={e =>
                                            this.redirectToItemDetail(e)
                                          }
                                          addNote={() => this.addNote()}
                                          saveChanges={() => this.saveChanges()}
                                          leaveComponent={(order, type) =>
                                            this.leaveComponent(order, type)
                                          }
                                          loadOrderSpinner={
                                            this.state.loadOrderSpinner
                                          }
                                          unscannedItemPerPage={
                                            this.state.unscannedItemPerPage
                                          }
                                          scannedItemPerPage={
                                            this.state.scannedItemPerPage
                                          }
                                          InputField={this.InputField}
                                          scannedList={this.state.scannedList}
                                          unscannedList={
                                            this.state.unscannedList
                                          }
                                          logList={this.state.logList}
                                          showScannedList={() =>
                                            this.showScannedList()
                                          }
                                          showUnscannedList={() =>
                                            this.showUnscannedList()
                                          }
                                          showLogList={() => this.showLogList()}
                                          addBarcode={e => this.addBarcode(e)}
                                          notesToPackerFlag={
                                            this.state.notes_toPackerFlag
                                          }
                                          tagsToPackerFlag={
                                            this.state.tags_toPackerFlag
                                          }
                                          closeNotes={() => this.closeNotes()}
                                          settings={settings}
                                          customerCommentsFlag={
                                            this.state.customer_commentsFlag
                                          }
                                          internalNotesFlag={
                                            this.state.notes_internalFlag
                                          }
                                          showNotesFun={() =>
                                            this.showNotesFun()
                                          }
                                          userData={this.state.userData}
                                          getOrderData={this.getUpdatededOrder}
                                          duplicateShipStationOrder={data =>
                                            this.duplicateShipStationOrder(data)
                                          }
                                          typeScanCount={
                                            this.state.typeScanCount
                                          }
                                          submitTypeScan={this.submitTypeScan.bind(
                                            this
                                          )}
                                          typeScanState={
                                            this.state.typeScanState
                                          }
                                          setType={this.setType}
                                          checkCount={this.checkCount}
                                          isBarcodeEnter={
                                            this.state.isBarcodeEnter
                                          }
                                          setIsBarcodeEnter={() => {
                                            this.setState({
                                              isBarcodeEnter: false
                                            });
                                          }}
                                        />
                                      )}
                                    </View>
                                    <View
                                      style={{
                                        flex: 2,
                                        zIndex: -1,
                                        backgroundColor: '#4A6179'
                                      }}>
                                      <ScannedItems
                                        boxChampSealConfirmedBoxIds={this.state.boxChampSealConfirmedBoxIds}
                                        boxChampPendingConfirmationBoxId={this.boxChampPendingConfirmationBoxId()}
                                        {...this.props}
                                        isConnected={this.state.isConnected}
                                        updateOrder={id =>
                                          this.getUpdatededOrder(id)
                                        }
                                        activeBoxIndex={
                                          this.state.activeBoxIndex
                                        }
                                        multiBoxStateUpdate={(emptyBoxPrint) =>
                                          this.multiBoxStateUpdate(emptyBoxPrint)
                                        }
                                        onCloseAlertMultiBox={() =>
                                          this.onCloseAlertMultiBox()
                                        }
                                        showAlert={message => this.showAlert(message)}
                                        printSlipFun={() => this.printSlipFun()}
                                        goPrev={() => this.goPrev()}
                                        goNext={() => this.goNext()}
                                        order={this.state.order}
                                        scanPackSetting={
                                          this.state.scan_pack_settings
                                        }
                                        generalSetting={
                                          this.state.general_settings
                                        }
                                        scannedItemPerPage={
                                          this.state.scannedItemPerPage
                                        }
                                        userData={this.state.userData}
                                        redirectToItemDetail={e =>
                                          this.redirectToItemDetail(e)
                                        }
                                      />
                                    </View>
                                  </View>
                                ) : (
                                  <View
                                    style={{
                                      flex: 1,
                                      backgroundColor: '#292929'
                                    }}>
                                    {this.props.isListMode && (
                                      <UnscannedItems
                                        {...this.props}
                                        orderUpdate={id =>
                                          this.getUpdatededOrder(id)
                                        }
                                        updatedData={
                                          this.props.route.params.data
                                        }
                                        order={this.state.order}
                                        notFullFilledItems={this.state.notFullFilledItems}
                                        openBoxChampOptions={
                                          this.boxChampPaused() ? undefined : this.openBoxChampOptions
                                        }
                                        currentFocus={() => this.currentFocus()}
                                        barcodeRef={this.barcode}
                                        access_token={this.state.token}
                                        barcodeState={this.state.bar_code}
                                        removeFocus={e => this.removeFocus(e)}
                                        redirectToItemDetail={e =>
                                          this.redirectToItemDetail(e)
                                        }
                                        clickScan={e => this.clickScan(e)}
                                        // clickScan={this.serialRecordCheck.bind(this , "clickscan")}
                                        scanAllItem={e => this.scanAllItem(e)}
                                        // scanAllItem={this.serialRecordCheck.bind(this , "scan_all_item")}
                                        scanBarcode={e => {
                                          this.scanBarcode(e)
                                        }}
                                        // scanBarcode={this.serialRecordCheck.bind(this , "barcode")}
                                        shuffleTheItem={(
                                          itemSKU,
                                          childItemSKU
                                        ) =>
                                          this.changeTheSuggestedItem(
                                            itemSKU,
                                            childItemSKU
                                          )
                                        }
                                        stateUpdate={text =>
                                          this.setState({bar_code: text})
                                        }
                                        scanPackSetting={
                                          this.state.scan_pack_settings
                                        }
                                        generalSetting={
                                          this.state.general_settings
                                        }
                                        activities={
                                          props &&
                                          props.Order &&
                                          props.Order.activities
                                        }
                                        localLogs={this.state.localLogs}
                                        restartButton={() =>
                                          this.handleRestartPrompt()
                                        }
                                        addNote={() => this.addNote()}
                                        saveChanges={() => this.saveChanges()}
                                        navButton={() => this.navButton()}
                                        leaveComponent={(order, type) =>
                                          this.leaveComponent(order, type)
                                        }
                                        unscannedItemPerPage={
                                          this.state.unscannedItemPerPage
                                        }
                                        InputField={this.InputField}
                                        scannedList={this.state.scannedList}
                                        unscannedList={this.state.unscannedList}
                                        logList={this.state.logList}
                                        showUnscannedList={() =>
                                          this.showUnscannedList()
                                        }
                                        showScannedList={() =>
                                          this.showScannedList()
                                        }
                                        getOrderData={this.getUpdatededOrder}
                                        showLogList={() => this.showLogList()}
                                        userData={this.state.userData}
                                        typeScanState={this.state.typeScanState}
                                        setType={this.setType}
                                        checkCount={this.checkCount}
                                        popInternet={this.state.popInternet}
                                        isBarcodeEnter={
                                          this.state.isBarcodeEnter
                                        }
                                        setIsBarcodeEnter={() => {
                                          this.setState({
                                            isBarcodeEnter: false
                                          });
                                        }}
                                      />
                                    )}

                                    {this.state.loadOrderSpinner ? (
                                      <View style={{marginTop: 100}}>
                                        <ActivityIndicator
                                          size="large"
                                          color="#000"
                                        />
                                        <View>
                                          <Text style={{textAlign: 'center'}}>
                                            Fetch more item to scan...
                                          </Text>
                                        </View>
                                      </View>
                                    ) : (
                                      <>
                                        {!this.props.isListMode &&
                                          this.state.scannedItemShow ===
                                            false && (
                                            <NextItems
                                        notFullFilledItems={this.state.notFullFilledItems}
                                        boxChampSealConfirmedBoxIds={this.state.boxChampSealConfirmedBoxIds}
                                        boxChampPendingConfirmationBoxId={this.boxChampPendingConfirmationBoxId()}
                                              {...this.props}
                                              boxChampBannerHeight={this.state.boxChampBannerHeight}
                                          openBoxChampOptions={
                                          this.boxChampPaused() ? undefined : this.openBoxChampOptions
                                        }
                                              offlineMessageRef={this.offlineMessageRef}
                                              verifiedBoxIds={this.state.verifiedBoxIds}
                                              normalFun={this.normalFun}
                                              updateOrder={id => {
                                                this.getUpdatededOrder(id);
                                              }}
                                              multiBoxStateUpdate={(emptyBoxPrint) =>
                                                this.multiBoxStateUpdate(emptyBoxPrint)
                                              }
                                              printSlipFun={() => this.printSlipFun()}
                                              goNext={() => this.goNext()}
                                              goPrev={() => this.goPrev()}
                                              activeBoxIndex={
                                                this.state.activeBoxIndex
                                              }
                                              order={this.state.order}
                                              currentFocus={() =>
                                                this.currentFocus()
                                              }
                                              width={this.props.windowWidth}
                                              barcodeRef={this.barcode}
                                              serialRecordPopUpShow={
                                                this.state.serialRecordPopUpShow
                                              }
                                              access_token={this.state.token}
                                              barcodeState={this.state.bar_code}
                                              removeFocus={e =>
                                                this.removeFocus(e)
                                              }
                                              isClicked={this.state.isClicked}
                                              redirectToItemDetail={e =>
                                                this.redirectToItemDetail(e)
                                              }
                                              clickScan={e => this.clickScan(e)}
                                              // clickScan={this.serialRecordCheck.bind(this , "clickscan")}
                                              scanAllItem={e =>
                                                this.scanAllItem(e)
                                              }
                                              // scanAllItem={this.serialRecordCheck.bind(this , "scan_all_item")}
                                              scanBarcode={e =>{
                                                this.scanBarcode(e)
                                              }
                                              }
                                              // scanBarcode={this.serialRecordCheck.bind(this , "barcode")}
                                              stateUpdate={text =>
                                                (barCodeInput = text)
                                              }
                                              shuffleTheItem={(
                                                itemSKU,
                                                childItemSKU
                                              ) =>
                                                this.changeTheSuggestedItem(
                                                  itemSKU,
                                                  childItemSKU
                                                )
                                              }
                                              scanPackSetting={
                                                this.state.scan_pack_settings
                                              }
                                              generalSetting={
                                                this.state.general_settings
                                              }
                                              activities={
                                                props &&
                                                props.Order &&
                                                props.Order.activities
                                              }
                                              localLogs={this.state.localLogs}
                                              restartButton={() =>
                                                this.handleRestartPrompt()
                                              }
                                              addNote={() => this.addNote()}
                                              saveChanges={() =>
                                                this.saveChanges()
                                              }
                                              navButtonLeft={() =>
                                                this.navButtonLeft()
                                              }
                                              navButtonRight={() => {
                                                this.setState({
                                                  unscannedItemShow: false,
                                                  nextItemShow: false,
                                                  scannedItemShow: true
                                                });
                                              }}
                                              leaveComponent={(order, type) =>
                                                this.leaveComponent(order, type)
                                              }
                                              loadOrderSpinner={
                                                this.state.loadOrderSpinner
                                              }
                                              unscannedItemPerPage={
                                                this.state.unscannedItemPerPage
                                              }
                                              scannedItemPerPage={
                                                this.state.scannedItemPerPage
                                              }
                                              InputField={this.InputField}
                                              scannedList={
                                                this.state.scannedList
                                              }
                                              unscannedList={
                                                this.state.unscannedList
                                              }
                                              logList={this.state.logList}
                                              showScannedList={() =>
                                                this.showScannedList()
                                              }
                                              showUnscannedList={() =>
                                                this.showUnscannedList()
                                              }
                                              showLogList={() =>
                                                this.showLogList()
                                              }
                                              addBarcode={e =>
                                                this.addBarcode(e)
                                              }
                                              notesToPackerFlag={
                                                this.state.notes_toPackerFlag
                                              }
                                              tagsToPackerFlag={
                                                this.state.tags_toPackerFlag
                                              }
                                              closeNotes={() =>
                                                this.closeNotes()
                                              }
                                              settings={settings}
                                              customerCommentsFlag={
                                                this.state.customer_commentsFlag
                                              }
                                              internalNotesFlag={
                                                this.state.notes_internalFlag
                                              }
                                              showNotesFun={() =>
                                                this.showNotesFun()
                                              }
                                              userData={this.state.userData}
                                              getOrderData={
                                                this.getUpdatededOrder
                                              }
                                              duplicateShipStationOrder={data =>
                                                this.duplicateShipStationOrder(
                                                  data
                                                )
                                              }
                                              typeScanCount={
                                                this.state.typeScanCount
                                              }
                                              submitTypeScan={this.submitTypeScan.bind(
                                                this
                                              )}
                                              typeScanState={
                                                this.state.typeScanState
                                              }
                                              setType={this.setType}
                                              checkCount={this.checkCount}
                                              isBarcodeEnter={
                                                this.state.isBarcodeEnter
                                              }
                                              setIsBarcodeEnter={() => {
                                                this.setState({
                                                  isBarcodeEnter: false
                                                });
                                              }}
                                              notFullFilledItems={this.state.notFullFilledItems}
                                        openBoxChampOptions={
                                          this.boxChampPaused() ? undefined : this.openBoxChampOptions
                                        }
                                            />
                                          )}
                                      </>
                                    )}
                                    {this.state.nextItemShow === false &&
                                      this.state.scannedItemShow === true && (
                                        <ScannedItems
                                        boxChampSealConfirmedBoxIds={this.state.boxChampSealConfirmedBoxIds}
                                        boxChampPendingConfirmationBoxId={this.boxChampPendingConfirmationBoxId()}
                                          {...this.props}
                                          isConnected={this.state.isConnected}
                                          updateOrder={id =>
                                            this.getUpdatededOrder(id)
                                          }
                                          activeBoxIndex={
                                            this.state.activeBoxIndex
                                          }
                                          printSlipFun={() => this.printSlipFun()}
                                          showAlert={message => this.showAlert(message)}
                                          // multiBoxStateUpdate={()=>this.multiBoxStateUpdate()}
                                          // onCloseAlertMultiBox={()=>this.onCloseAlertMultiBox()}
                                          // goPrev={() => this.goPrev()}
                                          // goNext={() => this.goNext()}
                                          order={this.state.order}
                                          scanPackSetting={
                                            this.state.scan_pack_settings
                                          }
                                          generalSetting={
                                            this.state.general_settings
                                          }
                                          navButton={() => {
                                            this.setState({
                                              unscannedItemShow: false,
                                              nextItemShow: true,
                                              scannedItemShow: false
                                            });
                                          }}
                                          scannedItemPerPage={
                                            this.state.scannedItemPerPage
                                          }
                                          userData={this.state.userData}
                                          redirectToItemDetail={e =>
                                            this.redirectToItemDetail(e)
                                          }
                                        />
                                      )}
                                  </View>
                                )}
                              </View>
                            ) : (
                              <>
                                <View
                                  style={{
                                    flex: 1,
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                  }}>
                                  <UnscannedItems
                                    {...this.props}
                                    orderUpdate={id =>
                                      this.getUpdatededOrder(id)
                                    }
                                    updatedData={this.props.route.params.data}
                                    order={this.state.order}
                                    notFullFilledItems={this.state.notFullFilledItems}
                                        openBoxChampOptions={
                                          this.boxChampPaused() ? undefined : this.openBoxChampOptions
                                        }
                                    currentFocus={() => this.currentFocus()}
                                    barcodeRef={this.barcode}
                                    barcodeState={this.state.bar_code}
                                    clickScan={e => this.clickScan(e)}
                                    scanAllItem={e => this.scanAllItem(e)}
                                    scanBarcode={e => {
                                      this.scanBarcode(e)
                                    }}
                                    stateUpdate={text => {
                                      barCodeInput = text;
                                    }}
                                    leaveComponent={(order, type) =>
                                      this.leaveComponent(order, type)
                                    }
                                    scanPackSetting={
                                      this.state.scan_pack_settings
                                    }
                                    generalSetting={this.state.general_settings}
                                    redirectToItemDetail={e =>
                                      this.redirectToItemDetail(e)
                                    }
                                    restartButton={() =>
                                      this.handleRestartPrompt()
                                    }
                                    addNote={() => this.addNote()}
                                    saveChanges={() => this.saveChanges()}
                                    unscannedItemPerPage={
                                      this.state.unscannedItemPerPage
                                    }
                                    InputField={this.InputField}
                                    scannedList={this.state.scannedList}
                                    unscannedList={this.state.unscannedList}
                                    logList={this.state.logList}
                                    showUnscannedList={() =>
                                      this.showUnscannedList()
                                    }
                                    showScannedList={() =>
                                      this.showScannedList()
                                    }
                                    shuffleTheItem={(itemSKU, childItemSKU) =>
                                      this.changeTheSuggestedItem(
                                        itemSKU,
                                        childItemSKU
                                      )
                                    }
                                    showLogList={() => this.showLogList()}
                                    localLogs={this.state.localLogs}
                                    userData={this.state.userData}
                                  />
                                </View>
                                <View
                                  style={{
                                    flex: 1,
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                  }}>
                                  <NextItems
                                        notFullFilledItems={this.state.notFullFilledItems}
                                        boxChampSealConfirmedBoxIds={this.state.boxChampSealConfirmedBoxIds}
                                        boxChampPendingConfirmationBoxId={this.boxChampPendingConfirmationBoxId()}
                                    {...this.props}
                                    offlineMessageRef={this.offlineMessageRef}
                                    verifiedBoxIds={this.state.verifiedBoxIds}
                                    activeBoxIndex={this.state.activeBoxIndex}
                                    normalFun={this.normalFun}
                                    order={this.state.order}
                                    currentFocus={() => this.currentFocus()}
                                    barcodeRef={this.barcode}
                                    access_token={this.state.token}
                                    width={this.state.windowWidth}
                                    barcodeState={this.state.bar_code}
                                    clickScan={e => this.clickScan(e)}
                                    removeFocus={e => this.removeFocus(e)}
                                    scanAllItem={e => this.scanAllItem(e)}
                                    scanBarcode={e => {
                                      this.scanBarcode(e)
                                    }}
                                    stateUpdate={text => {
                                      barCodeInput = text;
                                    }}
                                    scanPackSetting={
                                      this.state.scan_pack_settings
                                    }
                                    generalSetting={this.state.general_settings}
                                    activities={
                                      props &&
                                      props.Order &&
                                      props.Order.activities
                                    }
                                    localLogs={this.state.localLogs}
                                    restartButton={() =>
                                      this.handleRestartPrompt()
                                    }
                                    addNote={() => this.addNote()}
                                    serialRecordPopUpShow={
                                      this.state.serialRecordPopUpShow
                                    }
                                    saveChanges={() => this.saveChanges()}
                                    leaveComponent={(order, type) =>
                                      this.leaveComponent(order, type)
                                    }
                                    redirectToItemDetail={e =>
                                      this.redirectToItemDetail(e)
                                    }
                                    shuffleTheItem={(itemSKU, childItemSKU) =>
                                      this.changeTheSuggestedItem(
                                        itemSKU,
                                        childItemSKU
                                      )
                                    }
                                    loadOrderSpinner={
                                      this.state.loadOrderSpinner
                                    }
                                    unscannedItemPerPage={
                                      this.state.unscannedItemPerPage
                                    }
                                    scannedItemPerPage={
                                      this.state.scannedItemPerPage
                                    }
                                    InputField={this.InputField}
                                    scannedList={this.state.scannedList}
                                    unscannedList={this.state.unscannedList}
                                    logList={this.state.logList}
                                    showScannedList={() =>
                                      this.showScannedList()
                                    }
                                    showUnscannedList={() =>
                                      this.showUnscannedList()
                                    }
                                    showLogList={() => this.showLogList()}
                                    addBarcode={e => this.addBarcode(e)}
                                    showNotesFun={() => this.showNotesFun()}
                                    userData={this.state.userData}
                                    getOrderData={this.getUpdatededOrder}
                                    duplicateShipStationOrder={data =>
                                      this.duplicateShipStationOrder(data)
                                    }
                                  />
                                </View>
                                <View
                                  style={{
                                    flex: 1,
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                  }}>
                                  <ScannedItems
                                        boxChampSealConfirmedBoxIds={this.state.boxChampSealConfirmedBoxIds}
                                        boxChampPendingConfirmationBoxId={this.boxChampPendingConfirmationBoxId()}
                                    {...this.props}
                                    isConnected={this.state.isConnected}
                                    updateOrder={id =>
                                      this.getUpdatededOrder(id)
                                    }
                                    // activeBoxIndex={this.state.activeBoxIndex}
                                    // goPrev={() => this.goPrev()}
                                    // goNext={() => this.goNext()}
                                    order={this.state.order}
                                    scanPackSetting={
                                      this.state.scan_pack_settings
                                    }
                                    generalSetting={this.state.general_settings}
                                    showAlert={message => this.showAlert(message)}
                                    redirectToItemDetail={e =>
                                      this.redirectToItemDetail(e)
                                    }
                                    scannedItemPerPage={
                                      this.state.scannedItemPerPage
                                    }
                                    userData={this.state.userData}
                                  />
                                </View>
                              </>
                            )}
                          </View>
                        </Hotkeys>
                      )}
                  </React.Fragment>
                )}

                {/* Escalated copy of the set-aside notice.

                    The in-flow notice further down is stacked underneath the very pop-ups
                    the mirrored rejection exists to survive — see BoxChampEscalatedNotice
                    for the measurement and the reasoning. This one is portalled above
                    them. It renders only while a pop-up is up; with no pop-up the in-flow
                    notice is on top already and is the one the packer reads.

                    The in-flow notice stays mounted and unchanged: its height feeds the
                    onLayout measurement that positions the mobile view, and suppressing it
                    here would make the layout jump behind the pop-up.

                    It is NOT invisible while covered, but how visible depends on which pop-up.
                    boxChampModalOpen() (scanpack_item.js:681, modalSuppressesHandoffCard)
                    gates on 14 conditions (boxChampModalFlags.js), not 12: the 12
                    SHARED_MODAL_STATE_FLAGS, plus errorMessageClickScanConfirmation
                    (CARD_SUPPRESSING_ONLY_STATE_FLAGS), plus isBugOrSupportPopup
                    (SHARED_MODAL_PROP_FLAGS, mapped at scanpack_item.js:8403).

                    9 of the 12 draw a scrim: 8 — serialRecordPopUpShow,
                    typeScanAlert, alert, serviceIssuePrompt, productConfirmationCheck,
                    addItemToOrder, openRestartPrompt, orderConfirmPopUp — render over
                    responseView (src/style/scanpack.js:692), and boxChampDimsModalOpen
                    renders over the BoxChampDimsForm modal's own overlay
                    (src/style/boxChampCalculateModal.js:4, consumed at
                    BoxChampDimsForm.js:236-241), rgba(0,0,0,0.6). isBugOrSupportPopup adds a
                    10th scrimmed case outside the 12: it backs the drawer's bug-report /
                    feedback pop-up (set by reportBug()/setFeedback(), drawer.js:264-272,
                    dispatching setBugOrSupportPopUP()), which is wrapped in this same
                    scanpack.js's own alertContainer (:367, imported as stylesAlert at
                    drawer.js:16, consumed at drawer.js:344) — also rgba(14,14,14,0.7).
                    Through any of these ten the packer sees a dimmed second copy of the
                    notice (roughly 2:1 contrast) alongside the crisp portalled one on top.

                    The remaining 4 draw no scrim, so there the duplicate is fully bright,
                    not dimmed: clickScanConfirmation and addBarcodeWindow render over
                    typeScanContainer (src/style/scanpack.js:811), whose backgroundColor is
                    commented out at :816; errorMessageClickScanConfirmation renders in that
                    same ClickScanConfirmationPopUp / typeScanContainer, since it is only
                    ever set true while clickScanConfirmation is already true
                    (scanpack_item.js:5979-5982) — same no-scrim case, different flag; and
                    popUpModelShow renders over alertContainer or alerBoxPopup
                    (src/style/popupmodel.js:4 / :22, switched on windowWidth >= 900 in
                    pop_up_model.js:26), neither of which declares a background.
                    (src/style/scanpack.js also defines a typeRecordContainer (:840, no
                    consumers repo-wide) and an activityContainer (:884, used only by the
                    scanpack loading spinner, state.loader, scanpack_item.js:7041) at this
                    same rgba(14,14,14,0.7) — neither backs any of these 14 pop-ups, so don't
                    mistake them for scrims on this notice; alertContainer (:367), unlike
                    those two, IS a real scrim here via isBugOrSupportPopup above.)

                    Either way, that duplicate is accepted and deliberate, not a bug:
                    unmounting the in-flow copy instead of leaving it dimmed or fully visible
                    would drop the onLayout measurement above and make the mobile view's
                    layout jump the moment a pop-up opens. Two tests
                    (scanPackItemGuided.spec.js:307, :409) go red if it is merely hidden
                    while a pop-up is open; eight tests total in that file (adding :337,
                    :496, :517, :1037, :1243, :1510) go red if it is
                    unmounted outright. Do not "fix" this by hiding or
                    unmounting it. */}
                {this.boxChampModalOpen() && (
                  <BoxChampEscalatedNotice
                    message={this.state.boxChampSetAsideMessage}
                    tone={
                      this.state.boxChampSetAsideConfirmation ? 'info' : 'warning'
                    }
                    onDismiss={() => {
                      clearTimeout(this._boxChampConfirmationTimer);
                      this.setState({
                        boxChampSetAsideMessage: '',
                        boxChampSetAsideConfirmation: false
                      });
                    }}
                  />
                )}
              </View>
            )}
          </React.Fragment>
        }
      </View>
    );
  }
}

const mapStateToProps = state => {
  return {
    reprintstate: state.order.reprintstate,
    ssLabelData: state.order.ssLabelData,
    Order: state.order.order,
    ordersList: state.order.list,
    getShipment: state.order.getShipment,
    bothSettings: state.user.bothSettings,
    isBugOrSupportPopup: state.user.isBugOrSupportPopup,
    addOrderItems: state.order.addOrderItems,
    searchOrder: state.scanpack,
    saveData: state.updateAsync.retriveData,
    updateLog: state.saveLog,
    callOrder: state.scanpack.searchOrder,
    product: state.product.product,
    updateProduct: state.product.updateProductList,
    isListMode: state.menu.isListMode,
    updateAlias: state.product.updateProductAlias,
    statusMulti: state.saveLog,
    offlineMessage : state.saveLog,
    LoaderDetail: state.orderLoader,
    isHaptics: state.menu.isHaptics,
    showCartAssignmentToast: state.scanToCart.showCartAssignmentToast
  };
};

const mapDispatchToProps = {
  GetOrderDetail,
  CalculateBoxChampBoxes,
  fetchLabelData,
  emailCustomer,
  LoaderShow,
  ClearSearchProduct,
  GetOrderList,
  AddOrderItems,
  GetBothSettings,
  GetBoxChampSortPreference,
  SaveBoxChampSortPreference,
  SearchScanpackOrder,
  Getshipment,
  FullOrderScan,
  UpdateOrderStatus,
  GetItem,
  SetItem,
  SubmitLog,
  SearchOrder,
  GetProductDetail,
  updateProductList,
  CheckIsListMode,
  ShowNotification,
  updateProductAlias,
  MultiBoxSaveLog,
  AddBox,
  PrintSlip,
  fetchUser,
  saveLogReducer,
  updateOfflineOrder,
  handleItemOutOfStock,
  UpdateProductInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(ScanPackItem);
